var A_CAL_DAYS = ['', 'Enum.Days.MO', 'Enum.Days.TU', 'Enum.Days.WE', 'Enum.Days.TH', 'Enum.Days.FR', 'Enum.Days.SA', 'Enum.Days.SU'];
var A_CAL_MONTHS = ['', 'months.January', 'months.February', 'months.March', 'months.April', 'months.May', 'months.June', 'months.july', 'months.August', 'months.September', 'months.October', 'months.november', 'months.december'];
var O_CAL_FIELD = false;
var O_CAL_FIELD_FROM = false;
var O_CAL_FIELD_TO = false;
var O_DATE_SELECT = false;
var V_CAL_SHOW = 2;
//var A_CLIENT_WINDOW = XLClientWindow();
var A_CLIENT_WINDOW = false;
var A_POPS = new Array();
var O_POP_FON = false;
var O_TARGET = false;
var O_AUTOC_LI = false;
var O_POP_TARGET = false;
var V_CS_AIRPORTS = false;
var V_CS_CITIES = false;
var V_CS_AIRPORTSORI = false;
var V_CS_CITIESORI = false;
var currentDateSelect = null;

// Render svg for IE
!function (a, b) { "function" == typeof define && define.amd ? define([], function () { return a.svg4everybody = b() }) : "object" == typeof module && module.exports ? module.exports = b() : a.svg4everybody = b() }(this, function () { function a(a, b, c) { if (c) { var d = document.createDocumentFragment(), e = !b.hasAttribute("viewBox") && c.getAttribute("viewBox"); e && b.setAttribute("viewBox", e); for (var f = c.cloneNode(!0); f.childNodes.length;)d.appendChild(f.firstChild); a.appendChild(d) } } function b(b) { b.onreadystatechange = function () { if (4 === b.readyState) { var c = b._cachedDocument; c || (c = b._cachedDocument = document.implementation.createHTMLDocument(""), c.body.innerHTML = b.responseText, b._cachedTarget = {}), b._embeds.splice(0).map(function (d) { var e = b._cachedTarget[d.id]; e || (e = b._cachedTarget[d.id] = c.getElementById(d.id)), a(d.parent, d.svg, e) }) } }, b.onreadystatechange() } function c(c) { function e() { for (var c = 0; c < o.length;) { var h = o[c], i = h.parentNode, j = d(i), k = h.getAttribute("xlink:href") || h.getAttribute("href"); if (!k && g.attributeName && (k = h.getAttribute(g.attributeName)), j && k) { if (f) if (!g.validate || g.validate(k, j, h)) { i.removeChild(h); var l = k.split("#"), q = l.shift(), r = l.join("#"); if (q.length) { var s = m[q]; s || (s = m[q] = new XMLHttpRequest, s.open("GET", q), s.send(), s._embeds = []), s._embeds.push({ parent: i, svg: j, id: r }), b(s) } else a(i, j, document.getElementById(r)) } else ++c, ++p } else ++c } (!o.length || o.length - p > 0) && n(e, 67) } var f, g = Object(c), h = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, i = /\bAppleWebKit\/(\d+)\b/, j = /\bEdge\/12\.(\d+)\b/, k = /\bEdge\/.(\d+)\b/, l = window.top !== window.self; f = "polyfill" in g ? g.polyfill : h.test(navigator.userAgent) || (navigator.userAgent.match(j) || [])[1] < 10547 || (navigator.userAgent.match(i) || [])[1] < 537 || k.test(navigator.userAgent) && l; var m = {}, n = window.requestAnimationFrame || setTimeout, o = document.getElementsByTagName("use"), p = 0; f && e() } function d(a) { for (var b = a; "svg" !== b.nodeName.toLowerCase() && (b = b.parentNode);); return b } return c });
svg4everybody();


function getT(key) {
    if (!key || typeof (key) == 'undefined') return "";
    var res = i18next.t(key.toLowerCase());
    return res;
}
//window.addEventListener("load", XLClientWindow, false);

window.addEventListener("resize", function () { A_CLIENT_WINDOW = XLClientWindow(); }, true);
window.addEventListener("load", function () {
    if (window.hasRightsForDirectFlights === undefined) {
        var hasDisplayRightsParams = {
            clientId: window.site.clientId,
        };
        window.Typescript.DirectFlight.Services.DirectFlightService.hasDisplayRights(hasDisplayRightsParams).then(function (axiosResponse) {
            try {
                window.hasRightsForDirectFlights = JSON.parse(axiosResponse.data);
            }
            catch (ex) {
                console.log("error window.hasRightsForDirectFlights", ex);
                window.hasRightsForDirectFlights = false;
            }
        });
    };
    A_CLIENT_WINDOW = XLClientWindow();
    if (window.autocompleteCache == null) {
        window.autocompleteCache = window.localStorage.getItem("autocomplete");
        if (window.autocompleteCache != null) {
            window.autocompleteCache = JSON.parse(window.autocompleteCache);
        }
    }
}, true);
//window.addEventListener("load", function () { FCook(); }, true);

//////////////////////////////////////////////////////////////////////////////////////

//window.addEventListener("load", XLDebug, false);
function XLDebug() {

    var oBody = document.body;
    var oDebug = document.createElement("div");
    oDebug.id = 'i-debug';
    oDebug.classList.add('c-debug');
    oDebug.innerHTML = '<p>' + XLUCFirst(A_CLIENT_WINDOW['device']) + ' :: ' + XLUserSystem() + ' :: ' + XLUserAgent() + ' :: ' + A_CLIENT_WINDOW['width'] + ' x ' + A_CLIENT_WINDOW['height'] + '</p>';
    oBody.appendChild(oDebug);

}

function hasCookie(name) {
    return document.cookie.indexOf(name + '=') > 1;
}

/////////////////////////////////////////////////////////////////////////////////////
function FUpselTog(iTarget, vWhat) {

    //oUpsel = oTarget.parentNode.parentNode.parentNode ;
    oUpsel = document.getElementById(iTarget);
    if (vWhat == 0) oUpsel.classList.remove('c-upsel-on');
    else if (vWhat == 1) oUpsel.classList.add('c-upsel-on');

}

function FSellitTog(iTarget, vWhat) {
    oSellit = document.getElementById(iTarget);

    if (vWhat === 0) {
        oSellit.classList.remove('c-sellit-on');
        if ($("#" + iTarget + " .c-field").length > 0) {
            $("#" + iTarget + " .c-field").each(function (index, el) { el.classList.remove("c-field-ok"); });
        }
        if ($("#" + iTarget + " .c-new-field-label").length > 0) {
            $("#" + iTarget + " .c-new-field-label").each(function (index, el) { el.classList.remove("c-new-field-ok"); });
        }
        if ($("#" + iTarget + " .c-flip").length > 0) {
            $("#" + iTarget + " .c-flip").each(function (index, el) { el.classList.remove("c-flip-on"); });
        }
    }
    else if (vWhat === 1) {
        oSellit.classList.add('c-sellit-on');
        if ($("#" + iTarget + " .c-field").length > 0) {
            $("#" + iTarget + " .c-field").each(function (index, el) {
                el.classList.add("c-field-ok");
            });
        }
        if ($("#" + iTarget + " .c-new-field-label").length > 0) {
            $("#" + iTarget + " .c-new-field-label").each(function (index, el) {
                el.classList.add("c-new-field-ok");
            });
        }
        if ($("#" + iTarget + " .c-flip").length > 0) {
            $("#" + iTarget + " .c-flip").each(function (index, el) { el.classList.add("c-flip-on"); });
        }
    }
}

function FCountriesFlags(aIn) {

    var oUl = document.getElementById(aIn['iUl']),
        aLi = oUl.parentNode.getElementsByTagName('li'),
        aLiLength = aLi.length;
    for (var i = 0; i < aLiLength; ++i) {
        //var oImg = document.createElement("img") ;
        vDataCountry = aLi[i].getAttribute('data-country');
        //oImg.src = '/images/flags/24/' + vDataCountry.toLowerCase() + '.png' ;
        //aLi[i].appendChild(oImg) ;

        //aLi[i].innerHTML = '<img src="/global/images/flags/32/' + vDataCountry.toLowerCase() + '.png" alt="' + vDataCountry + '">' + aLi[i].innerHTML

        //AGSW Edit to load from static folder
        var imgUrl = getStaticFolder('images/flags/32/' + vDataCountry.toLowerCase() + '.png');
        aLi[i].innerHTML = '<img src="' + imgUrl + '" alt="' + vDataCountry + '" class="align-self-center">' + aLi[i].innerHTML
    }

}

var V_FF_DET = false;

function FFDet(vWich) {

    console.log('FFDet');

    if (V_FF_DET) {
        console.log(V_FF_DET);
        FSmoothOpen({ iSmooth: 'i-smooth-detail-' + V_FF_DET, iToggle: 'i-flight-' + V_FF_DET, vToggleClass: 'c-flight-on-detail' });
    }

    if (V_FF_DET != vWich) {
        FSmoothOpen({ iSmooth: 'i-smooth-detail-' + vWich, iToggle: 'i-flight-' + vWich, vToggleClass: 'c-flight-on-detail' });
        V_FF_DET = vWich;
    } else V_FF_DET = false;

    FStopProp(event);   ///AGSW: Bug fix

}

function FStopProp(event) {
    if (event)  ///AGSW: check first
        event.stopPropagation();
}

function FFDetB(vWich) {

    console.log('FFDetB');

    if (V_FF_DET) {
        console.log(V_FF_DET);
        var detailHeight = $('#i-smooth-detail-' + V_FF_DET).height();
        FSmoothOpen({ iSmooth: 'i-smooth-detail-' + V_FF_DET }, function () {
            var oFlightBackWrapper = $("#i-smooth-back-" + vWich.substr(0, vWich.indexOf('-')) + " .c-flight-back-wrapper");
            if (oFlightBackWrapper.length > 0) oFlightBackWrapper.height(576);
        });
    }

    if (V_FF_DET != vWich) {
        FSmoothOpen({ iSmooth: 'i-smooth-detail-' + vWich }, setTimeout(function () {
            var oFlightBackWrapper = $("#i-smooth-back-" + vWich.substr(0, vWich.indexOf('-')) + " .c-flight-back-wrapper");
            if (oFlightBackWrapper.length > 0) oFlightBackWrapper.height(oFlightBackWrapper.height() + $('#i-smooth-detail-' + vWich).height() + 5);
        }, 250));
        V_FF_DET = vWich;
    } else V_FF_DET = false;

}

function FFBack(vWich) {

    console.log('FFBack');
    FSmoothOpen({ iSmooth: 'i-smooth-back-' + vWich, iToggle: 'i-flight-' + vWich, vToggleClass: 'c-flight-on-back' });

    //if (document.getElementById('i-smooth-detail-' + vWich).className.indexOf('c-smooth-open') != -1) FFDet(vWich) ;
    if (V_FF_DET) {
        console.log(V_FF_DET);
        FSmoothOpen({ iSmooth: 'i-smooth-detail-' + V_FF_DET, iToggle: 'i-flight-' + V_FF_DET, vToggleClass: 'c-flight-on-detail' });
        V_FF_DET = false;
    }
}

function FDTab(oTarget, vTab) {

    var oTabs = oTarget.parentNode.parentNode;
    var oTabsTabs = oTarget.parentNode;
    aTabsTabs = oTabsTabs.getElementsByTagName('span');
    aScreens = oTabs.getElementsByClassName('c-flight-detail-tab');
    vScreenToShow = false;
    vTabToShow = false;
    //console.log(aScreens);

    oTabs.style.minHeight = '';

    for (var i = 0; i < aTabsTabs.length; ++i) {
        aTabsTabs[i].classList.remove('c-link-u');
        if (i + 1 == vTab) vTabToShow = aTabsTabs[i];
    }

    for (var i = 0; i < aScreens.length; ++i) {
        aScreens[i].classList.remove('c-on');
        if (i + 1 == vTab) vScreenToShow = aScreens[i];
    }

    vScreenToShow.classList.add('c-on');
    vTabToShow.classList.add('c-link-u');

    if (A_CLIENT_WINDOW['device'] == 'touch') {
        XLScrollTo({ oObj: oTabs, vHUp: 95 });
    }

}

function FTab(aIn) {

    var oScreenToShow = false,
        oTabToShow = false,
        oTabs = (aIn['iTabs']) ? document.getElementById(aIn['iTabs']) : aIn['oTab'].parentNode.parentNode,
        aTabsTabs = oTabs.getElementsByClassName('c-tabs-tabs')[0].getElementsByTagName('DIV'),
        aScreens = oTabs.getElementsByClassName('c-tabs-screen'),
        oRail = oTabs.getElementsByClassName('c-tabs-rail')[0],
        vMode = 'display';

    if (oTabs.className.indexOf('c-tabs-slide')) vMode = 'slide';
    for (var i = 0; i < aTabsTabs.length; ++i) {
        if (i + 1 == aIn['vTab']) oTabToShow = aTabsTabs[i];
        aTabsTabs[i].classList.remove('c-on');
    }
    if (oTabToShow) oTabToShow.classList.add('c-on');

    for (var i = 0; i < aScreens.length; ++i) {

        if (i + 1 == aIn['vTab'] && vMode == 'display') {
            oScreenToShow = aScreens[i];
            aScreens[i].classList.remove('c-on');
        }
        else if (i + 1 == aIn['vTab'] && vMode == 'slide') {
            oScreenToShow = aScreens[i];
            var aScreenBounds = XLObjBounds({ myObj: aScreens[i] });
        }
    }

    if (vMode == 'display' && oScreenToShow) oScreenToShow.classList.add('c-on');
    else if (vMode == 'slide' && oScreenToShow) {
        oRail.style.marginLeft = -1 * (aScreenBounds['width'] * (aIn['vTab'] - 1)) + 'px';
    }

}

function FTabLogin(aIn) {

    if (aIn['vId'] == 1) {
        document.getElementById('i-tab-login-1').classList.add('c-display-none');
        document.getElementById('i-tab-login-2').classList.remove('c-display-none');
    }
    else if (aIn['vId'] == 2) {
        document.getElementById('i-tab-login-1').classList.remove('c-display-none');
        document.getElementById('i-tab-login-2').classList.add('c-display-none');
    }

}

function FRespMenu(aIn) {
    var oMenu = document.getElementById(aIn['iPop']);
    oMenu.classList.add('c-pop');
    aIn['c'] = 'top';
    FPop(aIn);
}

function FLoft(aIn) {

    if (aIn['iLoft'] == 'parent') oLoft = aIn['oField'].parentNode;
    else oLoft = document.getElementById(aIn['iLoft']);
    oLoft.classList.add('c-loft');
    aIn['oLoft'] = oLoft;
    aIn['classAdd'] = 'c-opaque';
    return aIn;

}

function FSelect(aIn) {

    // To fix later ...
    if (aIn['e']) var oTarget = XLObjTarget(aIn['e']);
    else var oTarget = XLObjTarget(event);

    var vName = false;
    if (aIn['vName']) vName = aIn['vName'];
    else if (oTarget.getAttribute('data-name')) vName = oTarget.getAttribute('data-name');
    if (document.getElementById(vName + '-text')) document.getElementById(vName + '-text').classList.add('c-on');

    var oPopSource = "";
    vName === "cabinClass" ? oPopSource = document.getElementById('i-search-cabinClass-pop') : oPopSource = document.getElementById(vName + '-pop');
    if (oPopSource.getAttribute('data-fill')) vName = oPopSource.getAttribute('data-fill');

    if (vName) {
        var oTargetText = document.getElementById(vName + '-text');
        console.log(vName, oTargetText);
        if (oTarget.getAttribute('data-text')) {
            oTargetText.innerHTML = oTarget.getAttribute('data-text');
            //alert(oTarget.getAttribute('data-text')) ;
            //console.log(oTargetText);
        } else {
            if (oTarget.tagName == 'IMG' || oTarget.tagName == 'EM' || oTarget.tagName == 'SPAN')
                oTargetText.innerHTML = oTarget.parentNode.innerHTML;
            else if (!aIn['ignoreFlagsReplace'])
                oTargetText.innerHTML = oTarget.innerHTML;
        }

        if (vName == 'i-select-lang' || vName == 'i-payer') {
            document.getElementById(vName + '-text-label').classList.add('c-standby');
        }

        if (oTargetText.getAttribute('data-check')) XLFieldCheck({ oObj: oTargetText });

        //**************************************************************************************************************************************
        ///Modify by AGSW for the web
        //if (oTarget.getAttribute('data-value')) document.getElementsByName(vName)[0].value = oTarget.getAttribute('data-value');

        if (oTarget.getAttribute('data-value')) {		                                                // Required For Web
            if (aIn['isCountry'] && aIn['isCountry'] == 1) {                                            // Required For Web
                var countryVal = document.getElementsByName(vName)[0].value = oTarget.getAttribute('data-country');      // Required For Web
                if (countryVal == "FR") {
                    if (document.getElementById("i-postc")) {
                        document.getElementById("i-postc").setAttribute("data-check", "{check:'postcode',maxlength:5,length:5}");
                        document.getElementById("i-postc").setAttribute("maxlength", "5");
                    }
                }
                else {
                    if (document.getElementById("i-postc")) {
                        document.getElementById("i-postc").setAttribute("data-check", "{check:'postcode',maxlength:50,length:3}");
                        document.getElementById("i-postc").setAttribute("maxlength", "50");
                    }
                }
            }
            else                                                                                        // Required For Web
                document.getElementsByName(vName)[0].value = oTarget.getAttribute('data-value');       // Required For Web

            aVS = new Array();
            aVS['oObj'] = oTargetText;
            aVS['vError'] = false;
            aVS['vErrorCode'] = '';
            aVS['disabledOkStyle'] = aIn['disabledOkStyle'];
            if (aIn['vMode'] != 'phone-codes') XLFormValidStyle(aVS);

        }
        //**************************************************************************************************************************************

        //ignoreFlagsReplace: flag para controlar que este bloque de codigo no se ejecute porque esta reemplanzando el li y el codigo controlado por angular
        if (aIn['vMode'] && aIn['vMode'] == 'phone-codes' && (!aIn['ignoreFlagsReplace'])) {
            var vTempTar = (oTarget.tagName == 'IMG' || oTarget.tagName == 'EM' || oTarget.tagName == 'SPAN') ? oTarget.parentNode : oTarget;
            var vTemp = vTempTar.getElementsByTagName('img')[0].outerHTML + vTempTar.getElementsByTagName('em')[0].innerHTML;
            /*vTemp = vTemp.replace('flags/32', 'flags/16');*/
            document.getElementById(vName + '-text').innerHTML = vTemp;
            if (document.getElementById(vName).value == "33") document.getElementById(vName.replace('-codes', '')).setAttribute("maxlength", "10");
            else document.getElementById(vName.replace('-codes', '')).setAttribute("maxlength", "20");
        }

        var aTargets = aIn['myObj'].getElementsByTagName('li');
        for (var i = 0; i < aTargets.length; i++) aTargets[i].classList.remove('c-on');
        oTarget.classList.add('c-on');
        //var oPop = document.getElementById(vName + '-pop') ;
        if (oPopSource) {
            //if (oPop.className.indexOf('c-pop-quick') != -1) FPopHideAll() ;
            //else if (A_CLIENT_WINDOW['width'] >= 980) FPopHideAll() ;
            FPopHide({ iPop: oPopSource.id });
        }
    }

    if (aIn['f']) eval(aIn['f'](oTarget.getAttribute('data-value')));

    if (vName == 'i-card-aa') {
        if (parseInt(oTarget.innerHTML) == (new Date()).getFullYear()) {
            currentMonth = (new Date()).getMonth() + 1;
            if (document.getElementById("i-mm-card")) {
                if (parseInt(document.getElementById("i-card-mm-text").innerHTML) < currentMonth) {
                    $("#i-mm-card").removeClass("c-field-ok");
                    $("#i-mm-card").addClass("c-field-ko");
                    FErrorShow({ oObj: document.getElementById("i-mm-card"), vErrorCode: 'data-error', vErrorCustom: "Date d'expiration invalide" });
                }
                monthListItem = document.getElementById("i-card-mm-pop").getElementsByClassName("c-ul-tick")[0].getElementsByTagName("li");
                for (i = 0; i < currentMonth; i++) {
                    monthListItem[i].style.display = "none";
                }

            }
        }
        else if (parseInt(oTarget.innerHTML) > (new Date()).getFullYear()) {
            if (document.getElementById("i-mm-card")) {
                monthListItem = document.getElementById("i-card-mm-pop").getElementsByClassName("c-ul-tick")[0].getElementsByTagName("li");
                for (i = 0; i < monthListItem.length; i++) {
                    monthListItem[i].style.display = "block";
                }
            }
        }
    }

    //**************************************************************************************************************************************
    ///Modify by AGSW for the web
    //TODO 0: check if can remove this condition and use native js for all sites
    if (window.site.partnerId.startsWith("carrefour")) {

        if (document.getElementById(vName))
            document.getElementById(vName).dispatchEvent(new Event('change'));
    } else {
        $(document.getElementById(vName)).change();
    }
    //**************************************************************************************************************************************
}

function FSelectBuyerType(aIn) {

    if (aIn) {

        if (aIn.vName == "i-li-private") {
            document.getElementById("i-fields-private").style.display = 'block';
            document.getElementById("i-fields-society").style.display = 'none';
            document.getElementById("i-payer-type-text").innerHTML = "un particulier";
            document.getElementById("i-payer-type-pop").classList.remove('c-show');
        }
        else if (aIn.vName == "i-li-society") {
            document.getElementById("i-fields-society").style.display = 'block';
            document.getElementById("i-fields-private").style.display = 'none';
            document.getElementById("i-payer-type-text").innerHTML = "une société";
            document.getElementById("i-payer-type-pop").classList.remove('c-show');
        }

    }


    // To fix later ...
    if (aIn['e']) var oTarget = XLObjTarget(aIn['e']);
    else var oTarget = XLObjTarget(event);

    var vName = false;
    if (aIn['vName']) vName = aIn['vName'];
    else if (oTarget.getAttribute('data-name')) vName = oTarget.getAttribute('data-name');
    document.getElementById(vName + '-text').classList.add('c-on');

    var oPopSource = document.getElementById(vName + '-pop');
    if (oPopSource.getAttribute('data-fill')) vName = oPopSource.getAttribute('data-fill');

    if (vName) {
        var oTargetText = document.getElementById(vName + '-text');
        if (oTarget.getAttribute('data-text')) {
            oTargetText.innerHTML = oTarget.getAttribute('data-text');
            //alert(oTarget.getAttribute('data-text')) ;
            //console.log(oTargetText);
        } else {
            if (oTarget.tagName == 'IMG' || oTarget.tagName == 'EM' || oTarget.tagName == 'SPAN')
                oTargetText.innerHTML = oTarget.parentNode.innerHTML;
            else
                oTargetText.innerHTML = oTarget.innerHTML;
        }

        if (oTargetText.getAttribute('data-check')) XLFieldCheck({ oObj: oTargetText });

        //**************************************************************************************************************************************
        ///Modify by AGSW for the web
        //if (oTarget.getAttribute('data-value')) document.getElementsByName(vName)[0].value = oTarget.getAttribute('data-value');

        if (oTarget.getAttribute('data-value')) {		                                                // Required For Web
            if (aIn['isCountry'] && aIn['isCountry'] == 1)                                              // Required For Web
                document.getElementsByName(vName)[0].value = oTarget.getAttribute('data-country');      // Required For Web
            else                                                                                        // Required For Web
                document.getElementsByName(vName)[0].value = oTarget.getAttribute('data-value');       // Required For Web

            aVS = new Array();
            aVS['oObj'] = oTargetText;
            aVS['vError'] = false;
            aVS['vErrorCode'] = '';
            if (aIn['vMode'] != 'phone-codes') XLFormValidStyle(aVS);

        }
        //**************************************************************************************************************************************


        if (aIn['vMode'] && aIn['vMode'] == 'phone-codes') {
            var vTempTar = (oTarget.tagName == 'IMG' || oTarget.tagName == 'EM' || oTarget.tagName == 'SPAN') ? oTarget.parentNode : oTarget;
            var vTemp = vTempTar.getElementsByTagName('img')[0].outerHTML + ' ' + vTempTar.getElementsByTagName('em')[0].innerHTML;
            /*vTemp = vTemp.replace('flags/32', 'flags/16');*/
            document.getElementById(vName + '-text').innerHTML = vTemp;
        }

        var aTargets = aIn['myObj'].getElementsByTagName('li');
        for (i = 0; i < aTargets.length; i++) aTargets[i].classList.remove('c-on');
        oTarget.classList.add('c-on');
        //var oPop = document.getElementById(vName + '-pop') ;
        if (oPopSource) {
            //if (oPop.className.indexOf('c-pop-quick') != -1) FPopHideAll() ;
            //else if (A_CLIENT_WINDOW['width'] >= 980) FPopHideAll() ;
            FPopHide({ iPop: oPopSource.id });
        }
    }

    if (aIn['f']) eval(aIn['f'](oTarget.getAttribute('data-value')));

    //**************************************************************************************************************************************
    ///Modify by AGSW for the web
    $(document.getElementById(vName)).change();     // Required For Web
    //**************************************************************************************************************************************

}




function FPop(aIn) {

    //FPopMulti() ;
    if (document.getElementById("i-field-error"))
        FErrorDestroy();
    var popSearch = false;
    if (aIn["iPop"].indexOf('search') > 0) popSearch = true;

    if (!popSearch) {
        var oTarget = aIn['oTarget'];

        if (!oTarget)
            oTarget = aIn['oField'];
    }
    //oTarget.onblur = function() { FPopHide({iPop:aIn['iPop']}) } ;

    // Never user blur on fields : it will disable the tabindex
    // if (aIn['vBlur']) oTarget.blur() ;

    var oLoft = false;
    if (aIn['iLoft']) {
        if (aIn['iLoft'] == 'parent') oLoft = aIn['oField'].parentNode;
        else oLoft = document.getElementById(aIn['iLoft']);
        oLoft.classList.add('c-loft');
        aIn['classAdd'] = 'c-opaque';
        if (!popSearch) oTarget = oLoft;
    }

    if (aIn['vPClass']) {
        aIn['oField'].parentNode.classList.add('c-on');
        O_POP_FON = aIn['oField'].parentNode;
    }

    var oPop = document.getElementById(aIn['iPop']);
    if (!oPop) return false;

    //¡¡¡¡¡Mega super arreglo para que los combos funcionen bien!!!!
    $("#" + aIn['iPop'] + " li").children().not("a").not("input").not("label").css("pointer-events", "none");

    //oPop.onmousedown = function() { FStopProp(); } ;
    if (oPop !== null) {
        oPop.addEventListener("mousedown", FStopProp, false);
    }
    //console.log(oPop.classList) ;

    if (aIn['vFill']) oPop.setAttribute('data-fill', aIn['vFill']);
    //if (aIn['vNoBodyHide']) oPop.setAttribute('data-nobodyhide', true);

    if (popSearch) {
        oPopArrow = oPop.getElementsByClassName('c-pop-arr')[0];
        if (!oPopArrow && aIn["iPop"] !== 'i-search-autoc') {
            var oPopArrow = document.createElement("div");
            oPopArrow.classList.add('c-pop-arr');
            oPop.appendChild(oPopArrow);
        }
    }

    else if (oTarget && !popSearch) {
        var aTargetBounds = XLObjBounds({ myObj: oTarget });

        //console.log(oTarget);
        oTarget.classList.add('c-act');
        O_POP_TARGET = oTarget;

        var vLeft = aTargetBounds['pageRight'] - (oPop.offsetWidth / 2) - 6;
        var vTop = aTargetBounds['pageBottom'] + 10;
        //console.log(aIn['vPos']);

        if (aIn['vPos']) {
            if (aIn['vPos'] == 'bl') {
                vLeft = aTargetBounds['pageLeft'];
                vTop = aTargetBounds['pageBottom'];
            }
            else if (aIn['vPos'] == 'bc') {
                vTop = aTargetBounds['pageBottom'] + 10;
                vLeft = (aTargetBounds['pageLeft'] + aTargetBounds['width'] / 2) - (oPop.offsetWidth / 2);
            }
        }

        if (aIn['vTopM']) {
            vTop = vTop + aIn['vTopM'];
        }
        //console.log(vLeft);

        if (vLeft <= 0) vLeft = 5;
        else if ((vLeft + oPop.offsetWidth) >= A_CLIENT_WINDOW['width'] - 20) vLeft = A_CLIENT_WINDOW['width'] - oPop.offsetWidth - 20;

        //console.log(vLeft + ' - ' + oPop.offsetWidth + ' - ' + A_CLIENT_WINDOW['width']) ;

        oPop.style.left = vLeft + 'px';
        oPop.style.top = vTop + 'px';

        /** pop arrow **/
        oPopArrow = oPop.getElementsByClassName('c-pop-arr')[0];
        if (!oPopArrow) {
            var oPopArrow = document.createElement("div");
            oPopArrow.classList.add('c-pop-arr');
            oPop.appendChild(oPopArrow);
        }
        aIn['vStyle'] === 'classic' ? oPopArrow.style.left = aTargetBounds['width'] / 2 + 'px' : oPopArrow.style.left = aTargetBounds['pageLeft'] - vLeft + aTargetBounds['width'] / 2 + 'px';

        //console.log(oPop.style.left) ;
        //alert('stop') ;
        //oPop.setAttribute('style', 'top:' + vTop + 'px !important;left: '+ vLeft +'px ') ;
        //alert('STOP') ;
        if (A_CLIENT_WINDOW['width'] <= 750) {
            //var vTop = aTargetBounds['bottom'] + 5 ;
            //oPop.setAttribute('style', 'top:' + vTop + 'px !important;left: '+ vLeft +'px ') ;
            //oPop.style.top =  aTargetBounds['bottom'] + 5 + 'px ' ;
        }
        //console.log(oPop.style) ;
    }

    //if (oLoft && A_CLIENT_WINDOW['width'] <= 750) {
    if (oLoft && A_CLIENT_WINDOW['device'] == 'touch') {
        //window.scrollTo(0,aTargetBounds['pageTop'] - 10) ;
        //XLScrollTo({ vLeft: 0, vTop: aTargetBounds['pageTop'] - 10 });
    }

    if (aIn['c']) {
        if (aIn['c'] == 'top') oPop.classList.add('c-pop-top');
        else if (aIn['c'] == 'splash') oPop.classList.add('c-pop-splash');
    }

    if (aIn['vMode']) {
        if (aIn['vMode'] == 'quick') oPop.classList.add('c-pop-quick');
    }

    if (aIn['vStyle']) {

        if (aIn['vStyle'] == 'classic') {
            oPop.classList.remove('c-arrow');
            oPop.classList.add('c-classic');
            oPop.style.left = aTargetBounds['pageLeft'] + 'px';
            oPop.style.top = aTargetBounds['pageBottom'] + 2 + 'px';
        }
    }

    if (A_POPS.length > 0)
        document.getElementById(A_POPS[A_POPS.length - 1]).classList.remove('c-show');

    oPop.classList.add('c-show');
    A_POPS.push(aIn['iPop']);
    A_POPS = XLArrDelDuplicates(A_POPS);
    //console.log(A_POPS) ;

    oPopClose = oPop.getElementsByClassName('c-close')[0];
    //XLCoverShow(aIn) ;

    if (!aIn['fCallBackOnClose']) aIn['fCallBackOnClose'] = '';

    var aClosers = oPop.getElementsByClassName('c-closer');
    for (var i = 0; i < aClosers.length; ++i) {
        aClosers[i].onclick = function () { FPopHide({ iPop: aIn['iPop'], fCallBackOnClose: aIn['fCallBackOnClose'] }); };
    }

    var oBody = document.body;
    if (!aIn['vNoBodyHide'])
        oBody.onmousedown = function () { FPopHide({ iPop: aIn['iPop'], fCallBackOnClose: aIn['fCallBackOnClose'] }); };

    //if (aIn['iPop'] == 'i-search-who-pop')
    //document.getElementById('i-search-who-fieldset').classList.add('c-on') ;    

}

function FPopHide(aIn) {
    var oPop = document.getElementById(aIn['iPop']);
    if (oPop) {
        oPop.classList.remove('c-show');
        oPop.classList.remove('c-smooth-open');
        if (oPop.id === "i-search-when-pop") oPop.parentElement.removeChild(oPop);
    }
    var oBody = document.body;
    oBody.classList.remove('c-noscroll');

    //******************************************
    //AGSW Fix 2015-04-09
    oBody.removeAttribute('onmousedown');
    oBody.onmousedown = null;
    //******************************************



    XLArrSpliceVal(A_POPS, aIn['iPop']);
    if (A_POPS.length > 0) {
        //console.log(A_POPS);
        document.getElementById(A_POPS[A_POPS.length - 1]).classList.add('c-show');
    }
    //console.log(A_POPS) ;

    //if (aIn['iPop'] == 'i-search-who-pop')
    //document.getElementById('i-search-who-fieldset').classList.remove('c-on') ;

    if (O_POP_FON) {
        O_POP_FON.classList.remove('c-on');
        O_POP_FON = false;
    }

    if (O_POP_TARGET) O_POP_TARGET.classList.remove('c-act');

    if (oPop && oPop.getAttribute('data-hide-destroy')) oPop.parentElement.removeChild(oPop);

    if (aIn['fCallBackOnClose']) eval(aIn['fCallBackOnClose']());

}

function XLCoverShow(aIn) {

    var iCover = aIn['iPop'] + '-cover';

    if (!document.getElementById(iCover)) {

        var vCoverExist = XLCoverMulti({ vDo: 'hide', iPop: aIn['iPop'] });
        var oBody = document.body;
        var oCover = document.createElement("div");
        var iCover = aIn['iPop'] + '-cover';
        oCover.id = iCover;
        oCover.classList.add('c-cover');

        if (aIn['classAdd']) oCover.classList.add(aIn['classAdd']);
        oCover.setAttribute('data-ipop', aIn['iPop']);
        oBody.appendChild(oCover);
        oCover.onclick = function () { FPopHide({ oCover: oCover, iPop: aIn['iPop'] }); };

        window.setTimeout(function () {
            oCover.classList.add('c-show');
        }, 1);

    } else {

        var oCover = document.getElementById(iCover);
        oCover.classList.add('c-show');

    }

    var oPop = document.getElementById(aIn['iPop']);
    var aClosers = oPop.getElementsByClassName('c-closer');
    for (var i = 0; i < aClosers.length; ++i) {
        aClosers[i].onclick = function () { FPopHide({ oCover: oCover, iPop: aIn['iPop'] }); };
    }
    //return oCover ;
}

function FPopHideAll() {

    XLCoverMulti({ vDo: 'show', iPop: aIn['iPop'] });
    var aPops = document.getElementsByClassName('c-pop');
    var aCovers = document.getElementsByClassName('c-cover');

    for (var i = 0; i < aPops.length; ++i) aPops[i].classList.remove('c-show');

    for (var i = 0; i < aCovers.length; ++i) {
        aCovers[i].parentNode.removeChild(aCovers[i]);
    }

}

function XLCoverMulti(aIn) {

    //console.log('XLCoverMulti : ' + aIn) ;

    var vCoverExist = false;

    var aCovers = document.getElementsByClassName('c-cover');
    for (var i = 0; i < aCovers.length; ++i) {
        var oCover = aCovers[i];

        if (aIn['vDo'] == 'hide') {
            oCover.classList.remove('c-show');
            if (oCover.getAttribute('data-ipop')) {
                oPop = document.getElementById(oCover.getAttribute('data-ipop'));
                oPop.classList.remove('c-show');
                if (oCover.getAttribute('data-ipop') == aIn['iPop']) vCoverExist = true;
            }
        }
        else if (aIn['vDo'] == 'show') {
            oCover.classList.add('c-show');
            if (oCover.getAttribute('data-ipop')) {
                oPop = document.getElementById(oCover.getAttribute('data-ipop'));
                oPop.classList.add('c-show');
                if (oCover.getAttribute('data-ipop') == aIn['iPop']) vCoverExist = true;
            }
        }
    }

    return vCoverExist;

}

function XLScrollTo(aIn) {

    //setTimeout(function () {

    var oBody = document.body;
    var aBody = XLObjBounds({ myObj: oBody });
    //console.log(aBody);

    if (aIn['iObj']) aIn['oObj'] = document.getElementById(aIn['iObj']);

    if (aIn['oObj']) {
        var aObj = XLObjBounds({ myObj: aIn['oObj'] });
        //console.log(aObj);
        aIn['vTop'] = aObj['pageTop'];
    }

    oBody.classList.add('c-body-transi');

    var vScrollTo = aIn['vTop'];
    vScrollBy = (vScrollTo - aBody['scrollTop']) * -1;

    if (aIn['vHUp']) {
        vScrollBy = vScrollBy + aIn['vHUp'];
        vScrollTo = vScrollTo - aIn['vHUp'];
    }

    if (A_CLIENT_WINDOW['device'] != 'touch' && vScrollTo >= aBody['scrollTop'] && vScrollTo <= (aBody['scrollTop'] + aBody['innerHeight'])) return false;

    //vScrollBy = vScrollBy + 30 ;
    //vScrollTo = vScrollTo - 30 ;

    oBody.style.WebkitTransform = 'translate(0, ' + (vScrollBy) + 'px)';
    oBody.style.MozTransform = 'translate(0, ' + (vScrollBy) + 'px)';
    oBody.style.transform = 'translate(0, ' + (vScrollBy) + 'px)';

    //}, 200);

    window.setTimeout(function () {
        oBody.classList.remove('c-body-transi');
        oBody.style.cssText = '';
        window.scrollTo(0, vScrollTo);
    }, 400); // This time have to be equal ou upper the transition delay of the class c-body-transi

}

function XLScrollTo_BK(aIn) {

    var oBody = document.body;
    var aBody = XLObjBounds({ myObj: oBody });
    //console.log(aBody);

    if (aIn['iObj']) aIn['oObj'] = document.getElementById(aIn['iObj']);

    if (aIn['oObj']) {
        var aObj = XLObjBounds({ myObj: aIn['oObj'] });
        console.log(aObj);
        aIn['vTop'] = aObj['pageTop'];
    }

    oBody.classList.add('c-body-transi');

    var vScrollTo = aIn['vTop'];
    vScrollBy = (vScrollTo - aBody['scrollTop']) * -1;

    if (aIn['vHUp']) {
        vScrollBy = vScrollBy + aIn['vHUp'];
        vScrollTo = vScrollTo - aIn['vHUp'];
    }

    console.log(vScrollTo + ' - ' + vScrollBy + ' - ' + aIn['vTop'] + ' - ' + aBody['scrollTop']);

    //if (vScrollTo < aBody['scrollTop']) return false ;

    oBody.style.WebkitTransform = 'translate(0, ' + (vScrollBy) + 'px)';
    oBody.style.MozTransform = 'translate(0, ' + (vScrollBy) + 'px)';
    oBody.style.transform = 'translate(0, ' + (vScrollBy) + 'px)';

    window.setTimeout(function () {
        oBody.classList.remove('c-body-transi');
        oBody.style.cssText = '';
        window.scrollTo(0, vScrollTo);
    }, 400); // This time have to be equal ou upper the transition delay of the class c-body-transi

}

function XLObjInView(aIn) {

    var aReturn = new Array();
    var el = aIn['oObj'];
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    aReturn['inView'] = top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth);

    return aReturn;

}

function XLObjBounds(aIn) {

    var oObj = aIn['myObj'];
    var aObjBounds = oObj.getBoundingClientRect();
    var oBody = document.body;
    var vScrollLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
    var vScrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    aObjBounds['scrollLeft'] = vScrollLeft;
    aObjBounds['scrollTop'] = vScrollTop;
    aObjBounds['pageLeft'] = aObjBounds.left + aObjBounds['scrollLeft'];
    aObjBounds['pageTop'] = aObjBounds.top + aObjBounds['scrollTop'];
    aObjBounds['pageBottom'] = aObjBounds.bottom + aObjBounds['scrollTop'];
    aObjBounds['pageRight'] = aObjBounds.right + aObjBounds['scrollLeft'];

    aObjBounds['innerWidth'] = window.innerWidth;
    aObjBounds['innerHeight'] = window.innerHeight;

    //console.log(aObjBounds) ;
    return aObjBounds;

}

function XLClientWindow() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    //var width = document.documentElement.offsetWidth;
    //var height = document.documentElement.offsetHeight;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        device = 'touch';
    } else device = 'desktop';
    return {
        device: device,
        width: width,
        height: height
    };
}

function FAutoCompHide() {

    oAutoComp = document.getElementById('i-search-autoc');
    if (oAutoComp !== null) {
        oAutoComp.innerHTML = '';
        oAutoComp.classList.remove('c-show');
        FPopHide({ iPop: 'i-search-autoc' });
        oAutoComp.parentElement.removeChild(oAutoComp);
        //O_AUTO_COMP_F = false ;
    }
}

function FPopSearchWho() {

    FPopHide({ iPop: 'i-search-when-pop' });
    FPopHide({ iPop: 'i-search-autoc' });

}

//O_AUTO_COMP_F = false ;

function FAutoComp(aIn) {
    if (aIn["oField"].parentElement.getElementsByClassName("c-pop-autoc").length === 0) {
        oPopAutoc = document.createElement("div");
        oPopAutoc.id = "i-search-autoc";
        oPopAutoc.classList.add("c-pop", "c-pop-autoc");
        aIn['oField'].parentElement.appendChild(oPopAutoc);
    }
    else if (aIn["oField"].parentElement.getElementsByClassName("c-pop-autoc").length > 0) var oPopAutoc = document.getElementById("i-search-autoc");
    //oPopWhen = document.getElementById('i-search-when-pop') ;
    //oPopWho = document.getElementById('i-search-who-pop') ;
    if (oPopAutoc) {
        oPopAutoc.innerHTML = '';
    }

    aIn['oField'].parentNode.classList.remove('c-field-ko');

    //aIn['oField'].value = '' ;
    aIn['oField'].focus();
    //aIn['oField'].onblur = function() { } ;
    //aIn['oField'].select() ;

    if (aIn['oField'].getAttribute('data-validated') || aIn['oField'].value !== "") {
        aIn['oField'].setAttribute('placeholder', aIn['oField'].value);
        aIn['oField'].value = '';
        // For Hotel, we clear input value too
        if (aIn['oField'].id == "i-where-destination-hotel")
            document.getElementById('i-destination-hotel-input').value = '';
    }
    aIn['oField'].onblur = function () { FAutoCompBlur(aIn) };

    if (V_CS_AIRPORTS || V_CS_CITIES || V_CS_AIRPORTSORI || V_CS_CITIESORI) FAutoCompRun(aIn);

}

function XLCapitalizeFL(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function FAutoCompSel(aIn) {     

    //O_AUTOC_LI = false ;
    if (aIn['oTarget'] == false) return false;

    var oAutoComp = document.getElementById('i-search-autoc');
    //console.log(aIn['oTarget']) ;
    var oFieldText = document.getElementById(aIn['oTarget'].getAttribute('data-text-id'));
    var vInputName = aIn['oTarget'].getAttribute('data-input-name');
    var vInputValue = aIn['oTarget'].getAttribute('data-input-value');

    var localInfo = {
        'airport': aIn['oTarget'].getAttribute('data-input-airport'),
        'city': aIn['oTarget'].getAttribute('data-input-city'),
        'country': aIn['oTarget'].getAttribute('data-input-country'),
        'continent': aIn['oTarget'].getAttribute('data-input-continent'),
    }
    window.localStorage.setItem(vInputName + '_info', JSON.stringify(localInfo));

    if (vInputName) {
        oInput = document.getElementsByName(vInputName)[0];
        oInput.value = vInputValue;
    }

    var vText = '';
    if (aIn['vText']) vText = aIn['vText'];
    else if (aIn["iField"] == "i-where-destination-hotel")  // For Hotel
        vText = aIn["oTarget"].innerText;
    else {
        var pTags = aIn['oTarget'].getElementsByTagName('p');
        if (pTags && pTags.length > 0) {
            vText = pTags[0].innerHTML;
            vText = vText.replace('<em>', '(');
            vText = vText.replace('</em>', ')');
            vText = vText.replace(/<\/?[^>]+(>|$)/g, "");
            vText = XLCapitalizeFL(vText);
        }
    }

    if (oFieldText != null && typeof (oFieldText) != 'undefined') {
        oFieldText.value = vText;
        oFieldText.setAttribute('data-validated', true);
        oFieldText.setAttribute('data-edited', true);
        if (!aIn['vAutocLi']) oFieldText.setAttribute('data-autoced', true);
    }

    FAutoCompHide();
}


function FAutoCompBlur(aIn) {

    if (aIn['oField'].getAttribute('data-autoced')) {
        //console.log('A');
    }

    else if (O_AUTOC_LI != false) {
        FAutoCompSel({ oTarget: O_AUTOC_LI, iField: aIn['oField'].id, vAutocLi: true });
        aIn['oField'].setAttribute("data-tabbed", "true");
        O_AUTOC_LI = false;
    }

    //else if (!aIn['oField'].getAttribute('data-validated')) {
    else if (aIn['oField'].getAttribute('data-edited') || aIn['oField'].getAttribute('placeholder') !== "") {
        aIn['oField'].value = aIn['oField'].getAttribute('placeholder');
    }

    aIn['oField'].removeAttribute('data-autoced');
    O_AUTOC_LI = false;
}

//**************************************************************************************************************************************
///Modify by AGSW for the web
var autocompleteTimer;
var autocompleteWaitTime = 500;
function FAutoCompRun(aIn) {
    clearTimeout(autocompleteTimer);
    autocompleteTimer = setTimeout(function () { search(aIn) }, autocompleteWaitTime);
}

function search(aIn) {
    var oField = aIn['oField'];

    var vCustomSearch = false;
    var vCustomSearchOri = false;
    if (oField.classList.contains("customSearch"))
        vCustomSearch = true;
    if (oField.classList.contains("customSearchOri"))
        vCustomSearchOri = true;

    var vCustomSearch_DP = false;
    var vCustomSearchOri_DP = false;
    if (oField.classList.contains("customSearch_DP"))
        vCustomSearch_DP = true;
    if (oField.classList.contains("customSearchOri_DP"))
        vCustomSearchOri_DP = true;

    var c = aIn['e'];
    var excludeCities = "";
    if ($("#i-field-error")) {
        $("#i-field-error").remove();
        oField.parentNode.classList.remove("c-field-ko");
    }
    var vMaxRows = 7;
    var vMaxFlightRows = 7;
    var vMaxHotelRows = 99;
    if (vCustomSearch || vCustomSearchOri || vCustomSearch_DP || vCustomSearchOri_DP) {
        vMaxRows = 9999;
        vMaxFlightRows = 9999;
        vMaxHotelRows = 9999;
    }

    var e = aIn['e'];
    if (isset(e)) {
        if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40 || e.keyCode == 13 || e.keyCode == 9) {
            e.preventDefault();
            return false;
        }
        else if (e.keyCode == 27) {
            FAutoCompHide();
            return false;
        }
    }
    var vQuery = oField.value;
    var aIn = new Array();

    var oAutoComp = document.getElementById('i-search-autoc');
    if (!oAutoComp) return false;

    //**************************************************************************************************************************************
    ///Modify by AGSW for the web
    var apiUrl = "";
    var apiUrlSSL = "";
    if (oField.id == "i-where-destination-hotel") {
        vMaxRows = vMaxHotelRows;
        apiUrl = ((window.site && window.site.apiUrl) ? window.site.apiUrl + 'HotelAutoComplete/' : null) || 'https://mrfly.pilato.es/_rest/api/HotelAutocomplete/';
        apiUrlSSL = ((window.site && window.site.apiUrlSSL) ? window.site.apiUrlSSL + 'HotelAutoComplete/' : null) || 'https://mrfly.pilato.es/_rest/api/HotelAutocomplete/';
    }
    else {
        vMaxRows = vMaxFlightRows;
        apiUrl = ((window.site && window.site.apiUrl) ? window.site.apiUrl + 'Autocomplete/' : null) || 'https://www.misterfly.com/_rest/api/Autocomplete/';
        apiUrlSSL = ((window.site && window.site.apiUrlSSL) ? window.site.apiUrlSSL + 'Autocomplete/' : null) || 'https://www.misterfly.com/_rest/api/Autocomplete/';
    }
    // Custom Search (CS) modified by Nico 2016-01-13
    // ***********************************************************
    aIn['url'] = apiUrl;
    if (window.location.protocol == "https:") aIn['url'] = apiUrlSSL;

    var parameters = [];

    if (vCustomSearch) {
        aIn['url'] = apiUrlSSL;
        if (V_CS_AIRPORTS) parameters.push('airportIATA=' + V_CS_AIRPORTS);
        if (V_CS_CITIES) parameters.push('cityIATA=' + V_CS_CITIES);
        if (V_CS_GROUP) parameters.push('group=' + V_CS_GROUP);
        if (V_CS_REMOVE_IDENT) parameters.push('removeIdent=' + V_CS_REMOVE_IDENT);
    }
    else if (vCustomSearchOri) {
        aIn['url'] = apiUrlSSL;
        if (V_CS_AIRPORTSORI) parameters.push('airportIATA=' + V_CS_AIRPORTSORI);
        if (V_CS_CITIESORI) parameters.push('cityIATA=' + V_CS_CITIESORI);
        if (V_CS_GROUPORI) parameters.push('group=' + V_CS_GROUPORI);
        if (V_CS_REMOVE_IDENTORI) parameters.push('removeIdent=' + V_CS_REMOVE_IDENTORI);
    }
    else if (vCustomSearch_DP) {
        aIn['url'] = apiUrlSSL;
        if (V_CS_AIRPORTS_DP) parameters.push('airportIATA=' + V_CS_AIRPORTS_DP);
        if (V_CS_CITIES_DP) parameters.push('cityIATA=' + V_CS_CITIES_DP);
        if (V_CS_GROUP_DP) parameters.push('group=' + V_CS_GROUP_DP);
        if (V_CS_REMOVE_IDENT_DP) parameters.push('removeIdent=' + V_CS_REMOVE_IDENT_DP);
    } else if (vCustomSearchOri_DP) {
        aIn['url'] = apiUrlSSL;
        if (V_CS_AIRPORTSORI_DP) parameters.push('airportIATA=' + V_CS_AIRPORTSORI_DP);
        if (V_CS_CITIESORI_DP) parameters.push('cityIATA=' + V_CS_CITIESORI_DP);
        if (V_CS_GROUPORI_DP) parameters.push('group=' + V_CS_GROUPORI_DP);
        if (V_CS_REMOVE_IDENTORI_DP) parameters.push('removeIdent=' + V_CS_REMOVE_IDENTORI_DP);
    } else {
        if (window.site && window.site.type) {
            aIn['url'] += vQuery + "?stype=" + window.site.type;
            window.site.partnerId == "airbus" && oField.id == "i-where-destination" ? aIn['url'] += "&excludecityiata=" + excludeCities + "&group=1" : aIn['url'] += "";
        } else {
            aIn['url'] += vQuery;
            window.site.partnerId == "airbus" && oField.id == "i-where-destination" ? aIn['url'] += "&excludecityiata=" + excludeCities + "&group=1" : aIn['url'] += "";
        }
    }

    if (window.site.culture) {
        if (aIn['url'].indexOf("?") > -1) {
            aIn['url'] += "&culture=" + window.site.culture;
        }
        else {
            aIn['url'] += "?culture=" + window.site.culture;
        }

    }

    var postParameters = parameters.join("&");

    aIn['url'] += "&clientId=" + window.site.clientId;

    //return producttype (train or flight) depending the parameter
    if (oField.dataset.productTypeFilter) {
        aIn['url'] += "&productType=" + oField.dataset.productTypeFilter;
    }

    


    // ***********************************************************

    var XHRObject = null;
    if (window.XMLHttpRequest) XHRObject = new XMLHttpRequest();
    else if (window.ActiveXObject) XHRObject = new ActiveXObject("Microsoft.XMLHTTP");
    else return false;

    if (vCustomSearch)
        FPop({ oField: oField, iPop: 'i-search-autoc', iLoft: 'parent', vPos: 'bl', vTopM: 10 });
    else if (vCustomSearchOri)
        FPop({ oField: oField, iPop: 'i-search-autoc', iLoft: 'parent', vPos: 'bl', vTopM: 10 });
    else if (vCustomSearch_DP)
        FPop({ oField: oField, iPop: 'i-search-autoc', iLoft: 'parent', vPos: 'bl', vTopM: 10 });
    else if (vCustomSearchOri_DP)
        FPop({ oField: oField, iPop: 'i-search-autoc', iLoft: 'parent', vPos: 'bl', vTopM: 10 });
    else {
        if (vQuery.length <= 2 && oAutoComp !== null) {
            oAutoComp.classList.remove('c-show');
            oAutoComp.innerHTML = '';
            return false;
        }
    }
    if (parameters.length > 0) {
        XHRObject.open("POST", aIn['url'], true);
        XHRObject.setRequestHeader('Accept', 'application/json');
        XHRObject.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    else {
        XHRObject.open("GET", aIn['url'], true);
        XHRObject.setRequestHeader('Accept', 'application/json');
    }

    XHRObject.onload = function (e) {

        if (XHRObject.readyState == 4) {
            if (XHRObject.status === 200) {
                var vOutput = '';
                aResponse = JSON.parse(XHRObject.responseText);
                //var aResponse = JSON.stringify(xmlToJson(JSON.parse(XHRObject.responseText)));
                //console.log(aResponse) ;
                //if (vCustomSearch) aResponse = aResponse.orderBy(function (a) { return a.cityName });
                if (vCustomSearch && oField.id == 'i-where-origin') {
                    for (var key in aResponse) {

                        if (aResponse.hasOwnProperty(key) && key < vMaxRows) {
                            vClass = '';
                            if (aResponse[key]['ident'] == true) vClass = 'class="ident"';
                        }
                    }
                    aResponse = aResponse.orderBy([
                        { sort: 'desc', select: function (a) { return a.continent } },
                        { sort: 'asc', select: function (a) { return a.countryName } },
                        { sort: 'asc', select: function (a) { return a.cityName } }
                    ]);
                }
                if (vCustomSearch && oField.id == 'i-where-destination') {
                    aResponse = aResponse.orderBy([
                        //sort by cities only for Qatar
                        //{ sort: 'asc', select: function (a) { return a.continent } },
                        //{ sort: 'asc', select: function (a) { return a.countryName } },
                        { sort: 'asc', select: function (a) { return a.cityName } }
                    ]);
                }


                if (XLObjSize(aResponse) != 0) {
                    for (var key in aResponse) {
                        if (aResponse.hasOwnProperty(key) && key < vMaxRows) {
                            oField.setAttribute("data-tabbed", "false");
                            var airportIATA = aResponse[key]['airportIATA'];
                            if (airportIATA == null) airportIATA = '';

                            vClass = '';
                            if (aResponse[key]['ident'] == true) vClass = 'class="ident"';

                            vClick = '';
                            if (oField.id == "i-where-destination-hotel") {
                                vClick += aResponse[key]['key'];
                            } else {

                            
                                vClick += aResponse[key]['cityIATA'];
                                if (airportIATA) {
                                    vClick += '_' + airportIATA;
                                    airportIATA = '<em>' + airportIATA + '</em>';
                                }
                            }
                            var airportIATA2 = aResponse[key]['airportIATA'];
                            if (airportIATA2 == '') airportIATA2 = aResponse[key]['cityIATA'];
                            
                            var vTempIn = aResponse[key]['cityName'];

                            if (oField.id != "i-where-destination-hotel") {
                                if (aResponse[key]['airportName'] != '') {
                                    vTempIn += ' <span>(' + aResponse[key]['airportName'] + ')</span>';
                                }
                                else {
                                    vTempIn = ' <span>' + aResponse[key]['name'] + '</span>';
                                }
                            }

                            if (airportIATA2.length != 0) {
                                if (vCustomSearch || vCustomSearchOri || vCustomSearch_DP || vCustomSearchOri_DP) vTempIn += ' <em class="c-sec-dim">' + airportIATA2 + '</em>';
                                else vTempIn += ' <em>' + airportIATA2 + '</em>';
                            }
                            var vTempCountry = aResponse[key]['countryName'];
                            if ((aResponse[key]['countryISO'] == 'US' || aResponse[key]['countryISO'] == 'AU' || aResponse[key]['countryISO'] == 'CA'))
                                vTempCountry += ' - ' + aResponse[key]['areaLevel1Code'];

                            //var vTempIn = aResponse[key]['name'] + ' ' + airportIATA;
                            //if (key == 0) V_AUTOC = vTempIn ;
                            try {
                                var regex = new RegExp(vQuery, 'gi');
                                //vTempIn = vTempIn.replace(regex, '<strong>'+ vQuery.charAt(0).toUpperCase() + vQuery.slice(1) +'</strong>');
                                if (!vCustomSearch && !vCustomSearchOri && !vCustomSearch_DP && !vCustomSearchOri_DP) vTempIn = vTempIn.replace(regex, '<strong>' + vQuery + '</strong>');
                            }
                            catch (e) { }
                            if (vCustomSearch || vCustomSearchOri || vCustomSearch_DP || vCustomSearchOri_DP) var vTemp = '<p class="c-a c-first-dim">' + vTempIn + '</p>';
                            else var vTemp = '<p>' + vTempIn + '</p>';
                            vTemp += '<p class="c-b"> ' + vTempCountry + '</p>';

                            var city = aResponse[key]['cityIATA'];
                            var country = aResponse[key]['countryISO'];
                            var continent = aResponse[key]['continent'];
                            vCssClass = "";
                            if (oField.id == "i-where-destination-hotel") {
                                vCssClass = "icon-old-marker c-txt-or";
                            }
                            vOutput += '<li onmousedown="FAutoCompSel({oTarget:this,iField:\'' + oField.id + '\'})" ' + vClass + ' data-text-id="' + oField.id + '" data-input-name="' + oField.getAttribute('data-input-name') +
                                '" data-input-city="' + city + '" data-input-country="' + country + '" data-input-continent="' + continent +
                                '" data-input-value="' + vClick + '"><i class="' + vCssClass + '"></i>' + vTemp + '</li>';

                        }
                    }
                    FPop({ oField: oField, iPop: 'i-search-autoc', iLoft: 'parent', vPos: 'bl', vTopM: 10 });
                    vOutput = '<ul id="i-search-autoc-list">' + vOutput + '</ul>';

                    //console.log(vOutput) ;
                    oAutoComp.innerHTML = vOutput;
                    oAutoComp.classList.remove('c-error');
                    //bug fix from 15/01/2019 for IE11
                    oAutoComp.classList.add('c-pop-autoc');
                    oAutoComp.classList.add('c-show');

                    O_AUTOC_LI = oAutoComp.firstChild.firstChild;

                    if (vCustomSearch || vCustomSearchOri || vCustomSearch_DP || vCustomSearchOri_DP) {
                        var oPopAutoUl = document.getElementById('i-search-autoc-list');
                        oPopAutoUl.classList.add('c-scroll', 'c-height-auto');
                        searchInList(oField, 'i-search-autoc-list', 2)
                    }

                    //var aTargetBounds = XLObjBounds({myObj:oField}) ;
                    //oAutoComp.style.top = aTargetBounds['pageBottom'] + 'px !important' ;
                    //oAutoComp.style.left = '10px !important' ;
                    //if (oAutoComp.offsetWidth < oField.offsetWidth) oAutoComp.style.width = oField.offsetWidth + 'px' ;

                } else {

                    //oAutoComp.classList.add('c-error');
                    //oAutoComp.innerHTML = 'Aucun aéroport trouvé';

                    if (oField.getAttribute("data-tabbed") != "true") {
                        aVS = new Array();
                        aVS['oObj'] = oField;
                        aVS['vError'] = true;
                        aVS['vErrorCode'] = '';
                        aVS['vErrorCustom'] = getT('homepage.aucune');
                        XLFormValidStyle(aVS);
                        O_AUTOC_LI = false;
                    }

                }
                if (window.autocompleteCache == null) {
                    window.autocompleteCache = [];
                }
                /*
                if (window.autocompleteCache[oField.id] != null) {
                    delete window.autocompleteCache[oField.id];
                }
                window.autocompleteCache[oField.id] = aResponse;
                
                if (window.autocompleteCache != null) {
                    delete window.autocompleteCache;
                }
                */
                window.autocompleteCache = window.autocompleteCache.concat(aResponse);
            }
            else {
                //console.log('KO') ;
            }
        }

    };
    XHRObject.onerror = function (e) {
        //console.log('ERROR') ;
    };

    if (parameters.length > 0)
        XHRObject.send(postParameters);
    else
        XHRObject.send(null);
}



//Updated by AGSW (create a wrapper function to buffer the calls arround 100 ms to remove the unnecessary api calls) / 2015-04-10 / updated: 2015-04-15
if (typeof Function.prototype.getBuffered !== 'undefined')
    FAutoCompRun = FAutoCompRun.getBuffered(100);

/*******************************************************************************************************
CALENDAR
********************************************************************************************************/
function FCalUpdateRange(goDate, returnDate) {
    O_CAL_FIELD_FROM = document.getElementsByName(goDate)[0];
    O_CAL_FIELD_TO = document.getElementsByName(returnDate)[0];
}
function FCalRange(aIn) {
    if (aIn["oField"].parentElement.getElementsByClassName("c-pop-cal").length > 0) {
        if (aIn["oField"].parentElement.getElementsByClassName("c-pop-cal").length == 1) {
            aIn["oField"].parentElement.removeChild(aIn["oField"].parentElement.getElementsByClassName("c-pop-cal")[0]);
        }
        else {
            aIn["oField"].parentElement.getElementsByClassName("c-pop-cal").forEach(function (whenPop) {
                whenPop.parentElement.removeChild(whenPop);
            });
        }
    }

    var oCalPop = document.createElement("div");
    oCalPop.id = "i-search-when-pop";
    oCalPop.classList.add("c-pop", "c-pop-cal", "c-arrow");
    oCalPop.innerHTML = '<div class="c-cal" id="i-search-when-calendar"></div>';

    aIn['oField'].parentElement.appendChild(oCalPop);

    var oCalCont = document.getElementById('i-search-when-calendar');
    aIn['oField'].parentNode.classList.remove('c-field-ko');

    // vBlur = true if you want to disable the field
    //aIn['vBlur'] = true ;

    if (aIn['vRange'] == 'from') {
        O_CAL_FIELD_FROM = aIn['oField'];
        O_CAL_FIELD_TO = document.getElementsByName(aIn['vNameTo'])[0];
        oCalCont.setAttribute('data-range', 'from');
    }
    else if (aIn['vRange'] == 'to') {
        oCalCont.setAttribute('data-range', 'to');
    }
    O_CAL_FIELD = aIn['oField'];
    //O_CAL_FIELD.onblur = function() { alert('Blur this') ; FPopHide({iPop:'i-search-when-calendar'}) } ;
    FPopHide({ iPop: 'i-search-who-pop' });

    if (O_CAL_FIELD.getAttribute('data-date-min') && O_CAL_FIELD.getAttribute('data-date-min') != 'today' && O_CAL_FIELD.getAttribute('data-date-min') != 'tomorrow')
        aIn['vMonth'] = O_CAL_FIELD.getAttribute('data-date-min').substr(3, 7);

    if (document.getElementsByClassName("c-search-multi").length > 0) aIn['vMonth'] = document.querySelectorAll(".c-when .c-field:first-child input")[0].value.substr(3, 7);

    FPopCal(aIn);

}

function FPopCal(aIn) {

    //console.log('FPopCal') ;
    //if (A_CLIENT_WINDOW['device'] == 'touch') V_CAL_SHOW = 1;
    if (A_CLIENT_WINDOW['width'] <= 620) V_CAL_SHOW = 1;
    //alert('FPopCal ' + A_CLIENT_WINDOW['width']) ;
    //aIn['oField'] = aIn['oFrom'] ;
    //aIn['oTarget'] = aIn['oField'] ;
    if (!aIn['iPop']) aIn['iPop'] = 'i-search-when-pop';
    aIn['iLoft'] = 'parent';
    XLCal(aIn);
    FPop(aIn);

}


/*
Functions déplacées dans functions_ecma6.js
function XLCal(aIn) {
}
*/

function XLMonthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

function XLCalRender(aIn) {
    //vMonth = date to start drawing calendar

    //var vDateUser =  aIn['vDateUser'] ;
    // Initializing variables
    var vDate = aIn['vDate'];
    var vOutput = '';

    var oToday = new Date();
    oToday.setHours(0, 0, 0, 0);
    var aToday = {
        'date': oToday,
        'day': oToday.getDate(),
        'month': oToday.getMonth(),
        'year': oToday.getFullYear()
    };

    if (aIn['oField']['name'] == 'goDateHotel') {
        dayPlusOne = oToday.getDate() + 1;
        oToday = new Date(aToday['year'], aToday['month'], dayPlusOne);
    }
    if (aIn['oField']['name'] == 'returnDateHotel') {
        dayPlusTwo = oToday.getDate() + 2;
        oToday = new Date(aToday['year'], aToday['month'], dayPlusTwo);
    }

    /**
    var aSplitDateUser = vDateUser.split('/') ;
    var aDateUser = {
        'date' : vDateUser,
        'day' : parseInt(aSplitDateUser[0]),
        'month' : parseInt(aSplitDateUser[1]),
        'year' : parseInt(aSplitDateUser[2])
    };
    **/
    //var oDateUser = new Date(aDateUser['year'], (aDateUser['month'] - 1), aDateUser['day']) ;


    // Preparing the date to display in the calendar
    var aSplitDate = vDate.split('/');
    var aDate = {
        'date': vDate,
        'month': parseInt(aSplitDate[0], 10), // NICO 22-04
        'year': parseInt(aSplitDate[1], 10) // NICO 22-04
    };

    // Calculating the first day of the month for calendar display
    var vFirstDayNum = new Date(aDate['year'], (aDate['month'] - 1), 1).getDay();
    if (vFirstDayNum == 0) vFirstDayNum = 7;
    vDaysBefore = vFirstDayNum - 1;

    // Generating the month and year title in the calendar
    vOutput += '<div class="c-col xlsl-pan">';
    vOutput += '<p>' + getT(A_CAL_MONTHS[aDate['month']]) + ' ' + aDate['year'] + '</p>';
    vOutput += '<table>';
    vOutput += '<thead><tr>';


    for (var i = 1; i < 8; i++) vOutput += '<td>' + getT(A_CAL_DAYS[i]) + '</td>';
    vOutput += '</tr></thead>';

    // Calculating the number of days in the current month
    if (aDate['month'] == 1 || aDate['month'] == 3 || aDate['month'] == 5 || aDate['month'] == 7 || aDate['month'] == 8 || aDate['month'] == 10 || aDate['month'] == 12) vDaysInMonth = 31;
    else if (aDate['month'] == 4 || aDate['month'] == 6 || aDate['month'] == 9 || aDate['month'] == 11) vDaysInMonth = 30;
    else vDaysInMonth = (aDate['year'] % 4 == 0) ? 29 : 28;

    vOutput += '<tbody><tr>';

    // Generating the calendar cells with the days of the month
    for (i = 0; i < vDaysBefore; i++) vOutput += '<td></td>';

    var vDayNum = vFirstDayNum;
    vDayOff = true;

    for (i = 0; i < vDaysInMonth; i++) {

        vClass = '';
        vAction = '';
        vDay = i + 1;
        vClickable = true;

        vDateFull = XLWithZeroTen(vDay) + '/' + XLWithZeroTen(aDate['month']) + '/' + aDate['year'];

        vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: O_CAL_FIELD.getAttribute('data-date-min') });
        if (vDateComp == 'inf') vClass = ' c-off', vClickable = false;

        vDateComp = XLDateComp({ vDate: vDateFull, oDateComp: oToday });
        if (vDateComp == 'equal') vClass += ' c-today';

        vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: O_CAL_FIELD.value });
        if (vDateComp == 'equal') vClass = ' c-on';

        if (O_CAL_FIELD_FROM) {
            vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: O_CAL_FIELD_FROM.value });
            if (vDateComp == 'equal') vClass = ' c-on';
            if (O_CAL_FIELD_TO && vDateComp == 'sup' && O_CAL_FIELD_TO.value) vClass = ' c-range';
        }

        if (O_CAL_FIELD_TO) {
            vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: O_CAL_FIELD_TO.value });
            if (vDateComp == 'equal') vClass = ' c-on';
            if (vDateComp == 'sup' && O_CAL_FIELD_TO.value && O_CAL_FIELD_FROM.value) vClass = '';
            //FCalRange({vRange:'to',oField:O_CAL_FIELD_TO,vNameFrom:'n-date-go'}) ;
        }
        if (document.getElementsByClassName("c-search-multi").length > 0) {

            var vDatesInputs = document.querySelectorAll(".c-when .c-field:first-child input");
            var vDatesMulti = [];
            for (var k = 0; k < vDatesInputs.length; k++) {
                if (vDatesInputs[k].value != "") vDatesMulti[k] = vDatesInputs[k].value;
            }
            var vDateFirst = vDatesMulti[0]
            vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: vDateFirst });
            if (vDateComp == 'sup') vClass = 'c-range';
            var vDateLast = vDatesMulti[vDatesMulti.length - 1]
            vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: vDateLast });
            if (vDateComp == 'sup') vClass = '';
            for (var j = 0; j < vDatesMulti.length; j++) {
                vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: vDatesMulti[j] });
                if (vDateComp == 'equal') vClass = ' c-on';
            }
        }

        vDateComp = XLDateComp({ vDate: vDateFull, vDateComp: O_CAL_FIELD.getAttribute('data-date-max') });

        if (vDateComp == 'sup' || vDateComp == 'equal') {
            vClass = ' c-off';
            vClickable = false;
        }

        if (document.last.dates.indexOf(vDateFull) > -1 && !vClass.includes('c-off')) {
            vClass += ' c-direct';
        }

        if (vClickable) {
            vAction += ' onclick="FCalP({d:\'' + vDateFull + '\',vRange:\'' + aIn['vRange'] + '\',direct: ' + aIn['direct'] + '})" ';
            vAction += ' onmouseover="FCalO({o:this,d:\'' + vDateFull + '\'})" ';
        }

        if (vClass) vClass = 'class="' + vClass + '"';

        vOutput += '<td ' + vClass + ' ' + vAction + ' data-date="' + vDateFull + '"><em>' + vDay + '</em></td>';
        if (vDayNum == 7) vOutput += '</tr><tr>';
        vDayNum++;
        vDayNum %= 7;
        if (vDayNum == 0) vDayNum = 7;
    }

    vOutput += '</tr><tbody></table></div>';

    return vOutput;

}

function FCalO(aIn) {

    //O_CAL_FIELD.value = aIn['d'];

    var oCalendar = document.getElementById('i-search-when-calendar'),
        vCalenderRange = oCalendar.getAttribute('data-range');

    if (oCalendar) {
        if (vCalenderRange == 'to' && O_CAL_FIELD_FROM && O_CAL_FIELD_FROM.value != '') {

            aContEls = oCalendar.getElementsByTagName("td");
            for (var i = 0; i < aContEls.length; i++) {

                vDateFullTd = aContEls[i].getAttribute('data-date');
                vDateFullHover = aIn['o'].getAttribute('data-date');

                vDateCompA = XLDateComp({ vDate: vDateFullTd, vDateComp: vDateFullHover });
                vDateCompB = XLDateComp({ vDate: vDateFullTd, vDateComp: O_CAL_FIELD_FROM.value });

                if (vDateCompA == 'inf' && vDateCompB == 'sup') aContEls[i].classList.add('c-range');
                else aContEls[i].classList.remove('c-range');

            }

        }
        else if (vCalenderRange == 'from' && O_CAL_FIELD_TO && O_CAL_FIELD_TO.value != '') {

            aContEls = oCalendar.getElementsByTagName("td");
            for (var i = 0; i < aContEls.length; i++) {

                vDateFullTd = aContEls[i].getAttribute('data-date');
                vDateFullHover = aIn['o'].getAttribute('data-date');

                vDateCompA = XLDateComp({ vDate: vDateFullTd, vDateComp: vDateFullHover });
                vDateCompB = XLDateComp({ vDate: vDateFullTd, vDateComp: O_CAL_FIELD_TO.value });

                if (vDateCompA == 'sup' && vDateCompB == 'inf') aContEls[i].classList.add('c-range');
                else aContEls[i].classList.remove('c-range');

            }

        }
    }

}

function addDay(date, nbDays) {
    const [day, month, year] = date.split("/").map(Number);
    const initialDate = new Date(year, month - 1, day);
    initialDate.setDate(initialDate.getDate() + nbDays);

    const newDay = initialDate.getDate().toString().padStart(2, "0");
    const newMonth = (initialDate.getMonth() + 1).toString().padStart(2, "0");
    const newYear = initialDate.getFullYear();

    return `${newDay}/${newMonth}/${newYear}`;
}

function FCalP(aIn) {
    var oCalCont = document.getElementById('i-search-when-calendar');

    O_CAL_FIELD.value = aIn['d'];
    $(O_CAL_FIELD).change();
    var oCalField = O_CAL_FIELD;
    O_CAL_FIELD = false;
    FPopHide({ iPop: 'i-search-when-pop' });
    var searchMultiDestination = document.getElementsByClassName("c-search-multi");

    if (O_CAL_FIELD_TO && oCalCont.getAttribute('data-range') == 'from' && !O_CAL_FIELD_TO.getAttribute('disabled')) {
        const minDate = O_CAL_FIELD_TO.getAttribute('data-disable-same-date') === 'true' ? addDay(aIn['d'], 1) : aIn['d'];
        O_CAL_FIELD_TO.setAttribute('data-date-min', minDate);
        O_CAL_FIELD_TO.setAttribute('data-date-from', aIn['d']);

        aIn['dshort'] = aIn['d'].substr(3, 7);

        vDateComp = XLDateComp({ vDate: O_CAL_FIELD_FROM.value, vDateComp: O_CAL_FIELD_TO.value });

        if (vDateComp == 'sup')
            O_CAL_FIELD_TO.value = '';

        if (searchMultiDestination.length < 1)
            FCalRange({ vRange: 'to', oField: O_CAL_FIELD_TO, vNameFrom: 'n-date-go', vMonth: aIn['dshort'], vPClass: 'c-on', direct: aIn['direct'] });
    }

    if (document.getElementById('i-date-go-clone'))
        document.getElementById('i-date-go-clone').setAttribute('data-date-min', aIn['d']);

    if (document.getElementsByClassName("c-search-multi").length > 0) {
        aDates = document.querySelectorAll('#i-search-vols .c-when .c-field:first-child input');
        if (oCalField.getAttribute("name") == "goDate") {
            var num = 1;
            aDates[num].setAttribute('data-date-min', aIn['d']);
            aDates[num].value = "";
        }
        else {
            num = parseInt(oCalField.getAttribute("name").replace(/^\D+/g, ''));
            if (aDates[num]) {
                aDates[num].setAttribute('data-date-from', aIn['d']);
                aDates[num].value = "";
            }
        }
        for (var i = num; i < aDates.length; i++) {
            aDates[i].setAttribute('data-date-from', '');
            aDates[i].value = "";
        }
    }
}

// NICO function changed XLDateComp 24-04
function XLDateComp(aIn) {
    var oDate = false;
    var oDateComp = false;

    if (aIn['oDate']) {
        var oDate = aIn['oDate'];
    }
    else if (aIn['vDate']) {
        var aSDate = aIn['vDate'].split('/');
        if (aIn['vDate'] == 'today') {
            var oDate = new Date();
            oDate.setHours(0, 0, 0, 0);
        }
        else if (aIn['vDate'] == 'tomorrow') {
            var oDate = new Date(new Date().setDate(new Date().getDate() + 1));
            oDate.setHours(0, 0, 0, 0);
        }
        else if (/^in-\d+-days$/.test(aIn['vDate'])) {
            const days = parseInt(aIn['vDate'].match(/^in-(\d+)-days$/)[1]); // extract the int part which represents the number of days
            var oDate = new Date(new Date().setDate(new Date().getDate() + days));
            oDate.setHours(0, 0, 0, 0);
        } 
        else if (aIn['vDate'] == 'today-plus-year') {
            var oDate = new Date(new Date().setYear(new Date().getFullYear() + 1))
            oDate.setHours(0, 0, 0, 0);
        }
        else if (aSDate.length == 2) oDate = new Date(aSDate[1], aSDate[0] - 1, '01');
        else if (aSDate.length == 3) oDate = new Date(aSDate[2], aSDate[1] - 1, aSDate[0]);
    }

    if (aIn['oDateComp']) {
        var oDateComp = aIn['oDateComp'];
    }
    else if (aIn['vDateComp']) {
        var aSDateComp = aIn['vDateComp'].split('/');
        if (aIn['vDateComp'] == 'today') {
            var oDateComp = new Date();
            oDateComp.setHours(0, 0, 0, 0);
        }
        else if (aIn['vDateComp'] == 'tomorrow') {
            var oDateComp = new Date(new Date().setDate(new Date().getDate() + 1));
            oDateComp.setHours(0, 0, 0, 0);
        }
        else if (/^in-\d+-days$/.test(aIn['vDateComp'])) {
            const days = parseInt(aIn['vDateComp'].match(/^in-(\d+)-days$/)[1]); // extract the int part
            var oDateComp = new Date(new Date().setDate(new Date().getDate() + days));
            oDateComp.setHours(0, 0, 0, 0);
        } 
        else if (aIn['vDateComp'] == 'today-plus-year') {
            var oDateComp = new Date(new Date().setYear(new Date().getFullYear() + 1))
            oDateComp.setHours(0, 0, 0, 0);
        }
        else if (aSDateComp.length == 2) oDateComp = new Date(aSDateComp[1], aSDateComp[0] - 1, '01');
        else if (aSDateComp.length == 3) oDateComp = new Date(aSDateComp[2], aSDateComp[1] - 1, aSDateComp[0]);
    }

    if (oDate && oDateComp) {

        if (oDate.getTime() == oDateComp.getTime()) return 'equal';
        else if (oDate.getTime() < oDateComp.getTime()) return 'inf';
        else if (oDate.getTime() > oDateComp.getTime()) return 'sup';
        else return false;

    }

}

function XLWithZeroTen(vInt) {
    return parseInt(vInt, 10) < 10 ? '0' + parseInt(vInt, 10) : parseInt(vInt, 10); // NICO 15-04-22
}

function FSmoothPayment(aIn) {

    if (aIn['vClicked'] == '4x') FSmoothOpen({ iSmooth: 'i-smooth-payment-4x', vForce: 'open' });
    if (aIn['vClicked'] != '4x') FSmoothOpen({ iSmooth: 'i-smooth-payment-4x', vForce: 'close' });
}

function FSmoothPaymentB2B(aIn) {
    if (aIn['vClicked'] == 'option') FSmoothOpen({ iSmooth: 'i-smooth-payment-option', vForce: 'open' });
    if (aIn['vClicked'] != 'option') FSmoothOpen({ iSmooth: 'i-smooth-payment-option', vForce: 'close' });
}

/*******************************************************************************************************
FORM VALIDATION
********************************************************************************************************/
var V_TABINDEX = 0;



//A_ERRORS_CHECK['length'] = "Nombre de caractères insuffisant" ;

var A_ERRORS_SHAKE = new Array();
var A_ERRORS_CHECK = new Array();
function translateErrors() {
    A_ERRORS_CHECK['text'] = getT('airbooking.errorscheck.text');
    A_ERRORS_CHECK['name'] = getT('airbooking.errorscheck.text');
    A_ERRORS_CHECK['pax-same-name'] = getT('airbooking.errorscheck.PaxesSameName');
    A_ERRORS_CHECK['date'] = getT('airbooking.errorscheck.invaliddate');
    A_ERRORS_CHECK['date-short'] = getT('airbooking.errorscheck.invaliddate');
    A_ERRORS_CHECK['date-cb'] = getT('airbooking.errorscheck.invalidexpirationdate');
    A_ERRORS_CHECK['postcode'] = getT('airbooking.errorscheck.Invalidpostalcode');
    A_ERRORS_CHECK['booking-number'] = getT('airbooking.errorscheck.invalidbookingnumber');
    A_ERRORS_CHECK['numeric'] = getT('airbooking.errorscheck.pleaseenteronlynumbers');
    A_ERRORS_CHECK['phone'] = getT('airbooking.errorscheck.invalidphonenumber');
    A_ERRORS_CHECK['email'] = getT('airbooking.errorscheck.Invalidemail');
    A_ERRORS_CHECK['decimal'] = getT('airbooking.errorscheck.formatmustbedecimal');
    A_ERRORS_CHECK['alphanum'] = getT('airbooking.errorscheck.textandnumbers');
    A_ERRORS_CHECK['empty'] = getT('airbooking.errorscheck.Pleasefillout');
    A_ERRORS_CHECK['confirm'] = getT('airbooking.errorscheck.doesnot');
    A_ERRORS_CHECK['validated'] = getT('airbooking.errorscheck.fieldnotvalidated');
    A_ERRORS_CHECK['data-error'] = getT('airbooking.errorscheck.fieldnotvalidated');
    A_ERRORS_CHECK['invalid-char'] = getT('airbooking.errorscheck.invalidcharacter');
    A_ERRORS_CHECK['card'] = getT('airbooking.errorscheck.Invalidcardnumber');
    A_ERRORS_CHECK['date-min'] = getT('airbooking.errorscheck.invaliddate');
    A_ERRORS_CHECK['date-max'] = getT('airbooking.errorscheck.invaliddate');
    A_ERRORS_CHECK['date-bad-y'] = getT('airbooking.errorscheck.Incorrectbirthyear');

    A_ERRORS_SHAKE['date'] = getT('airbooking.errorscheck.pleaseonlyenternumbers');
    A_ERRORS_SHAKE['name'] = getT('airbooking.errorscheck.text');
    A_ERRORS_SHAKE['card'] = getT('airbooking.errorscheck.pleaseonlyenternumbers');
    A_ERRORS_SHAKE['date-cb'] = getT('airbooking.errorscheck.pleaseonlyenternumbers');
    A_ERRORS_SHAKE['postcode'] = getT('airbooking.errorscheck.numbersorletters');
}





function XLFormInit(aIn) {

    var oCont = document.getElementById(aIn['iCont']),
        aContEls = oCont.getElementsByTagName("*");

    for (var i = 0; i < aContEls.length; i++) {

        aContEls[i].classList.remove('c-field-ok');
        aContEls[i].classList.remove('c-field-ko');

        if (aContEls[i].tagName.toUpperCase() !== 'SVG' && aContEls[i].tagName.toUpperCase() !== 'USE' && aContEls[i].tagName.toUpperCase() !== 'PATH') {
            if ((aContEls[i].tagName == 'INPUT' || aContEls[i].tagName == 'SELECT' || aContEls[i].className.indexOf('c-field-select') != -1) && aContEls[i].getAttribute('tabindex') !== '0') {
                V_TABINDEX++;
                aContEls[i].setAttribute("tabIndex", V_TABINDEX);
                //aContEls[i].addEventListener("focus", function(){ XLFieldFocus(this)}) ;
                //aContEls[i].addEventListener("blur", function(){ XLFieldBlur(this)}) ;
            }

            if (aContEls[i].getAttribute('data-check')) {

                vDataValid = aContEls[i].getAttribute('data-check');
                aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")")));

                if (aDataValid['check']) {
                    aContEls[i].addEventListener("blur", function () { XLFieldCheck({ oObj: this }); });
                    if (!aContEls[i].getAttribute('data-mask'))
                        aContEls[i].addEventListener("focus", function () { XLLastChar({ oObj: this, fCallBack: XLFormValidShaker }) });
                }
            }

            if (aContEls[i].getAttribute('data-mask')) FMaskedInput({ oInput: aContEls[i] });
        }
    }
}

function XLFieldFocus(oObj) {
    //FErrorDestroy();
    var aTargetBounds = XLObjBounds({ myObj: oObj });
    if (A_CLIENT_WINDOW['device'] == 'touch') {
        XLScrollTo({ vLeft: 0, vTop: aTargetBounds['pageTop'] - 30 });
    }
    //oObj.parentNode.classList.add('c-on');
}

function XLFieldBlur(oObj) {
    oObj.parentNode.classList.remove('c-on');
}

function XLFormValidSearch() {
    if (window.autocompleteCache != null) {
        window.localStorage.setItem("autocomplete", JSON.stringify(window.autocompleteCache));
    }
    var vSearchType = document.getElementsByName('i-search-type')[0].value;
    var vAdults = document.getElementsByName('adults').length > 0 ? document.getElementsByName('adults')[0].value : 1;
    var vChilds = document.getElementsByName('childs').length > 0 ? document.getElementsByName('childs')[0].value : 0;
    var vInfants = document.getElementsByName('infants').length > 0 ? document.getElementsByName('infants')[0].value : 0;

    // Block internal flights in Metropolitan France
    if (window.site.partnerId == "airbus") {

       
        var legs = parseInt($('.c-segment .c-field').length);
        if (legs === 0) {
            legs = 1; //Warning ! 0 equals 1 !
        }


        var corsicaAirports = ['aja', 'bia', 'cly', 'fsc', 'prp', 'soz'];
        var segments = [];
        var firstMetropolitanRouteError = 0;
        var lastOriginKey, lastDestinationKey;
        for (var i = 1; i <= legs; i++) {
            if (i > 1) {
                lastOriginKey = 'origin-' + i + '_info';
                lastDestinationKey = 'destination-' + i + '_info';
            }
            else {
                lastOriginKey = 'origin_info';
                lastDestinationKey = 'destination_info';
            }
            var segment = {
                origin: JSON.parse(window.localStorage.getItem(lastOriginKey)),
                destination: JSON.parse(window.localStorage.getItem(lastDestinationKey)),
                metropolitan: false
            };

            //Warning, legs is sometimes wrong!
            if (segment.origin && segment.destination) {
                if ((segment.origin.country.toLowerCase() === 'fr' && corsicaAirports.includes(segment.origin.city.toLowerCase()) === false)
                    && (segment.destination.country.toLowerCase() === 'fr' && corsicaAirports.includes(segment.destination.city.toLowerCase()) === false)) {
                    if (!firstMetropolitanRouteError) {
                        firstMetropolitanRouteError = i;
                    }
                    segment.metropolitan = true;
                }
                // to log
                segments.push(segment);
            }
        }
        console.log("segments " + legs + " " + firstMetropolitanRouteError, segments);

        if (firstMetropolitanRouteError) {
            aVS = new Array();
            //donc on doit parer l'éventualité d'un mauvais index, pour ne pas afficher une erreur dans un objet qui n'existe pas
            var errorOrign;
            for (var i = firstMetropolitanRouteError; i >= 0; i--) {
                errorOrigin = document.getElementById(i > 1 ? 'i-where-origin-' + i : 'i-where-origin');
                if (errorOrigin != null) {
                    break;
                }
            }
            aVS['oObj'] = errorOrigin;

            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.blockinternalflightsinfrance');
            XLFormValidStyle(aVS);
            return false;
        }

    }

    if (vSearchType == 'roundTrip' || vSearchType == 'oneWay' || vSearchType == 'openJaw') {

        if (document.getElementById('i-where-origin').value == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementById('i-where-origin');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        if (document.getElementsByName('origin')[0].value == '')
            document.getElementsByName('origin')[0].value = document.getElementById('i-where-origin').value;

        if (document.getElementById('i-where-destination').value == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementById('i-where-destination');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        if (document.getElementsByName('destination')[0].value == '')
            document.getElementsByName('destination')[0].value = document.getElementById('i-where-destination').value;

        if (document.getElementById('i-where-origin').value == document.getElementById('i-where-destination').value) {

            aVS = new Array();
            aVS['oObj'] = document.getElementById('i-where-destination');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.choosecityaeroport');
            XLFormValidStyle(aVS);
            return false;

        }

        var vGoDate = document.getElementsByName('goDate')[0].value;

        if (vGoDate == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementsByName('goDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

    }

    if (vSearchType == 'openJaw') {
        var legs = parseInt($('.c-segment .c-field').length);

        for (var i = 2; i <= legs; i++) {
            if (document.getElementById('i-where-origin-' + i)) {
                if (document.getElementById('i-where-origin-' + i).value == '') {

                    aVS = new Array();
                    aVS['oObj'] = document.getElementById('i-where-origin-' + i);
                    aVS['vError'] = true;
                    aVS['vErrorCode'] = '';
                    aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
                    XLFormValidStyle(aVS);
                    return false;

                }
            }

            if (document.getElementsByName('goDate-' + i)[0]) {
                if (document.getElementsByName('goDate-' + i)[0].value == '') {

                    aVS = new Array();
                    aVS['oObj'] = document.getElementsByName('goDate-' + i)[0];
                    aVS['vError'] = true;
                    aVS['vErrorCode'] = '';
                    aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
                    XLFormValidStyle(aVS);
                    return false;

                }
            }

            if (document.getElementsByName('origin-' + i)[0]) {
                if (document.getElementsByName('origin-' + i)[0].value == '')
                    document.getElementsByName('origin-' + i)[0].value = document.getElementById('i-where-origin-' + i).value;
            }

            if (document.getElementById('i-where-destination-' + i)) {
                if (document.getElementById('i-where-destination-' + i).value == '') {

                    aVS = new Array();
                    aVS['oObj'] = document.getElementById('i-where-destination-' + i);
                    aVS['vError'] = true;
                    aVS['vErrorCode'] = '';
                    aVS['vErrorCustom'] = getT('airbooking.pleaseselectdestination');
                    XLFormValidStyle(aVS);
                    return false;

                }
            }

            if (document.getElementsByName('destination-' + i)[0] == '') {
                if (document.getElementsByName('destination-' + i)[0].value == '')
                    document.getElementsByName('destination-' + i)[0].value = document.getElementById('i-where-destination-' + i).value;
            }

            if (document.getElementById('i-where-origin-' + i) && document.getElementById('i-where-destination-' + i)) {
                if (document.getElementById('i-where-origin-' + i).value == document.getElementById('i-where-destination-' + i).value) {

                    aVS = new Array();
                    aVS['oObj'] = document.getElementById('i-where-destination-' + i);
                    aVS['vError'] = true;
                    aVS['vErrorCode'] = '';
                    aVS['vErrorCustom'] = 'Veuillez choisir une ville/aéroport de destination<br> différent de celui de départ';
                    XLFormValidStyle(aVS);
                    return false;

                }
            }
        }
    }

    if (vSearchType == 'roundTrip') {

        var vReturnDate = document.getElementsByName('returnDate')[0].value;

        if (vReturnDate == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementsByName('returnDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        vDateComp = XLDateComp({ vDate: vGoDate, vDateComp: vReturnDate });
        if (vDateComp == 'sup') {

            aVS = new Array();
            aVS['oObj'] = document.getElementsByName('returnDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.dateafterdeparture');
            XLFormValidStyle(aVS);
            return false;

        }

    }

    if (vSearchType == 'openJaw') {
        var legs = parseInt($('.c-segment .c-field').length);

        for (var i = 2; i <= legs; i++) {
            if (document.getElementsByName('goDate-' + i)[0]) {
                var vReturnDate = document.getElementsByName('goDate-' + i)[0].value;

                if (vReturnDate == '') {

                    aVS = new Array();
                    aVS['oObj'] = document.getElementsByName('goDate-' + i)[0];
                    aVS['vError'] = true;
                    aVS['vErrorCode'] = '';
                    aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
                    XLFormValidStyle(aVS);
                    return false;

                }
            }
            vDateComp = XLDateComp({ vDate: vGoDate, vDateComp: vReturnDate });
            if (vDateComp == 'sup') {

                aVS = new Array();
                aVS['oObj'] = document.getElementsByName('goDate-' + i)[0];
                aVS['vError'] = true;
                aVS['vErrorCode'] = '';
                aVS['vErrorCustom'] = getT('airbooking.thisdatemust');
                XLFormValidStyle(aVS);
                return false;

            }
        }
    }

    if (parseInt(vAdults, 10) + parseInt(vChilds, 10) + parseInt(vInfants, 10) > 9) {

        aVS = new Array();
        aVS['oObj'] = document.getElementById('i-travellers-text');
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('airbooking.adultforinfant');
        XLFormValidStyle(aVS);
        return false;

    }

    if (document.getElementById("i-search-who-field").hasAttribute("data-min") && parseInt(vAdults, 10) + parseInt(vChilds, 10) + parseInt(vInfants, 10) < parseInt(document.getElementById("i-search-who-field").getAttribute("data-min"), 10)) {

        aVS = new Array();
        aVS['oObj'] = document.getElementById('i-travellers-text');
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        if (document.getElementById("i-search-who-field").getAttribute("data-max") && document.getElementById("i-search-who-field").getAttribute("data-max") == 1 && document.getElementById("i-search-who-field").getAttribute("data-min") == 1) aVS['vErrorCustom'] = getT('homepage.searchform.selectonepax');
        else if (document.getElementById("i-search-who-field").getAttribute("data-min") == 1) aVS['vErrorCustom'] = '1 passager minimum';
        else if (document.getElementById("i-search-who-field").getAttribute("data-max") && document.getElementById("i-search-who-field").getAttribute("data-min") == document.getElementById("i-search-who-field").getAttribute("data-max")) aVS['vErrorCustom'] = getT('homepage.searchform.pleaseselect') + document.getElementById("i-search-who-field").getAttribute("data-max") + ' ' + getT('homepage.searchform.selectpassengers').toLowerCase();
        else aVS['vErrorCustom'] = document.getElementById("i-search-who-field").getAttribute("data-min") + ' passagers minimum';
        XLFormValidStyle(aVS);
        return false;
    }

    if (document.getElementById("i-search-who-field").hasAttribute("data-max") && parseInt(vAdults, 10) + parseInt(vChilds, 10) + parseInt(vInfants, 10) > parseInt(document.getElementById("i-search-who-field").getAttribute("data-max"), 10)) {

        aVS = new Array();
        aVS['oObj'] = document.getElementById('i-travellers-text');
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        if (document.getElementById("i-search-who-field").getAttribute("data-min") && document.getElementById("i-search-who-field").getAttribute("data-max") == 1 && document.getElementById("i-search-who-field").getAttribute("data-min") == 1) aVS['vErrorCustom'] = getT('homepage.searchform.selectonepax');
        else if (document.getElementById("i-search-who-field").getAttribute("data-max") == 1) aVS['vErrorCustom'] = '1 passager maximum';
        else if (document.getElementById("i-search-who-field").getAttribute("data-min") && document.getElementById("i-search-who-field").getAttribute("data-min") == document.getElementById("i-search-who-field").getAttribute("data-max")) aVS['vErrorCustom'] = getT('homepage.searchform.pleaseselect') + document.getElementById("i-search-who-field").getAttribute("data-max") + ' ' + getT('homepage.searchform.selectpassengers').toLowerCase();
        else aVS['vErrorCustom'] = document.getElementById("i-search-who-field").getAttribute("data-max") + ' passagers maximum';
        XLFormValidStyle(aVS);
        return false;
    }

    if (parseInt(vInfants, 10) > parseInt(vAdults, 10)) {

        aVS = new Array();
        aVS['oObj'] = document.getElementById('i-travellers-text');
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('airbooking.ninepassengermaximum');
        XLFormValidStyle(aVS);
        return false;

    }

    //no roundtrip, no upsell !
    if ($('#hid-upsell').length > 0 && vSearchType !== 'roundTrip') {
        $('#hid-upsell').remove();
    }

    if ($('#hid-upsell').length === 0 && vSearchType === 'roundTrip' && window.getUrlVars()["upsell"] === "true") {
        $("#i-search").append('<input id="hid-upsell" type="hidden" name="upsell" value="true" />');
    }

    //Params
    var params = window.getUrlVars();

    if (params['lastname']) {
        $("#i-search").append('<input type="hidden" name="lastname" value="' + decodeURIComponent(params['lastname']) + '" />');
    }

    if (params['firstname']) {
        $("#i-search").append('<input type="hidden" name="firstname" value="' + decodeURIComponent(params['firstname']) + '" />');
    }

    if (params['phone']) {
        $("#i-search").append('<input type="hidden" name="phone" value="' + decodeURIComponent(params['phone']) + '" />');
    }

    if (params['email']) {
        $("#i-search").append('<input type="hidden" name="email" value="' + decodeURIComponent(params['email']) + '" />');
    }

    if (params['birthdate']) {
        $("#i-search").append('<input type="hidden" name="birthdate" value="' + decodeURIComponent(params['birthdate'].replace(/\+/g, '%20')) + '" />');
    }

    if (params['title']) {
        $("#i-search").append('<input type="hidden" name="title" value="' + decodeURIComponent(params['title']) + '" />');
    }

    if (params['totalflex']) {
        $("#i-search").append('<input type="hidden" name="totalflex" value="' + decodeURIComponent(params['totalflex']) + '" />');
    }

    if (params['repatriation']) {
        $("#i-search").append('<input type="hidden" name="repatriation" value="' + decodeURIComponent(params['repatriation']) + '" />');
    }

    if (params['address']) {
        $("#i-search").append('<input type="hidden" name="address" value="' + decodeURIComponent(params['address']) + '" />');
    }

    if (params['zipcode']) {
        $("#i-search").append('<input type="hidden" name="zipcode" value="' + decodeURIComponent(params['zipcode']) + '" />');
    }

    if (params['city']) {
        $("#i-search").append('<input type="hidden" name="city" value="' + decodeURIComponent(params['city']) + '" />');
    }

    //GTM
    sendGtmEvent();

    document.getElementById('i-search-btn').classList.add('c-search-go');
    $("#i-search").trigger('submit');
    return false;
}


function XLFormValidFlighHotelSearch() {

    var vSearchType = document.getElementsByName('i-search-type')[0].value;

    if (vSearchType == 'roundTrip' || vSearchType == 'oneWay' || vSearchType == 'openJaw') {

        if (document.getElementById('i-where-origin').value == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementById('i-where-origin');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        if (document.getElementsByName('origin')[0].value == '')
            document.getElementsByName('origin')[0].value = document.getElementById('i-where-origin').value;

        if (document.getElementById('i-where-destination').value == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementById('i-where-destination');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        if (document.getElementsByName('destination')[0].value == '')
            document.getElementsByName('destination')[0].value = document.getElementById('i-where-destination').value;

        if (document.getElementById('i-where-origin').value == document.getElementById('i-where-destination').value) {

            aVS = new Array();
            aVS['oObj'] = document.getElementById('i-where-destination');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.choosecityaeroport');
            XLFormValidStyle(aVS);
            return false;

        }

        var vGoDate = document.getElementsByName('goDate')[0].value;

        if (vGoDate == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementsByName('goDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

    }

    if (vSearchType == 'roundTrip') {

        var vReturnDate = document.getElementsByName('returnDate')[0].value;

        if (vReturnDate == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementsByName('returnDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        vDateComp = XLDateComp({ vDate: vGoDate, vDateComp: vReturnDate });
        if (vDateComp == 'sup') {

            aVS = new Array();
            aVS['oObj'] = document.getElementsByName('returnDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.dateafterdeparture');
            XLFormValidStyle(aVS);
            return false;

        }

    }

    //GTM
    if (window.site.partnerId != "rakuten-dp")
        sendGtmEvent();
        
    return true;
}


function validSearchHotel() {

    // Search url can be define in config.xml file for Hotel
    var vSearchUrl = "http://misterfly.hresa.koedia.com";
    if (window.isDefined(window.urlHotel)) {
        if (window.site.type == 2)
            vSearchUrl = window.urlHotel["b2b"];
        else
            vSearchUrl = window.urlHotel["b2c"];
    }

    var vLng = 'fr'; // Todo : Get this from partner config

    /******************* Same validation of Flight search *******************/
    if (document.getElementById('i-where-destination-hotel').value == '') {

        aVS = new Array();
        aVS['oObj'] = document.getElementById('i-where-destination-hotel');
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('airbooking.selectanelement');
        XLFormValidStyle(aVS);
        return false;
    }
    if (document.getElementById('i-destination-hotel-input').value == '') {

        aVS = new Array();
        aVS['oObj'] = document.getElementById('i-where-destination-hotel');
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('airbooking.selectanelement');
        XLFormValidStyle(aVS);
        return false;
    }

    var vGoDate = document.getElementsByName('goDateHotel')[0].value;
    if (vGoDate == '') {

        aVS = new Array();
        aVS['oObj'] = document.getElementsByName('goDateHotel')[0];
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
        XLFormValidStyle(aVS);
        return false;
    }

    var vReturnDate = document.getElementsByName('returnDateHotel')[0].value;
    if (vReturnDate == '') {

        aVS = new Array();
        aVS['oObj'] = document.getElementsByName('returnDateHotel')[0];
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
        XLFormValidStyle(aVS);
        return false;
    }

    vDateComp = XLDateComp({ vDate: vGoDate, vDateComp: vReturnDate });
    if (vDateComp == 'sup') {

        aVS = new Array();
        aVS['oObj'] = document.getElementsByName('returnDateHotel')[0];
        aVS['vError'] = true;
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('airbooking.returndeparturedate');
        XLFormValidStyle(aVS);
        return false;

    }
    /*******************************************************************************/

    // For hotel search we should take exactly data returned by Autocomplete API and Selected by User to launch a search
    // Moreover, format depend on category selected
    if (document.getElementById('i-destination-hotel-input').value != '') {
        var vParams = document.getElementById('i-destination-hotel-input').value.split('|');   // value like category|source_id|name|longitude|latitude
        if (vParams.length > 0)
            switch (vParams[0]) {
                case "POLYGON":
                    vSearchUrl += "/redirect.htm?toPolygonCode=" + vParams[1] + "&";  // Ex: http://misterfly.hresa.koedia.com/redirect.htm?toPolygonCode=FR-Disneyland&startDate=20160907&endDate=20160908&nbAdults_room_1=1
                    break;
                case "HOTEL":
                    vSearchUrl += "/" + vParams[1] + "/hotel-" + vParams[2] + ".htm?";  // Must redirect directly on hotel page. Ex: http://misterfly.hresa.koedia.com/1669473/hotel-hipark_serris_val_deurope.htm?nbAdults_room_1=1
                    break;
                default:
                    vSearchUrl += "/redirect.htm?toAddressName=" + vParams[2] + "&lat=" + vParams[4] + "&lng=" + vParams[3] + "&";  // Ex: http://misterfly.hresa.koedia.com/redirect.htm?toAddressName=Paris,France&lat=48.856614&lng=2.3522219&startDate=20160907&endDate=20160908&nbAdults_room_1=1
                    break;
            }
        // warn: this can't work if we change format date from FR one dd/mm/yyyy => to replace by moment() later
        vFromDate = vGoDate.split('/');
        vToDate = vReturnDate.split('/');
        vSearchUrl += "&startDate=" + vFromDate[2] + vFromDate[1] + vFromDate[0] + "&endDate=" + vToDate[2] + vToDate[1] + vToDate[0] + "&lang=" + vLng;

        var vNbRooms = +document.getElementById('nbRoom').value;

        for (i = 1; i <= vNbRooms; i++) {
            vSearchUrl += "&nbAdults_room_" + i + "=" + document.getElementById('nbadultroom' + i).value + "&nbChilds_room_" + i + "=" + document.getElementById('nbchildroom' + i).value; // + "&childAge_room_1_1=2&childAge_room_1_2=6
            vSearchUrl += "&childAge_room_" + i + "_1=" + document.getElementById("childAge_room_" + i + "_1").value + "&childAge_room_" + i + "_2=" + document.getElementById("childAge_room_" + i + "_2").value + "&childAge_room_" + i + "_3=" + document.getElementById("childAge_room_" + i + "_3").value;
        }

        // Discount Code
        var cavg = document.getElementById('i-code-avantage');
        if (cavg) {
            var discountCode = cavg.value;
            if (discountCode && discountCode != '')
                vSearchUrl += "&discountCode=" + discountCode;
        }
        //AgentId
        if (window.site && window.site.loginInfo && window.site.loginInfo.Agent)
            vSearchUrl += "&mid=" + window.site.loginInfo.Agent.AgentId;

        // Save fields
        hotelHistory.saveSearch();
        // Redirect search
        window.location.href = vSearchUrl;
    }

    return false;
}

function isOpenJaw(itineraries) {
    return itineraries && itineraries.length === 2
        && (itineraries[0].origin.cityIATA.localeCompare(itineraries[1].destination.cityIATA) !== 0
            || itineraries[0].destination.cityIATA.localeCompare(itineraries[1].origin.cityIATA) !== 0);
}

function XLFormValid(aIn) {

    var oCont = document.getElementById(aIn['iCont']);
    if (oCont == null) {
        return true;
    }
    var aContEls = oCont.getElementsByTagName("*"),
        aErrors = new Array(),
        oFirstError = false,
        vStopErrors = false,
        i = 0;

    while (i < aContEls.length && vStopErrors == false) {

        if (aContEls[i].getAttribute('data-check')) {

            //console.log(aContEls.name + ' /// ') ;

            vDataValid = aContEls[i].getAttribute('data-check');
            aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")")));

            if (aDataValid['check']) {
                aFieldCheck = XLFieldCheck({ oObj: aContEls[i], vFormValid: true });
                if (aFieldCheck['vError'] == true) {
                    aErrors.push(aContEls[i]);
                    //aContEls[i].addEventListener("mousedown", function () { this.parentNode.classList.remove('c-field-ko') }, true) ;
                    vStopErrors = true;
                    aContEls[i].addEventListener("focus", function () { this.parentNode.classList.remove('c-field-ko') }, true);
                    //console.log(aContEls[i]) ;
                }
            }
        }
        i++;

    }

    if (aErrors.length > 0) {

        return false;

    } else {
        //Keep the dirty test that will never succeed. It's supposed to do so.
        //if (oCont.tagName && oCont.tagName.toLowerCase() == 'form') oCont.submit();
        if (oCont.tagName == 'form') oCont.submit();
        else return true;

    }

}
function B2B_XLFormValid(aIn) {

    //console.log(aIn) ;

    var oCont = document.getElementById(aIn['iCont']),
        aContEls = oCont.getElementsByTagName("*"),
        aErrors = new Array(),
        oFirstError = false,
        vStopErrors = false,
        i = 0;

    while (i < aContEls.length && vStopErrors == false) {

        if (aContEls[i].getAttribute('data-check')) {

            //console.log(aContEls.name + ' /// ') ;

            vDataValid = aContEls[i].getAttribute('data-check');
            aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")")));

            if (aDataValid['check']) {
                aFieldCheck = XLFieldCheck({ oObj: aContEls[i], vFormValid: true });
                if (aFieldCheck['vError'] == true) {
                    aErrors.push(aContEls[i]);
                    //aContEls[i].addEventListener("mousedown", function () { this.parentNode.classList.remove('c-field-ko') }, true) ;
                    vStopErrors = true;
                    aContEls[i].addEventListener("focus", function () { this.parentNode.classList.remove('c-field-ko') }, true);
                    //console.log(aContEls[i]) ;
                }
            }
        }
        i++;

    }

    if (aErrors.length > 0) {

        return false;

    } else {

        if (oCont.tagName && oCont.tagName.toLowerCase() == 'form') oCont.submit();
        else return true;

    }

}

function XLFieldCheck(aIn) {

    var oObj = aIn['oObj'];

    FErrorDestroy();

    var vDataValid = oObj.getAttribute('data-check'),
        isCheckEnabled = oObj.getAttribute('data-checkenabled'),
        aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")"))),
        vError = false,
        vErrorCode = '',
        vErrorCustom = '',
        vErrorMsg = '';
    vReg = true,
        oObjClass = oObj.parentNode,
        aReturn = new Array();

    isCheckEnabled = !(typeof isCheckEnabled !== 'undefined' && isCheckEnabled == "false");
    if (!isCheckEnabled)
        return true;

    // vValue = oObj.value || oObj.innerHTML,
    var vValue = oObj.value;
    if (oObj.className.indexOf('c-field-select') != -1 || oObj.className.indexOf('vc-select-control') != -1 || oObj.className.indexOf('c-new-field-select') != -1) {
        var vFieldName = oObj.id.substring(0, oObj.id.length - 5);
        vValue = document.getElementsByName(vFieldName)[0].value;
    }

    vValue = vValue.trim();

    var vCurrentDate = new Date();
    var vCurrentMonth = vCurrentDate.getMonth() + 1;
    var vCurrentYearFull = vCurrentDate.getFullYear();
    var vCurrentYear = vCurrentYearFull.toString().substring(2);
    if (vCurrentMonth < 10) { vCurrentMonth = '0' + vCurrentMonth; }

    if (aDataValid['thisor']) {

        vThisOrError = 1;
        if (vValue != '' || document.getElementById(aDataValid['thisor']).value != '') vThisOrError = 0;
        if (document.getElementById(aDataValid['thisor']).value != '' && vThisOrError == 0) vErrorCode = '';
        if (vThisOrError == 1) vErrorCode = 'thisor';

    }

    if (aDataValid['check'] == 'text') {
        vReg = /^([^0-9]*)$/.test(vValue);
        if (vReg == false) vErrorCode = 'text';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'date') {
        vReg = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/[0-9]{4}$/.test(vValue);
        if (vReg == false) vErrorCode = 'date';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'date-short') {
        vReg = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])$/.test(vValue);
        if (vReg == false) vErrorCode = 'date-short';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'date-cb') {
        aSplit = vValue.split("/");
        if (!isNaN(parseInt(aSplit[0], 10)) && !isNaN(parseInt(aSplit[1], 10))) {
            vDateComp = XLDateComp({ vDate: '01/' + parseInt(aSplit[0], 10) + '/20' + parseInt(aSplit[1], 10), vDateComp: '01/' + parseInt(vCurrentMonth, 10) + '/20' + parseInt(vCurrentYear, 10) });
            if (parseInt(aSplit[0], 10) == 0) vErrorCode = 'date-cb';
            else if (parseInt(aSplit[0], 10) > 12) vErrorCode = 'date-cb';
            else if (vDateComp == 'inf') vErrorCode = 'date-cb';
            else {
                vYearLimit = parseInt(vCurrentYear, 10) + 10;
                vDateComp = XLDateComp({ vDate: '01/' + parseInt(aSplit[0], 10) + '/20' + parseInt(aSplit[1], 10), vDateComp: '01/' + parseInt(vCurrentMonth, 10) + '/20' + vYearLimit });
                if (vDateComp == 'sup') vErrorCode = 'date-cb';
            }

        } else vErrorCode = 'date-cb';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'numeric') {
        vReg = /^[0-9]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'numeric';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'postcode') {
        if (document.getElementById("i-country") && document.getElementById("i-country").value == "FR") vReg = /^[0-9]+$/.test(vValue);
        else vReg = /^[0-9a-zA-Z -.]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'postcode';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'booking-number') {
        vReg = /^(T_)?\d{1,12}V?$/.test(vValue);
        if (vReg == false) vErrorCode = 'booking-number';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'phone') {
        //vReg = /^[0-9 -.]+$/.test(vValue);
        if (oObj.previousElementSibling) {
            phoneNumber = oObj.previousElementSibling.textContent.replace(/\s+/g, '') + vValue;
        } else {
            //warning
            /*phoneNumber = document.getElementById("i-phone-0").value.replace(/\s+/g, '') + vValue;*/
            //phoneNumber = document.getElementById(oObj.getAttribute('id').replace('phone', 'phonecode') + '-text').textContent.replace(/\s+/g, '') + vValue;
            phoneNumber = document.getElementById(oObj.getAttribute('id').replace('phone', 'phone-codes') + '-text').textContent.replace(/\s+/g, '') + vValue;
        }
        vReg = libphonenumber.isValidNumber(phoneNumber);
        if (vReg == true) oObj.value = libphonenumber.parse(phoneNumber).phone;
        else if (vReg == false) vErrorCode = 'phone';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'simplephone') {
        vReg = /^[0-9]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'phone';
    }
    else if (aDataValid['min'] && vValue < aDataValid['min']) {
        vErrorCode = 'min';
        vErrorCustom = 'Veuillez saisir un nombre supérieur à ' + aDataValid['min'];
    }
    else if (aDataValid['max'] && vValue > aDataValid['max']) {
        vErrorCode = 'max';
        vErrorCustom = 'Veuillez saisir un nombre inférieur à ' + aDataValid['max'];
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'card') {
        //vReg = /^[0-9 ]+$/.test(vValue);
        //if (vReg == false) vErrorCode = 'card' ;
        if (document.getElementsByName('i-card-type')[0].value) {
            vCardCheck = FCardCheck(vValue, document.getElementsByName('i-card-type')[0].value);
            if (vCardCheck == false) vErrorCode = 'card';
        }
        else {
            vErrorCode = 'card';
        }
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'email') {
        vReg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(vValue);
        if (vReg == false) vErrorCode = 'email';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'decimal') {
        vReg = /^[0-9.,]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'decimal';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'alphanum') {
        vReg = /^[0-9a-zA-Z' \-àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'alphanum';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'name') {
        vReg = /^([^0-9&µ#"`()\?!\§<>|$£€!@={}°~.^_\\\/:,;%+*\[\]]*)$/.test(vValue);
        if (vReg == false) vErrorCode = 'alphanum';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'name-paxinfo') {
        var paxes = [];
        var paxesLen = document.getElementsByClassName("c-paxinfo").length;
        if (paxesLen > 1) {
            var completeInfo = false;
            for (var i = 0; i < paxesLen; i++) {
                var currentPax = document.getElementById("i-paxinfo-" + i);
                var firstname = currentPax.getElementsByClassName("paxinfo-firstname")[0].value;
                var lastname = currentPax.getElementsByClassName("paxinfo-lastname")[0].value;
                if (firstname != "" && lastname != "") {
                    paxes.push({
                        id: i,
                        firstname: firstname,
                        lastname: lastname
                    });
                    completeInfo = true;
                }
                else completeInfo = false;
            }
        }
        vReg = /^([^0-9&µ#"`()\?!\§<>|$£€!@={}°~.^_\\\/:,;%+*\[\]]*)$/.test(vValue);

        var partnersToNotTestSpecialCharacters = ["cnas", "servair", "cnasdomtom", "adosspp"];
        if (!partnersToNotTestSpecialCharacters.contains(window.partnerName)) {
            var regexOnlyCharacters = /^[A-Za-z ]*[A-Za-z ][A-Za-z ]*$/;
            vReg = regexOnlyCharacters.test(vValue);
        }

        if (vReg == false) vErrorCode = 'name';

        //forbid few specific values
        if (vReg === true) {
            if (forbiddenNames.isForbidden(vValue, window.site.type)) {
                vErrorCode = 'pax-name';
                vErrorCustom = getT('airbooking.forbiddenname').format(vValue);
            }
        }
    }

    if (aDataValid['thisor']) {

        vThisOrError = 1;
        if (vValue != '' || document.getElementById(aDataValid['thisor']).value != '') vThisOrError = 0;
        if (document.getElementById(aDataValid['thisor']).value != '' && vThisOrError == 0) vErrorCode = '';
        if (vThisOrError == 1) vErrorCode = 'thisor';

    }

    if (aDataValid['check'] == 'required' && !aDataValid['thisor'] && (!vValue || vValue == '&nbsp;')) vErrorCode = 'empty';
    if (aDataValid['check'] && aDataValid['check'] != 'data-error' && !aDataValid['thisor'] && (!vValue || vValue == '&nbsp;')) vErrorCode = 'empty';
    if (aDataValid['confirm'] && vValue.toUpperCase() != document.getElementById(aDataValid['confirm']).value.toUpperCase()) vErrorCode = 'confirm';
    if (aDataValid['validated'] == true && !oObj.getAttribute('data-validated')) vErrorCode = 'validated';
    if (aDataValid['check'] == 'data-error' && oObj.getAttribute('data-error')) vErrorCode = 'data-error';
    if (aDataValid['length'] && vValue.length < aDataValid['length']) {
        vErrorCode = 'length';
        vErrorCustom = getT('airbooking.pleaseenterminimum') + ' ' + aDataValid['length'] + ' ' + getT('airbooking.characters');
    }
    if (aDataValid['maxlength'] && vValue.length > aDataValid['maxlength']) {
        vErrorCode = 'maxlength';
        vErrorCustom = getT('airbooking.entermaximum') + ' ' + aDataValid['maxlength'] + ' ' + getT('airbooking.characters');
    }

    if (aDataValid['noForbiddenCharacter']) {
        if (vValue.indexOf(';') != -1 || vValue.indexOf(',') != -1) {
            vErrorCode = 'forbidden character';
            vErrorCustom = "L'adresse ne doit pas contenir de point virgule ni de virgule";
        }
    }

    if (aDataValid['complexPassword']) {
        var hasNumber = /[0-9]+/.test(vValue);
        var hasUpperChar = /[A-Z]+/.test(vValue);
        var hashMinimum8Chars = /.{8,}/.test(vValue);
        var hasLowerChar = /[a-z]+/.test(vValue);
        var hasSymbols = /[!@#$%^&*()_+=\[{\]};:<>|./?,-]/.test(vValue);

        var isComplexPassword = hasNumber && hasUpperChar && hashMinimum8Chars && hasLowerChar && hasSymbols;
        if (!isComplexPassword) {
            vErrorCode = 'password not complex enough';
            vErrorCustom = getT("b2bresetpassword.entercomplexpasswordwarning");
        }
    }

    //alert(vErrorCode) ;

    if (oObj.getAttribute('data-mask')) {
        var vDataMask = oObj.getAttribute('data-mask'),
            aDataMask = JSON.parse(JSON.stringify(eval("(" + vDataMask + ")")));
        if (aDataMask['vFormat'] == vValue) vErrorCode = 'empty';
    }

    if (vErrorCode == '' && aDataValid['check'] == 'date') {
        if (aDataValid['date_min'] && aDataValid['date_min'] != '') {
            var aDateUser = vValue.split("/");
            var vDateUser = new Date(aDateUser[2], aDateUser[1], aDateUser[0]);
            var vDateAfter = new Date(aDataValid['date_min']);
            var aDateAfter = aDataValid['date_min'].split("/");
            var vDateAfter = new Date(aDateAfter[2], aDateAfter[1], aDateAfter[0]);
            if (vDateUser < vDateAfter) vErrorCode = 'date-min';
            //console.log(aDateUser + ' > ' + vError + ' : ' + vDateUser + ' > ' + vDateAfter) ;
        }
        if (aDataValid['date_max'] && aDataValid['date_max'] != '') {
            var aDateUser = vValue.split("/");
            var vDateUser = new Date(aDateUser[2], aDateUser[1], aDateUser[0]);
            //var vDateUser = new Date(vValue);
            var aDateBefore = aDataValid['date_max'].split("/");
            var vDateBefore = new Date(aDateBefore[2], aDateBefore[1], aDateBefore[0]);
            if (vDateUser > vDateBefore) vErrorCode = 'date-max';
            //console.log(aDateUser + ' > ' + vError + ' : ' + vDateUser + ' > ' + vDateBefore) ;
        }
        if (aDataValid['birthday'] && aDataValid['birthday'] == true) {
            var aDateUser = vValue.split("/");
            if (aDateUser[2] > vCurrentYearFull) vErrorCode = 'date-bad-y';
        }
    }

    vError = (vErrorCode == '') ? false : true;

    if (!aIn['vFormValid'] && aDataValid['nolive']) {
        vError = false;
        vErrorCode = '';
        return false;
    }
    if (aDataValid['optional'] && aDataValid['optional'] == true && vValue == '') {
        vError = false;
        vErrorCode = '';
        return false;
    }

    //if (vValue)
    if ((aIn['oObj'].className.indexOf('c-field-select') != -1 || aIn['oObj'].className.indexOf('c-new-field-select') != -1) && vError == true && !aIn['vFormValid']) {
    } else {
        aVS = new Array();
        aVS['oObj'] = oObj;
        aVS['vError'] = vError;
        aVS['vErrorCode'] = vErrorCode;
        if (vErrorCustom != '') aVS['vErrorCustom'] = vErrorCustom;
        XLFormValidStyle(aVS);
    }

    aReturn['vError'] = vError;
    aReturn['vErrorCode'] = vErrorCode;
    //console.log(aReturn) ;
    return aReturn;

}

function XLFormValidShaker(oObj, vChar, LastVal) {

    var vDataValid = oObj.getAttribute('data-check'),
        aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")"))),
        vReg = true,
        vErrorCode = '';

    //if (aDataValid['check'] == 'text') vReg = /^[a-zA-Z \-àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]+$/.test(vChar);
    //else if (aDataValid['check'] == 'decimal') vReg = /^[0-9.,]+$/.test(vChar);
    //else if (aDataValid['check'] == 'numeric') vReg = /^[0-9]+$/.test(vChar);

    var vValue = vChar;

    if (aDataValid['check'] == 'text') {
        vReg = /^([^0-9]*)$/.test(vValue);
        if (vReg == false) vErrorCode = 'text';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'name') {
        vReg = /^([^0-9&µ#"`()\?!\§<>|$£€!@={}°~.^_\\\/:,;%+*\[\]]*)$/.test(vValue);
        if (vReg == false) vErrorCode = 'name';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'date') {
        vReg = /^([0-9]*)$/.test(vValue);
        if (vReg == false) vErrorCode = 'date';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'numeric') {
        vReg = /^[0-9]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'numeric';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'phone') {
        vReg = /^[0-9]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'phone';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'decimal') {
        vReg = /^[0-9.,]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'decimal';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'card') {
        vReg = /^[0-9]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'card';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'date-cb') {
        vReg = /^[0-9]+$/.test(vValue);
        if (vReg == false) vErrorCode = 'date-cb';
    }
    else if (vErrorCode == '' && aDataValid['check'] == 'alphanum') {
        var regexOnlyCharactersAndNumbers = /^[A-Za-z0-9 ]*[A-Za-z0-9 ][A-Za-z0-9 ]*$/;
        vReg = regexOnlyCharactersAndNumbers.test(vValue);
        if (vReg == false) vErrorCode = 'alphanum';
    }

    vError = (vErrorCode == '') ? false : true;

    FErrorDestroy();

    if (!vReg) {
        //XLClassAnim({ oObj: oObj, vParent: true, vClass: 'c-ani-shake', vTime: 150 });
        //console.log(XLCaretGetPos(oObj));

        vCaretGetPos = XLCaretGetPos(oObj);

        oObj.value = LastVal;
        V_LASTCHAR_BEFORE = oObj.value;

        aVS = new Array();
        aVS['oObj'] = oObj;
        aVS['vError'] = vError;
        aVS['vErrorCode'] = vErrorCode;
        XLFormValidStyle(aVS);
        if (vErrorCode == 'alphanum') {
            oObj.parentNode.classList.remove('c-field-ok');
            oObj.parentNode.classList.remove('c-field-ko');
        }
        XLCaretSetPos({ oObj: oObj, vPos: vCaretGetPos - 1 });
    } else {
        oObj.parentNode.classList.remove('c-field-ok');
        oObj.parentNode.classList.remove('c-field-ko');
    }

}


function FErrorShow(aIn) {
    FErrorDestroy();

    var aTargetBounds = XLObjBounds({ myObj: aIn['oObj'] });
    if (A_CLIENT_WINDOW['device'] == 'touch' || aIn['vScrollTo']) // NICO 15-04-20
        XLScrollTo({ vLeft: 0, vTop: aTargetBounds['pageTop'] - 30 });

    var oObjError = document.createElement("span");
    //var oObjErrorIn = document.createElement("div");
    oObjError.className = 'c-microcopy';
    oObjError.id = 'i-field-error';
    oObjError.style.color = '#cc2908';
    oObjError.style.display = 'inline-block';
    //oObjErrorIn.innerHTML = 'Erreur sur ce champ';

    //console.log(aIn['vErrorCode'] + ' > ' + aIn['oObj'].outerHTML);

    if (aIn['oObj'].getAttribute('data-error-' + aIn['vErrorCode'])) oObjError.innerHTML = aIn['oObj'].getAttribute('data-error-' + aIn['vErrorCode']);
    else if (aIn['vErrorCustom']) oObjError.innerHTML = aIn['vErrorCustom'];
    else oObjError.innerHTML = A_ERRORS_CHECK[aIn['vErrorCode']];

    // TEST AFFICHAGE ERREUR
    /*$('#' + $(aIn['oObj']).attr('id') + '-microcopy').text(oObjErrorIn.innerHTML).css('display','inline-block');*/

    //oObjError.appendChild(oObjErrorIn);
    //console.log(aTargetBounds) ;
    //console.log(oFirstError) ;
    //oFirstError.parentNode.parentNode.parentNode.insertBefore(oObjError,oFirstError.parentNode.parentNode) ;
    var oDiv = aIn['oObj'].closest('div');
    var oFor;
    if (oDiv.classList.contains('c-new-field-phone')) {
        oFor = oDiv.querySelectorAll('label')[1].getAttribute('for');
        $(oDiv).next('span#' + oFor + '-microcopy' + ':visible').hide();
        oDiv.parentNode.appendChild(oObjError);
    } else {
        oFor = oDiv.querySelector('label').getAttribute('for');
        $(oDiv).find('span#' + oFor + '-microcopy' + ':visible').last().hide();
        oDiv.appendChild(oObjError);
    }
    
    var aErrorBounds = XLObjBounds({ myObj: oObjError });

    //if (aIn['vShiftLeft']) vShiftLeft = aIn['vShiftLeft'];
    //else vShiftLeft = 0;

    //var computedLeft = aTargetBounds['pageLeft'] + (aTargetBounds['width'] / 2) - (aErrorBounds['width'] / 2) - 10 + vShiftLeft;
    //if (computedLeft > 0) {
    //    oObjError.style.left = computedLeft + 'px';
    //}
    //oObjError.style.top = aTargetBounds['pageBottom'] + 5 + 'px';
    XLClassAnim({ oObj: oObjError, vClass: 'c-ani-shake', vTime: 450 });

    oObjError.addEventListener("click", function () { FErrorDestroy(); });
    aIn['oObj'].addEventListener("click", function () { FErrorDestroy(); });

    $(document).trigger('input-error', [aIn.oObj], $('#i-field-error').text());

}

function FErrorDestroy() {

    oFieldError = document.getElementById('i-field-error');
    if (oFieldError) {
        var oFor = oFieldError.parentElement.querySelector('label').getAttribute('for');
        $(oFieldError.parentElement).find('span#' + oFor + '-microcopy' + ':hidden').last().show();
        oFieldError.parentElement.removeChild(oFieldError);
    } 

}

function XLFormValidStyle(aIn) {

    var grandParent = aIn['oObj'].parentNode.parentNode;

    aIn['oObj'].parentNode.classList.remove('c-field-ok');
    aIn['oObj'].parentNode.classList.remove('c-field-ko');
    //TEST GESTION ERREUR
    aIn['oObj'].parentNode.classList.remove('c-new-field-ok');
    aIn['oObj'].parentNode.classList.remove('c-new-field-ko');
    //Phone specific
    if (grandParent.classList.contains('c-new-field-phone')) {
        grandParent.classList.remove('c-new-field-ok');
        grandParent.classList.remove('c-new-field-ko');
    }

    if (aIn['vError'] == true) {
        console.log("1 --- aIn['vError'] == true");
        XLClassAnim({ oObj: aIn['oObj'].parentNode, vParent: false, vClass: 'c-ani-shake', vTime: 450 });
        aIn['oObj'].parentNode.classList.add('c-field-ko');
        aIn['oObj'].parentNode.classList.add('c-new-field-ko');
        if (grandParent.classList.contains('c-new-field-phone')) {
            grandParent.classList.add('c-new-field-ko');
        }
        aIn['vScrollTo'] = true;
        FErrorShow(aIn);
    }
    else if (aIn['vError'] == false) {
        console.log("2 --- aIn['vError'] == false");
        if (aIn['oObj'].value != '' && aIn['disabledOkStyle'] !== true) {
            console.log(" 2.5 ---- aIn['oObj'].value != ''");
            aIn['oObj'].parentNode.classList.add('c-field-ok');
            aIn['oObj'].parentNode.classList.add('c-new-field-ok');
            if (grandParent.classList.contains('c-new-field-phone')) {
                grandParent.classList.add('c-new-field-ok');
            }
        }
        //TEST RETRAIT MESSAGE ERREUR
        /*$('#' + $(aIn['oObj']).attr('id') + '-microcopy').text('').css('display', 'none');*/
    }
    else if (aIn['vError'] == 'nostyle') {
        console.log("3 ---- aIn['vError'] == false");
        XLClassAnim({ oObj: aIn['oObj'].parentNode, vParent: false, vClass: 'c-ani-shake', vTime: 450 });
        FErrorShow(aIn);
    }

}

var V_CHARS_BEFORE = '';
var V_LASTCHAR_BEFORE = '';


function FCheck(oObj) {
    oObj.addEventListener("keydown", function () { XLLastChar({ oObj: this, fCallBack: XLFormValidShaker }) });
}

function XLLastChar(aIn) {

    var vChar,
        oObj = aIn['oObj'];

    if (oObj.tagName != 'INPUT') return false;

    var V_LASTCHAR_BEFORE = oObj.value,
        aCharsBefore = V_LASTCHAR_BEFORE.split('');

    //if (!oObj.getAttribute('data-lastchar')) {
    oObj.addEventListener("keyup", function () { XLTrueCharProc(this) }, true);
        //oObj.addEventListener("keydown", function () { XLTrueCharProc(this,aIn) }, true);
        //oObj.addEventListener("keypress", function () { XLTrueCharProc(this,aIn) }, true);
        //oObj.setAttribute('data-lastchar', '');
    //}
    function XLTrueCharProc(oObj) {

        var vObjValue = oObj.value,
            aCharsAfter = vObjValue.split(''),
            aCharsBefore = V_LASTCHAR_BEFORE.split(''),
            aCharsAfterL = aCharsAfter.length;

        //if (vObjValue == V_LASTCHAR_BEFORE) return false;
        //if (vObjValue.length < V_LASTCHAR_BEFORE.length) return false;

        for (var i = 0; i < aCharsAfterL; i++) {

            //console.log(vObjValue + ' / ' + V_LASTCHAR_BEFORE + ' = ' + aCharsAfter[i] + ' / ' + aCharsBefore[i]) ;
            if (aCharsAfter[i] != aCharsBefore[i] || !aCharsBefore[i]) {
                vChar = aCharsAfter[i].toLowerCase();
                //console.log(vChar);
                oObj.setAttribute('data-lastchar', vChar);
                //console.log('vChar : ' + vChar) ;
                if (aIn['fCallBack']) eval(aIn['fCallBack'](oObj, vChar, V_LASTCHAR_BEFORE));
                V_LASTCHAR_BEFORE = oObj.value;
                break;
            }
        }
    }
    return vChar;
}



function FMaskedInput(aIn) {

    var oInput = aIn['oInput'] || document.getElementById(aIn['iInput']),
        vDataMask = oInput.getAttribute('data-mask'),
        aDataMask = JSON.parse(JSON.stringify(eval("(" + vDataMask + ")")));

    oInput.addEventListener("focus", FMaskedInputOn);
    oInput.addEventListener("focus", function () { oInput.select(); });

    //**************************************************************************************************************************************
    ///Modify by AGSW for the web
    function FMaskedInputOn() {

        if (!oInput.getAttribute('data-mask-on')) {
            MaskedInput({
                preserve: false,                    // Required For Web
                elm: oInput,
                onfilled: function () {
                    //var hidden = document.getElementById(oInput.getAttribute('data-name'));
                    //console.log(hidden);
                    //hidden.value = oInput.value;
                    $(oInput).change();             // Required For Web
                },
                format: aDataMask['vFormat'],
                onbadkey: function () {
                    //ShakeShake({ elm: document.getElementById('ex-1') });
                    //oInput.parentNode.classList.add('c-ani-shake') ;
                    //XLClassAnim({ oObj: oInput, vParent: true, vClass: 'c-ani-shake', vTime: 150 });

                    vErrorCustom = A_ERRORS_CHECK['invalid-char'];
                    if (oInput.getAttribute('data-check')) {
                        var vDataValid = oInput.getAttribute('data-check'),
                            aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")")));
                        if (A_ERRORS_SHAKE[aDataValid['check']]) vErrorCustom = A_ERRORS_SHAKE[aDataValid['check']];
                    }

                    aVS = new Array();
                    aVS['oObj'] = oInput;
                    aVS['vError'] = true;
                    aVS['vErrorCode'] = 'invalid-char';
                    aVS['vErrorCustom'] = vErrorCustom;
                    XLFormValidStyle(aVS);

                }, badkeywait: 400
            });

        }
        oInput.setAttribute('data-mask-on', true);
        oInput.setAttribute('maxlength', aDataMask['vFormat'].length); // NICO 15-04-22
    }
    //**************************************************************************************************************************************

}

function XLCaretSetPos(aIn) {
    var elem = aIn['oObj'];
    var caretPos = aIn['vPos'];

    if (elem != null) {
        if (elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        }
        else {
            if (elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}

function XLCaretGetPos(oField) {

    // Initialize
    var iCaretPos = 0;

    // IE Support
    if (document.selection) {

        // Set focus on the element
        oField.focus();

        // To get cursor position, get empty selection range
        var oSel = document.selection.createRange();

        // Move selection start to 0 position
        oSel.moveStart('character', -oField.value.length);

        // The caret position is selection length
        iCaretPos = oSel.text.length;
    }

    // Firefox support
    else if (oField.selectionStart || oField.selectionStart == '0')
        iCaretPos = oField.selectionStart;

    // Return results
    return (iCaretPos);
}


/** SLIDER ***/

function XLRangeSlider(aIn) {

    var aDraggers = new Array();
    var oSlider = aIn['oSlider'] || document.getElementById(aIn['iSlider']);
    var vChild = aIn['oSlider'] ? true : false;
    var onSlide = aIn['onSlideCallBack'] || function () { };

    var vMinDrag = aIn['vMinDrag'] ? aIn['vMinDrag'] : aIn['vMin']; // NICO ADDED 2015-04-07
    var vMaxDrag = aIn['vMaxDrag'] ? aIn['vMaxDrag'] : aIn['vMax']; // NICO ADDED 2015-04-07

    if (oSlider == null)
        return;

    aSliderBounds = XLObjBounds({ myObj: oSlider });

    var vDown = false,
        vSliderWidth = aSliderBounds['width'] - 5,
        vSliderLeft = aSliderBounds['pageLeft'];

    if (!vChild) {

        var oSliderBg = document.createElement("div");
        oSliderBg.classList.add('c-slider-bg');
        oSlider.appendChild(oSliderBg);

        var oSliderBgColor = document.createElement("div");
        oSliderBgColor.classList.add('c-slider-bgc');
        oSlider.appendChild(oSliderBgColor);

        var oSliderZone = document.createElement("div");
        oSliderZone.classList.add('c-slider-zone');
        oSlider.appendChild(oSliderZone);

    }

    var oSliderBgColor = oSlider.getElementsByClassName('c-slider-bgc')[0];

    var oDragger = document.createElement("div");
    oDragger.classList.add('c-slider-dr');
    oSlider.appendChild(oDragger);

    if (aIn['vDual']) {
        var aInChild = new Array();
        aInChild['oSlider'] = oSlider;
        aInChild['vInputName'] = aIn['vInputName'];
        aInChild['vDefault'] = aIn['vDefault'];
        XLRangeSlider(aInChild);
    }

    var oValue = document.createElement("div");
    oValue.classList.add('c-slider-value');
    oSlider.appendChild(oValue);

    var oInput = document.createElement("input");
    oInput.setAttribute('type', 'hidden');
    oInput.classList.add('c-slider-input');
    oSlider.appendChild(oInput);

    if (!vChild) {
        oDragger.setAttribute('data-slider', 0);
        oInput.setAttribute('name', aIn['vInputDualName']);
        if (!aIn['vInputDualName']) oInput.setAttribute('name', aIn['vInputName']);
    }
    else {
        oDragger.setAttribute('data-slider', 1);
        oInput.setAttribute('name', aIn['vInputName']);
    }

    var vMin = aIn['vMin'] || 0, vMax = aIn['vMax'] || 100;

    if (aIn['vMinShow'] && !vChild) {
        var oMinShow = document.createElement("div");
        oMinShow.classList.add('c-slider-min');
        oMinShow.innerHTML = vMin;
        oSlider.appendChild(oMinShow);
    }

    if (aIn['vMaxShow'] && !vChild) {
        var oMaxShow = document.createElement("div");
        oMaxShow.classList.add('c-slider-max');
        oMaxShow.innerHTML = vMax;
        oSlider.appendChild(oMaxShow);
    }

    var vRangeLength = vMax - vMin;
    //console.log(vMin + ' > ' + vMax + ' = ' + vRangeLength) ;

    var aDraggerBounds = XLObjBounds({ myObj: oDragger });
    var vDraggerWidth = aDraggerBounds['width'] - 5;
    oDragger.style.marginTop = -(oDragger.offsetHeight / 2) - 3 + 'px';
    //oValue.style.marginTop = - (oDragger.offsetHeight) - oValue.offsetHeight - 10 + 'px' ;
    //if (!aIn['vDefault']) aIn['vDefault'] = vMin ;

    vDraggerPos = 0;
    if (aIn['vDefault'] !== false) {
        vDraggerPosPct = Math.round(((aIn['vDefault'] - vMin) / vRangeLength) * 100);
        vDraggerPos = Math.round(((vDraggerPosPct / 100) * vSliderWidth) - (vDraggerWidth / 2));
        //console.log('vDraggerPosPct : ' + vDraggerPosPct) ;
        oSlider.getElementsByClassName('c-slider-dr')[0].style.left = vDraggerPos + 'px';
        aIn['vDefaultText'] = aIn['vDefault'];
        if (aIn['vText']) aIn['vDefaultText'] = aIn['vText'].replace('{VAL}', aIn['vDefault']);
    }
    if (aIn['vDefaultDual'] !== false) {
        vDraggerPosPct = Math.round(((aIn['vDefaultDual'] - vMin) / vRangeLength) * 100);
        vDraggerPos = Math.round(((vDraggerPosPct / 100) * vSliderWidth) - (vDraggerWidth / 2));
        //console.log('vDraggerPosPct : ' + vDraggerPosPct) ;
        if (oSlider.getElementsByClassName('c-slider-dr')[1])
            oSlider.getElementsByClassName('c-slider-dr')[1].style.left = vDraggerPos + 'px';
        aIn['vDefaultDualText'] = aIn['vDefaultDual'];
        if (aIn['vText']) aIn['vDefaultDualText'] = aIn['vText'].replace('{VAL}', aIn['vDefaultDual']);
    }

    if (aIn['vText']) {
        aIn['vDefaultText'] = aIn['vText'].replace('{VAL}', aIn['vDefault']);
    }

    if (aIn['vDual']) {
        oSlider.getElementsByClassName('c-slider-value')[0].innerHTML = aIn['vDefaultText'];
        oSlider.getElementsByClassName('c-slider-value')[1].innerHTML = aIn['vDefaultDualText'];
        oSlider.getElementsByClassName('c-slider-input')[0].setAttribute('value', aIn['vDefault']);
        oSlider.getElementsByClassName('c-slider-input')[1].setAttribute('value', aIn['vDefaultDual']);
    } else {
        oSlider.getElementsByClassName('c-slider-value')[0].innerHTML = aIn['vDefaultText'];
        oSlider.getElementsByClassName('c-slider-input')[0].value = aIn['vDefault'];
    }

    aDraggers = oSlider.getElementsByClassName('c-slider-dr');
    XLRangeSliderEffect();

    oSlider.addEventListener("mousedown", function (e) { XLRangeSliderStart(e); });
    oSlider.addEventListener("touchstart", function (e) { XLRangeSliderStart(e); });
    document.addEventListener("mousemove", function (e) { if (vDown) XLRangeSliderMove(e); });
    document.addEventListener("touchmove", function (e) { if (vDown) XLRangeSliderMove(e); });
    document.addEventListener("mouseup", function () { if (onSlide && vDown) onSlide(); vDown = false; });
    document.addEventListener("touchend", function () { if (onSlide && vDown) onSlide(); vDown = false; });

    function XLRangeSliderStart(e) {

        oTarget = XLObjTarget(e);
        var oTargetDr = false;
        vPageX = e.pageX || e.changedTouches[0].pageX;

        aSliderBounds = XLObjBounds({ myObj: oSlider });
        vSliderWidth = aSliderBounds['width'] - 5;
        vSliderLeft = aSliderBounds['pageLeft'];

        //if (oTarget.className == 'c-slider-bg' || oTarget.className == 'c-slider-bgc' || oTarget.className == 'c-slider-dr' || oTarget.className == 'c-slider-zone') {

        // IE9 Fix : we have to use indexOf
        if (oTarget.className.indexOf("c-slider-bg") != -1 || oTarget.className.indexOf("c-slider-bgc") != -1 || oTarget.className.indexOf("c-slider-dr") != -1 || oTarget.className.indexOf("c-slider-zone") != -1) {

            oSliderTemp = oTarget.parentNode;
            vDistance = 99999999;
            aSliderTempEls = oSliderTemp.getElementsByTagName('div');
            vSliderTempsLen = aSliderTempEls.length;
            for (var h = 0; h < vSliderTempsLen; ++h) {

                //if (aSliderTempEls[h].className == 'c-slider-dr') {
                if (aSliderTempEls[h].className.indexOf("c-slider-dr") != -1) {

                    vSliderClick = vPageX - vSliderLeft;
                    var vDiff = parseInt(aSliderTempEls[h].style.left) - vSliderClick;
                    if (vDiff < 0) vDiff = vDiff * -1;
                    //console.log(vDiff + ' > ' + vPageX + ' > ' + parseInt(aSliderTempEls[h].offsetLeft)) ;

                    if (vDiff < vDistance) {
                        vDistance = vDiff;
                        oTargetDr = aSliderTempEls[h];
                    }

                }
            }

            oDragger = oTargetDr;
            vDraggerNum = oTargetDr.getAttribute('data-slider');
            oValue = oSlider.getElementsByClassName('c-slider-value')[vDraggerNum];
            oInput = oSlider.getElementsByClassName('c-slider-input')[vDraggerNum];

            /**
            aSliderBounds = XLObjBounds({ myObj: oSlider });
            vSliderWidth = aSliderBounds['width'] - 5;
            vSliderLeft = aSliderBounds['pageLeft'];
            **/
            //console.log('vDown') ;

            vDown = true;
            XLRangeSliderMove(e);
        }
        e.preventDefault();
    }

    function XLRangeSliderMove(e) {

        console.log('XLRangeSliderMove');

        e.preventDefault();
        vPageX = e.pageX || e.changedTouches[0].pageX;

        //console.log(vPageX + ' > ' + vSliderLeft + ' > ' + vSliderWidth) ;

        if (vDown && vPageX >= vSliderLeft && vPageX <= (vSliderLeft + vSliderWidth)) {

            vPct = (Math.round(((vPageX - vSliderLeft) / vSliderWidth) * 100));
            vReturn = Math.round((vPct / 100) * vRangeLength + vMin);
            var vEffect = 0;

            //console.log(vReturn) ;

            if (vReturn >= vMinDrag && vReturn <= vMaxDrag) { // NICO ADDED 2015-04-07

                oDragger.style.left = vPageX - vSliderLeft - ((vDraggerWidth / 2)) + 'px';
                if (aDraggers.length == 2 && vDraggerNum == 0 && (parseInt(oDragger.style.left) >= parseInt(aDraggers[1].style.left) - vDraggerWidth)) {
                    oDragger.style.left = parseInt(aDraggers[1].style.left) - vDraggerWidth - 6 + 'px';
                    return false;
                }
                else if (aDraggers.length == 2 && vDraggerNum == 1 && (parseInt(oDragger.style.left) <= parseInt(aDraggers[0].style.left) + vDraggerWidth)) {
                    oDragger.style.left = parseInt(aDraggers[0].style.left) + vDraggerWidth + 6 + 'px';
                    return false;
                }


            } // NICO ADDED 2015-04-07
            else if (vReturn < vMinDrag) {
                oDragger.style.left = ((vSliderWidth / vRangeLength) * vMinDrag) - ((vDraggerWidth / 2)) + 'px';
            }
            else if (vReturn > vMaxDrag) {
                oDragger.style.left = ((vSliderWidth / vRangeLength) * vMaxDrag) - ((vDraggerWidth / 2)) + 'px';
            }

            if ((vReturn >= vMinDrag && vReturn <= vMaxDrag) || vReturn < vMinDrag || vReturn > vMaxDrag) {

                XLRangeSliderEffect();

                vReturnNew = vReturn;
                if (vReturn < vMinDrag) vReturnNew = vMinDrag;
                else if (vReturn > vMaxDrag) vReturnNew = vMaxDrag;

                if (oValue) {
                    vReturnText = vReturnNew;
                    if (aIn['vText']) vReturnText = aIn['vText'].replace('{VAL}', vReturnNew);
                    oValue.innerHTML = vReturnText;
                    oInput.value = vReturnNew;
                    $(oInput).trigger("change");
                }

            }

        }
        e.preventDefault();
    }

    function XLRangeSliderEffect() {

        if (oSliderBgColor) {
            if (aDraggers.length == 2) {

                oSliderBgColor.style.marginLeft = parseInt(aDraggers[0].style.left) + (vDraggerWidth / 2) + 'px';
                oSliderBgColor.style.width = parseInt(aDraggers[1].style.left) - parseInt(aDraggers[0].style.left) + 'px';

                oSliderValA = oSlider.getElementsByClassName('c-slider-value')[0];
                oSliderValB = oSlider.getElementsByClassName('c-slider-value')[1];

                oSliderValA.style.left = parseInt(aDraggers[0].style.left) + ((vDraggerWidth) / 2) - (oSliderValA.offsetWidth / 2) + 'px';
                if (oSliderValB)
                    oSliderValB.style.left = parseInt(aDraggers[1].style.left) + ((vDraggerWidth) / 2) - (oSliderValB.offsetWidth / 2) + 'px';

            }
            else {
                oSliderBgColor.style.width = parseInt(aDraggers[0].style.left) + ((vDraggerWidth) / 2) + 10 + 'px';
                oSliderValA = oSlider.getElementsByClassName('c-slider-value')[0];
                oSliderValA.style.left = parseInt(aDraggers[0].style.left) + ((vDraggerWidth) / 2) - (oSliderValA.offsetWidth / 2) + 'px';
            }
        }

    }

}

function XLInsertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function FTempShowPops() {

    console.log(A_POPS);

}


//XLClassAnim({oObj:xxx,vClass:'c-class',vTime:100}) ;
function XLClassAnim(aIn) {

    var oObj = aIn['oObj'];
    if (aIn['vParent']) oObj = oObj.parentNode;
    if (oObj) {
        var vClass = aIn['vClass'] ? aIn['vClass'] : 'c-ani-shake';
        var vTime = aIn['vTime'] ? aIn['vTime'] : 100;
        oObj.classList.add(vClass);
        window.setTimeout(function () {
            oObj.classList.remove(vClass);
        }, vTime);
    }
}

function stopDefAction(e) {
    e.preventDefault();
}

//**************************************************************************************************************************************
function FSWhat(val, mode) {

    var tripType = val;

    if (val != undefined && val != null)
        tripType = val.toLowerCase();

    oWhenReturn = document.getElementsByName('returnDate')[0];
    oWhenField = document.getElementById("i-search-when-fieldset");
    oWhenGo = document.getElementsByName('goDate')[0];
    oSearch = document.getElementById('i-search');
    oSearchFieldsetsClone = document.getElementById('i-search-fieldsets-clone');
    aSearchFieldsetsClone2 = document.getElementById('i-search-fieldsets-clone-2');

    if (document.getElementsByClassName("c-remove-flight") && document.getElementsByClassName("c-remove-flight").length != 0)
        removeByClass("c-remove-flight");

    if (document.getElementById("i-field-error"))
        document.getElementById("i-field-error").click();

    oCieBack = document.getElementById("i-company-retour");
    oSchedTimeBack = document.getElementById("i-horaires-retour");

    if (tripType == 'oneway') {
        if (document.getElementById("switchDest"))
            document.getElementById("switchDest").style.display = "block";
        if (document.getElementById("totallegs"))
            document.getElementById("totallegs").value = 1;

        oWhenReturn.setAttribute('disabled', 'disabled');
        oWhenField.classList.add("return-disabled");
        oWhenReturn.parentNode.classList.add('c-disabled');
        oSearch.classList.remove('c-search-multi');
        oWhenReturn.removeAttribute('data-check');

        if (oCieBack)
            oCieBack.removeAttribute('data-check');

        if (oSchedTimeBack)
            oSchedTimeBack.removeAttribute('data-check');
    }
    else {
        if (oWhenReturn) {
            oWhenReturn.removeAttribute('disabled');
            oWhenField.classList.remove("return-disabled");
            oWhenReturn.parentNode.classList.remove('c-disabled');
            oWhenReturn.setAttribute('data-check', JSON.stringify({ check: 'date' })); // NICO ADDED 15-04-08
            if (oCieBack) oCieBack.setAttribute('data-check', JSON.stringify({ check: 'required' }));
            if (oSchedTimeBack) oSchedTimeBack.setAttribute('data-check', JSON.stringify({ check: 'required' }));
        }

        if (tripType == "roundtrip") {
            if (document.getElementById("switchDest"))
                document.getElementById("switchDest").style.display = "block";
            if (document.getElementById("totallegs"))
                document.getElementById("totallegs").value = 2;

            aInTemp = new Array();
            aInTemp['vRange'] = 'from';
            aInTemp['oField'] = oWhenGo;
            aInTemp['vNameTo'] = 'returnDate';
            aInTemp['vPClass'] = 'c-on';
            aInTemp['iLoft'] = 'parent';
            oWhenGo.removeAttribute('onfocus');
            oWhenGo.addEventListener("focus", function () { FCalRange(aInTemp); });

            if (oWhenGo.value != '') {
                oWhenReturn.setAttribute('data-date-min', oWhenGo.value);
                O_CAL_FIELD_FROM = oWhenGo;
            }
        }

        if (tripType == 'openjaw') { // Required For Web
            if (document.getElementById("switchDest")) {
                document.getElementById("switchDest").style.display = "none";
                document.getElementById("switchDest").classList.remove("show");
            }

            oSearch.classList.add('c-search-multi');
            oWhenReturn.setAttribute('disabled', 'disabled');
            oWhenReturn.removeAttribute('data-check'); // NICO 15-04-17
            document.querySelectorAll('#i-search-when-fieldset label')[0].innerHTML = getT('homepage.searchform.date');

            oSearchWhereFieldset = document.getElementById('i-search-where-fieldset');
            oSearchWhenFieldset = document.getElementById('i-search-when-fieldset');

            var oSearchWhereFieldsetClone = oSearchWhereFieldset.cloneNode(true);
            oSearchWhereFieldsetClone.id = 'i-search-where-fieldset-2';

            var oSearchWhenFieldsetClone = oSearchWhenFieldset.cloneNode(true);
            oSearchWhenFieldsetClone.id = 'i-search-when-fieldset-2';

            oSearchWhenFieldset.children[0].getElementsByTagName("input")[0].setAttribute("onfocus", "FCalRange({vRange:'from',oField:this,vNameTo:'goDate-2',vPClass:'c-on',iLoft:'parent'})");


            aSearchWhereFieldsetClone = oSearchWhereFieldsetClone.getElementsByTagName('*'),
                setSearchFieldsAttr(aSearchWhereFieldsetClone, aSearchWhereFieldsetClone.length, 2);

            aSearchWhenFieldsetClone = oSearchWhenFieldsetClone.getElementsByTagName('*'),
                setSearchFieldsAttr(aSearchWhenFieldsetClone, aSearchWhenFieldsetClone.length, 2);

            oSearchFieldsetsClone = document.createElement("div");
            oSearchFieldsetsClone.appendChild(oSearchWhereFieldsetClone);
            oSearchFieldsetsClone.appendChild(oSearchWhenFieldsetClone);
            oSearchFieldsetsClone.id = 'i-search-fieldsets-clone';
            oSearchFieldsetsClone.classList.add("fieldsets-clone");

            oSearchAddFieldsets = document.createElement("fieldset");
            oSearchAddFieldsets.id = "i-add-flight";
            oSearchAddFieldEl = document.createElement("div");
            oSearchAddFieldEl.classList.add("c-field");
            oSearchAddFieldEl.setAttribute("onclick", "FSWhat('openJaw','add');");
            //cannot use getT when dictionnary is not loaded yet. Add a ng-i18next directive as attribute to get the key anyway
            oSearchAddFieldEl.setAttribute("ng-i18next", "[html]airbooking.addtrajet");
            oSearchAddFieldEl.innerHTML = "<span>" + getT('airbooking.addtrajet') + "</span>";
            //if (!(window.partnerName == "adp" || window.partnerName == "adpmobile"))   // Solucion temporal para no mostrar el Ajouter en ADP
            oSearchAddFieldsets.appendChild(oSearchAddFieldEl);

            oSearchRemoveFieldsets = document.createElement("fieldset");
            oSearchRemoveFieldsets.classList.add("c-remove-flight");
            oSearchRemoveFieldEl = document.createElement("div");
            oSearchRemoveFieldEl = document.createElement("div");
            oSearchRemoveFieldEl.classList.add("c-field");
            oSearchRemoveFieldEl.innerHTML = "<span class='d-sm-none'>" + getT("airbooking.removetrajet") + "</span>";
            oSearchRemoveFieldEl.setAttribute("onclick", "FSWhat('openJaw','remove');");
            oSearchRemoveFieldsets.appendChild(oSearchRemoveFieldEl);

            if (!document.getElementById("i-search-fieldsets-clone")) {
                XLInsertAfter(oSearchFieldsetsClone, oSearchWhenFieldset);
                XLInsertAfter(oSearchAddFieldsets, oSearchFieldsetsClone);
                whereElSelect = document.getElementsByClassName("c-where");

                for (var i = 0; i < whereElSelect.length; ++i) {
                    oSearchSegmentNumber = document.createElement("fieldset");
                    oSearchSegmentNumber.id = "i-segment-number-" + (i + 1);
                    oSearchSegmentNumber.classList.add("c-segment");
                    oSearchSegmentNumberEl = document.createElement("div");

                    oSearchSegmentNumberElS = document.createElement("span");
                    oSearchSegmentNumberElS.classList.add("c-field");
                    oSearchSegmentNumberElS.setAttribute("style", "width:auto !important;");
                    oSearchSegmentNumberElS.setAttribute("ng-i18next", "[html]homepage.searchform.flight");
                    //oSearchSegmentNumberElS.innerHTML = getT('homepage.searchform.flight');
                    oSearchSegmentNumberElS.innerHTML = getT("homepage.searchform.flight") + "&nbsp" + (i + 1);
                    //oSearchSegmentNumberElN = document.createElement("span");
                    //oSearchSegmentNumberElN.classList.add("c-field");
                    //oSearchSegmentNumberElN.setAttribute("style", "width:auto !important;margin-left:5px;");
                    //oSearchSegmentNumberElN.innerHTML = (i + 1);
                    oSearchSegmentNumberEl.appendChild(oSearchSegmentNumberElS);
                    //oSearchSegmentNumberEl.appendChild(oSearchSegmentNumberElN);

                    if (!(window.partnerName == "adp" || window.partnerName == "adpmobile"))   // Solucion temporal para no mostrar el Ajouter en ADP
                    {
                        oSearchSegmentNumber.appendChild(oSearchSegmentNumberEl);
                        whereElSelect[i].insertBefore(oSearchSegmentNumber, whereElSelect[i].firstChild);
                    }
                }
                oWhenGoBis = document.getElementsByName('goDate-2')[0];
                oWhenGoBis.setAttribute("onfocus", "FCalRange({vRange:'to',oField:this,vNameFrom:'goDate',vPClass:'c-on',iLoft:'parent'})");
                oWhenGoBis.setAttribute('data-date-min', document.getElementsByName("goDate")[0].value);
                oWhenGoBis.setAttribute('onchange', 'setMinDates(this)');
            }
            else if (mode == 'add') {
                fieldsetsClone = document.getElementsByClassName("fieldsets-clone");
                var fieldsetsCloneLen = fieldsetsClone.length;
                lastEl = fieldsetsClone[fieldsetsCloneLen - 1];
                prevDestVal = lastEl.querySelector(".c-where .c-field-destination input").value;
                prevDestHideVal = lastEl.querySelector(".c-where .c-field-destination input[type=hidden]").value;

                if (!document.getElementById("i-add-flights-wrapper")) {
                    oAddFlightsWrapper = document.createElement("div");
                    oAddFlightsWrapper.id = 'i-add-flights-wrapper';
                    insertAfter(oAddFlightsWrapper, lastEl);
                }

                if (fieldsetsCloneLen < window.multiDestinationMaxLegNumber - 1) {
                    if (document.getElementById("totallegs"))
                        document.getElementById("totallegs").value = Number(fieldsetsCloneLen) + 2;

                    var oSearchWhereFieldsetCloneNew = oSearchWhereFieldset.cloneNode(true);
                    oSearchWhereFieldsetCloneNew.id = 'i-search-where-fieldset-' + (fieldsetsCloneLen + 2);
                    var oSearchWhenFieldsetCloneNew = oSearchWhenFieldset.cloneNode(true);
                    oSearchWhenFieldsetCloneNew.id = 'i-search-when-fieldset-' + (fieldsetsCloneLen + 2);
                    oSearchFieldsetsCloneNew = document.createElement("div");
                    oSearchFieldsetsCloneNew.appendChild(oSearchWhereFieldsetCloneNew);
                    oSearchFieldsetsCloneNew.appendChild(oSearchWhenFieldsetCloneNew);

                    oSearchFieldsetsCloneNew.id = 'i-search-fieldsets-clone-' + (fieldsetsCloneLen + 1);
                    oSearchFieldsetsCloneNew.classList.add("fieldsets-clone");
                    oAddFlightsWrapper.appendChild(oSearchFieldsetsCloneNew);

                    aSearchWhereFieldsetCloneNew = oSearchWhereFieldsetCloneNew.getElementsByTagName('*'),
                        setSearchFieldsAttr(aSearchWhereFieldsetCloneNew, aSearchWhereFieldsetCloneNew.length, fieldsetsCloneLen + 2);

                    aSearchWhenFieldsetCloneNew = oSearchWhenFieldsetCloneNew.getElementsByTagName('*'),
                        setSearchFieldsAttr(aSearchWhenFieldsetCloneNew, aSearchWhenFieldsetCloneNew.length, fieldsetsCloneLen + 2);

                    oSearchFieldsetsCloneNew.querySelector(".c-where .c-field-origin input").value = prevDestVal;
                    oSearchFieldsetsCloneNew.querySelector(".c-where .c-field-origin input[type=hidden]").value = prevDestHideVal;
                    aSegmentsNumber = document.getElementsByClassName("c-segment");
                    if (!(window.partnerName == "adp" || window.partnerName == "adpmobile"))
                        aSegmentsNumber[fieldsetsCloneLen + 1].innerHTML = "<div class='c-field'> " + getT("homepage.searchform.flight") + " " + (fieldsetsCloneLen + 2) + "</div>";

                    if (fieldsetsCloneLen == window.multiDestinationMaxLegNumber - 2)
                        document.getElementById("i-add-flight").classList.add("disabled");

                    oWhenGoBisNew = document.getElementsByName('goDate-' + (fieldsetsCloneLen + 2))[0];
                    oWhenGoBisPrev = document.getElementsByName('goDate-' + (fieldsetsCloneLen + 1))[0];
                    oWhenGoBisNew.setAttribute("onfocus", "FCalRange({vRange:'to',oField:this,vNameFrom:'goDate-" + (fieldsetsCloneLen + 1) + "',vPClass:'c-on',iLoft:'parent'})");
                    oWhenGoBisNew.setAttribute('data-date-min', oWhenGoBisPrev.value);
                    oWhenGoBisNew.setAttribute('data-date-from', oWhenGoBisPrev.value);
                    oWhenGoBisNew.value = "";
                    oWhenGoBisNew.setAttribute('onchange', 'setMinDates(this)');
                }

                lastEl = fieldsetsClone[fieldsetsCloneLen];
                lastEl.appendChild(oSearchRemoveFieldsets);

                // Fixe de la destination_info de la ligne précédente qui n'est pas clonée
                // Curieux indice supérieur à ce qu'il devrait, mais pas touche à là haut
                var newIndex = parseInt(document.getElementById("totallegs").value, 10) - 1;
                var lastIndex = newIndex - 1;
                var lastDestinationKey = 'destination_info';
                if (lastIndex > 1) {
                    lastDestinationKey = 'destination-' + lastIndex + '_info';
                }
                var newOriginKey = 'origin_info';
                if (newIndex > 1) {
                    newOriginKey = 'origin-' + newIndex + '_info';
                }
                window.localStorage.setItem(newOriginKey, window.localStorage.getItem(lastDestinationKey));
             }
            else if (mode == 'remove') {
                fieldsetsClone = document.getElementsByClassName("fieldsets-clone");
                var fieldsetsCloneLen = fieldsetsClone.length;
                if (fieldsetsCloneLen >= 2) {
                    oAddFlightsWrapper.removeChild(oAddFlightsWrapper.lastChild);
                    if (fieldsetsCloneLen > 2) fieldsetsClone[fieldsetsCloneLen - 2].appendChild(oSearchRemoveFieldsets);

                    if (document.getElementById("totallegs")) document.getElementById("totallegs").value = fieldsetsCloneLen;
                }
                if (document.getElementById("i-add-flight").classList.contains("disabled")) document.getElementById("i-add-flight").classList.remove("disabled");
            }
        }
    }

    if (tripType != 'openjaw') {
        if (oSearch) {
            if (document.getElementById("switchDest"))
                document.getElementById("switchDest").style.display = "block";

            oSearch.classList.remove('c-search-multi');
            oSearchSegmentNum = document.getElementsByClassName("c-segment")[0];
            oSearchAddFlight = document.getElementById("i-add-flight");
            oSearchAddFlightWrapper = document.getElementById("i-add-flights-wrapper");
            if (oWhenGo.nextElementSibling)
                oWhenGo.nextElementSibling.innerHTML = getT('homepage.searchform.dep');

            if (oSearchFieldsetsClone)
                oSearchFieldsetsClone.parentNode.removeChild(oSearchFieldsetsClone);

            if (oSearchSegmentNum)
                oSearchSegmentNum.parentNode.removeChild(oSearchSegmentNum);

            if (oSearchAddFlight)
                oSearchAddFlight.parentNode.removeChild(oSearchAddFlight);

            if (oSearchAddFlightWrapper)
                oSearchAddFlightWrapper.parentNode.removeChild(oSearchAddFlightWrapper);
        }
    }

    oSearchBlock = document.getElementById('i-search');
    aSearchBlock = oSearchBlock.getElementsByTagName('*');
    vSearchBlockLength = aSearchBlock.length;

    for (var i = 0; i < vSearchBlockLength; ++i) {
        if (aSearchBlock[i].getAttribute('tabindex')) aSearchBlock[i].setAttribute('tabindex', i);
    }
}

function setMinDates(aIn) {
    var currentDateIndex = aIn.getAttribute("name").match(/\d+/g).map(Number)[0];
    var currentDate = $("[name='goDate-" + currentDateIndex + "']").val();
    var nextDate = $("[name='goDate-" + (currentDateIndex + 1) + "']");
    nextDate.attr("data-date-min", currentDate);
}
//**************************************************************************************************************************************

//**************************************************************************************************************************************
///Modify by AGSW for the web
// We split the function in two so we have a refresh function to fill the search form on the products view
function FSelectMPG(aIn) {
    
    var myObj = aIn['myObj'],
        vValue = FSelectMP({ e: aIn['e'], myObj: myObj });
    FSelectMPG_Refresh();
}
function FSelectMPGMasstock(aIn) {

    var myObj = aIn['myObj'],
        vValue = FSelectMP({ e: aIn['e'], myObj: myObj });
    FSelectMPGMasstock_Refresh(aIn['id']);
}
function FSelectMPG_Refresh() {

    var oText = document.getElementById('i-travellers-text');
    var oSelectMPG = document.getElementById('i-select-mpg');

    if (oSelectMPG) {

        var aInputs = oSelectMPG.getElementsByTagName('input');
        var aOutput = new Array();
        var vTotal = 0;
        var vTotalAdult = 0;
        var vTotalBaby = 0;
        var oSearchWhoField = document.getElementById('i-search-who-field');
        var oSelectMPGErr = document.getElementById('i-select-mpg-err');

        //myObj.addEventListener("mousedown", function(e) { XLObjTarget(e) ;} );

        for (i = 0; i < aInputs.length; i++) {
            vInputVal = aInputs[i].value;
            if (i == 0 && vInputVal == 1) aOutput.push(getT('homepage.oneadulte')), vTotalAdult = vTotalAdult + parseInt(vInputVal);
            else if (i == 0 && vInputVal > 1) aOutput.push(vInputVal + ' ' + getT('homepage.adults')), vTotalAdult = vTotalAdult + parseInt(vInputVal);
            else if (i == 1 && vInputVal == 1) aOutput.push(getT('homepage.onechild'));
            else if (i == 1 && vInputVal > 1) aOutput.push(vInputVal + ' ' + getT('homepage.children'));
            else if (i == 2 && vInputVal == 1) aOutput.push(getT('homepage.oneinfant')), vTotalBaby = vTotalBaby + parseInt(vInputVal);
            else if (i == 2 && vInputVal > 1) aOutput.push(vInputVal + ' ' + getT('homepage.infants')), vTotalBaby = vTotalBaby + parseInt(vInputVal);
            vTotal = vTotal + parseInt(vInputVal);
        }
        //console.log(vTotal) ;

        if (oSelectMPGErr)
            oSelectMPGErr.classList.remove('c-show');
        if (oSearchWhoField)
            oSearchWhoField.removeAttribute('data-error');
        //oSelectMPGErr.classList.remove('c-ani-shake') ;

        if (vTotal > 9) {
            oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = getT('airbooking.maximumpassenger');
            oSearchWhoField.setAttribute('data-error', getT('airbooking.maximumpassenger'));
            oSelectMPGErr.classList.add('c-show');
            //oSelectMPGErr.classList.add('c-ani-shake') ;
            XLClassAnim({ oObj: oSelectMPGErr, vClass: 'c-ani-shake', vTime: 500 });

        }

        if (oSearchWhoField.hasAttribute("data-max")) {
            maxPax = oSearchWhoField.getAttribute("data-max");
            oWhoPop = document.getElementById("i-search-who-pop");
            aPaxPlusBtn = oWhoPop.getElementsByClassName("c-p");
            if (vTotal > maxPax) {

                var errorMessage = getT('airbooking.maximumpassenger').replace(/[0-9]/, maxPax);

                if (maxPax == 1) {
                    oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = errorMessage;
                    oSearchWhoField.setAttribute('data-error', errorMessage);
                }
                else if (maxPax > 1) {
                    oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = errorMessage;
                    oSearchWhoField.setAttribute('data-error', errorMessage);
                }
                oSelectMPGErr.classList.add('c-show');
                XLClassAnim({ oObj: oSelectMPGErr, vClass: 'c-ani-shake', vTime: 500 });

                if (vTotal >= maxPax) {
                    for (var i = 0; i < aPaxPlusBtn.length; i++) {
                        aPaxPlusBtn[i].style.pointerEvents = "none";
                    }
                }
            }
            else {
                for (var i = 0; i < aPaxPlusBtn.length; i++) {
                    aPaxPlusBtn[i].style.pointerEvents = "inherit";
                }
            }
        }

        if (vTotalBaby > vTotalAdult) {
            oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = getT('airbooking.adultinfant');
            oSearchWhoField.setAttribute('data-error', getT('airbooking.adultinfant'));
            oSelectMPGErr.classList.add('c-show');
            XLClassAnim({ oObj: oSelectMPGErr, vClass: 'c-ani-shake', vTime: 500 });
        }

        //oText.value = aOutput.join(' + ') ;
        if (oText)
            oText.innerHTML = aOutput.join(' + ');
    }
}

function FSelectMPGMasstock_Refresh(paxId) {
    var oText = document.getElementById('i-travellers-text-' + paxId),
        oSelectMPG = document.getElementById('i-select-mpg-' + paxId),
        aInputs = oSelectMPG.getElementsByTagName('input'),
        aOutput = new Array(),
        vTotal = 0,
        vTotalAdult = 0,
        vTotalBaby = 0,
        oSearchWhoField = document.getElementById('i-pax-field-' + paxId),
        oSelectMPGErr = document.getElementById('i-select-mpg-err-' + paxId);

    //myObj.addEventListener("mousedown", function(e) { XLObjTarget(e) ;} );

    for (i = 0; i < aInputs.length; i++) {
        vInputVal = aInputs[i].value;
        if (i == 0 && vInputVal == 1) aOutput.push(getT('homepage.oneadulte')), vTotalAdult = vTotalAdult + parseInt(vInputVal);
        else if (i == 0 && vInputVal > 1) aOutput.push(vInputVal + ' ' + getT('homepage.adults')), vTotalAdult = vTotalAdult + parseInt(vInputVal);
        else if (i == 1 && vInputVal == 1) aOutput.push(getT('homepage.onechild'));
        else if (i == 1 && vInputVal > 1) aOutput.push(vInputVal + ' ' + getT('homepage.children'));
        else if (i == 2 && vInputVal == 1) aOutput.push(getT('homepage.oneinfant')), vTotalBaby = vTotalBaby + parseInt(vInputVal);
        else if (i == 2 && vInputVal > 1) aOutput.push(vInputVal + ' ' + getT('homepage.infants')), vTotalBaby = vTotalBaby + parseInt(vInputVal);
        vTotal = vTotal + parseInt(vInputVal);
    }
    //console.log(vTotal) ;
    if (oSelectMPGErr)
        oSelectMPGErr.classList.remove('c-show');
    if (oSearchWhoField)
        oSearchWhoField.removeAttribute('data-error');
    //oSelectMPGErr.classList.remove('c-ani-shake') ;

    if (vTotal > 9) {
        oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = getT('airbooking.maximumpassenger');
        oSearchWhoField.setAttribute('data-error', getT('airbooking.maximumpassenger'));
        oSelectMPGErr.classList.add('c-show');
        //oSelectMPGErr.classList.add('c-ani-shake') ;
        XLClassAnim({ oObj: oSelectMPGErr, vClass: 'c-ani-shake', vTime: 500 });

    }

    if (oSearchWhoField.hasAttribute("data-max")) {
        maxPax = oSearchWhoField.getAttribute("data-max");
        oWhoPop = document.getElementById("i-search-who-pop");
        aPaxPlusBtn = oWhoPop.getElementsByClassName("c-p");
        if (vTotal > maxPax) {

            var errorMessage = getT('airbooking.maximumpassenger').replace(/[0-9]/, maxPax);

            if (maxPax == 1) {
                oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = errorMessage;
                oSearchWhoField.setAttribute('data-error', errorMessage);
            }
            else if (maxPax > 1) {
                oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = errorMessage;
                oSearchWhoField.setAttribute('data-error', errorMessage);
            }
            oSelectMPGErr.classList.add('c-show');
            XLClassAnim({ oObj: oSelectMPGErr, vClass: 'c-ani-shake', vTime: 500 });

            if (vTotal >= maxPax) {
                for (var i = 0; i < aPaxPlusBtn.length; i++) {
                    aPaxPlusBtn[i].style.pointerEvents = "none";
                }
            }
        }
        else {
            for (var i = 0; i < aPaxPlusBtn.length; i++) {
                aPaxPlusBtn[i].style.pointerEvents = "inherit";
            }
        }
    }

    if (vTotalBaby > vTotalAdult) {
        oSelectMPGErr.getElementsByTagName("span")[0].innerHTML = getT('airbooking.adultinfant');
        oSearchWhoField.setAttribute('data-error', getT('airbooking.adultinfant'));
        oSelectMPGErr.classList.add('c-show');
        XLClassAnim({ oObj: oSelectMPGErr, vClass: 'c-ani-shake', vTime: 500 });
    }

    //oText.value = aOutput.join(' + ') ;
    if (oText)
        oText.innerHTML = aOutput.join(' + ');
}
//**************************************************************************************************************************************

function FSelectMP(aIn) {

    if (!aIn['myObj'] || typeof (aIn['myObj']) == "undefined")
        return 0;
    else {
        var myObj = aIn['myObj'],
            oTarget = XLObjTarget(aIn['e']),
            aTriggers = myObj.getElementsByTagName('i'),
            oInput = myObj.querySelector("input"),
            oMinus = aTriggers[0], oValue = myObj.getElementsByTagName('div')[0], oPlus = aTriggers[1],
            vMin = (myObj.getAttribute('data-min')) ? myObj.getAttribute('data-min') : -999999,
            vMax = (myObj.getAttribute('data-max')) ? myObj.getAttribute('data-max') : 999999,
            oValueInt = parseInt(oValue.innerHTML);

        //oTarget = XLObjTarget(e),

        //oTarget = O_TARGET ;

        if (oTarget == oPlus && oValueInt < vMax) oValue.innerHTML = oValueInt + 1;
        else if (oTarget == oMinus && oValueInt > vMin) oValue.innerHTML = oValueInt - 1;

        var oValueInt = parseInt(oValue.innerHTML);

        if (oValueInt == vMin) {
            XLClassAnim({ oObj: oTarget, vParent: true, vClass: 'c-ani-shake', vTime: 150 });
            oMinus.classList.add('c-txt-vlight');
        }
        else oMinus.classList.remove('c-txt-vlight');

        if (oValueInt == vMax) {
            oPlus.classList.add('c-txt-vlight');
            XLClassAnim({ oObj: oTarget, vParent: true, vClass: 'c-ani-shake', vTime: 150 });
        }
        else oPlus.classList.remove('c-txt-vlight');

        if (oInput) oInput.value = oValueInt;

        if (parseInt(document.getElementById('myInfantNumber').value) > 1) document.getElementById('myInfantLabel').innerHTML = getT('resultpage.infants') + getT('homepage.searchform.selectpassengers.infantsage');
        else document.getElementById('myInfantLabel').innerHTML = getT('resultpage.infant') + getT('homepage.searchform.selectpassengers.infantsage');

        return oValueInt;
    }

}

function XLObjTarget(e) {
    //e = e || window.event; // DANGER : SENSIBLE CHANGE 2015-11-30
    O_TARGET = e.target || e.srcElement;
    return e.target || e.srcElement;
}

function XLObjSize(myObj) {
    var size = 0, key;
    for (key in myObj) {
        if (myObj.hasOwnProperty(key)) size++;
    }
    return size;
}

function XLDateSlash(aIn) {

    var e = aIn['e'];
    //console.log(e.keyCode) ;

    if (e.keyCode == 27) {
        aIn['myObj'].value = '';
        return false;
    }

    else if (e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 37 || e.keyCode == 39 || e.keyCode == 46) return true;

    else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {

        aIn['myObj'].onkeyup = function () { XLDateSlashUp(aIn['myObj'], event); XLCalRange({ oFrom: aIn['myObj'] }) };

    } else {
        e.preventDefault();
        return false;
    }

}

function XLDateSlashUp(myObj, e) {
    if ((myObj.value.length == 2 || myObj.value.length == 5) && e.keyCode != 8) myObj.value += '/';
}

function FClassT(aIn) {

    aIn['myObj'].classList.toggle(aIn['vClass']);

}

function FSmoothOpen(aIn, callback) {

    if (!aIn['vWhat']) aIn['vWhat'] = 'h';

    if (aIn['iSmooth']) oSmooth = document.getElementById(aIn['iSmooth']);
    else if (aIn['oSmooth']) oSmooth = aIn['oSmooth'];

    if (oSmooth) {
        var vSmoothStyles = null;
        try {
            vSmoothStyles = window.getComputedStyle(oSmooth);
        } catch (e) { }
        //console.log(vSmoothStyles.visibility);

        //**************************************************************************************************************************************
        //Modify by AGSW for the web (banque casino)
        var open = aIn['vForce'] == 'open';
        if (vSmoothStyles)
            open = open || vSmoothStyles.visibility == 'hidden';
        open = open && aIn['vForce'] != 'close';
        //**************************************************************************************************************************************

        if (open) {
            var productHeight = 0;
            //console.log('OPEN');
            oSmooth.classList.add('c-smooth-init');
            oSmooth.classList.add('c-smooth-proc');
            //oSmooth.classList.remove('c-resp-smooth-closed-m') ;
            oSmooth.classList.remove('c-smooth-closed-l');
            oSmooth.classList.remove('c-smooth-closed-m');
            oSmooth.classList.remove('c-smooth-closed-s');
            var vSmoothHeight = oSmooth.offsetHeight;
            var vSmoothWidth = oSmooth.offsetWidth;
            oSmooth.classList.remove('c-smooth-proc');
            if (aIn['oOpener']) aIn['oOpener'].classList.add('c-smooth-opener-on');

            if (aIn['vClassP']) aIn['oOpener'].parentNode.classList.add(aIn['vClassP']);
            if (aIn['vClassPP']) aIn['oOpener'].parentNode.parentNode.classList.add(aIn['vClassPP']);

            if (aIn['iToggle'] && document.getElementById(aIn['iToggle'])) oToggle = document.getElementById(aIn['iToggle']).classList.add(aIn['vToggleClass']);
            oSmooth.style.minHeight = 0;
            if (aIn['vWhat'] == 'h') oSmooth.style.minHeight = vSmoothHeight + 'px';
            else if (aIn['vWhat'] == 'w') oSmooth.style.width = vSmoothWidth + 'px';

            //handle more products return
            if (oSmooth.getElementsByClassName("c-flight-back-pick").length > 0 && oSmooth.getElementsByClassName("c-flight-back-wrapper").length > 0 && oSmooth.getElementsByClassName("c-flight").length > 6) {
                var flightBackPickHeight = oSmooth.getElementsByClassName("c-flight-back-pick")[0].clientHeight + 4;
                for (var i = 0; i < 6; i++) {
                    productHeight += oSmooth.getElementsByClassName("c-flight")[i].clientHeight + 4;
                    if (i === 5) productHeight += oSmooth.getElementsByClassName("c-flight")[i + 1].clientHeight / 2 + 4;
                }
                vSmoothHeight = productHeight - 4;
                oSmooth.style.minHeight = vSmoothHeight + 'px';
                oSmooth.getElementsByClassName("c-flight-back-wrapper")[0].style.height = vSmoothHeight + 'px';
            }

            oSmooth.classList.add('c-smooth-open');
            oSmooth.classList.remove('c-smooth-closed');
            if (typeof callback === "function") {
                callback(aIn);
            }

        } else if (vSmoothStyles) {
            if (vSmoothStyles.visibility == 'visible') {
                //console.log('CLOSE');
                vSmoothHeight = oSmooth.offsetHeight;
                vSmoothWidth = oSmooth.offsetWidth;
                if (aIn['vWhat'] == 'h') oSmooth.style.minHeight = vSmoothHeight + 'px';
                else if (aIn['vWhat'] == 'w') oSmooth.style.width = vSmoothWidth + 'px';

                if (aIn['vClassP']) aIn['oOpener'].parentNode.classList.remove(aIn['vClassP']);
                if (aIn['vClassPP']) aIn['oOpener'].parentNode.parentNode.classList.remove(aIn['vClassPP']);

                if (aIn['iToggle'] && document.getElementById(aIn['iToggle'])) oToggle = document.getElementById(aIn['iToggle']).classList.remove(aIn['vToggleClass']);

                if (aIn['vWhat'] == 'h') oSmooth.style.minHeight = '0';
                else if (aIn['vWhat'] == 'w') oSmooth.style.width = '0';
                oSmooth.classList.remove('c-smooth-open');
                oSmooth.classList.add('c-smooth-closed');
                if (aIn['oOpener']) aIn['oOpener'].classList.remove('c-smooth-opener-on');
                if (typeof callback === "function") {
                    callback(aIn);
                }
            }
        }

        if (aIn['vForce'] == 'open') {
            oSmooth.classList.remove('c-smooth-open');
        }

        window.setTimeout(function (arg) {
            if (arg) {
                if (arg['_oSmooth']) {
                    var _oSmooth = arg['_oSmooth'];
                    _oSmooth.classList.remove('c-smooth-init');
                }
            }
        }, 150, { _oSmooth: oSmooth });

        FErrorDestroy();
    }
    //console.log('*********************');

}

/********************************************************************************************************************************************************************/

window.addEventListener("keydown", FDocKeyDown, false);
var OAutoCompKeySel;

function FDocKeyDown(event) {

    OAutoComp = document.getElementById('i-search-autoc');
    var DoIt = false;
    var e = event ? event : window.event;

    //if (OAutoComp.style.display == 'block') {
    if (OAutoComp && OAutoComp.className.indexOf("c-show") != -1) {

        //console.log(e.keyCode) ;



        if (!OAutoCompKeySel && (e.keyCode == 38 || e.keyCode == 40)) {
            OAutoCompList = document.getElementById('i-search-autoc-list');
            if (OAutoCompList) {
                //console.log('DOIT 1') ;
                OAutoCompKeySel = OAutoCompList.firstChild;
                DoIt = true;
            }
        }

        // Key Up
        else if (e.keyCode == 38) {
            if (OAutoCompKeySel.previousSibling && OAutoCompKeySel.previousSibling.tagName == 'LI') {
                OAutoCompKeySel = OAutoCompKeySel.previousSibling;
                DoIt = true;
            }
        }

        else if (e.keyCode == 40) {
            if (OAutoCompKeySel.nextSibling && OAutoCompKeySel.nextSibling.tagName == 'LI') {
                OAutoCompKeySel = OAutoCompKeySel.nextSibling;
                DoIt = true;
            }
        }

        if (OAutoCompKeySel) OAutoCompKeySel.classList.add('c-on');

        if (DoIt) {
            //console.log('DOIT 2 ');
            if (isset('OAutoCompKeySelSaved')) OAutoCompKeySelSaved.classList.remove('c-on');
            OAutoCompKeySelSaved = OAutoCompKeySel;
        }

        if (OAutoCompKeySel && e.keyCode == 13) {

            //console.log(OAutoCompKeySel); //

            //OAutoComp.innerHTML = '' ;
            //OAutoComp.style.display = 'none' ;
            FAutoCompSel({ oTarget: OAutoCompKeySel, iField: OAutoCompKeySel.getAttribute('data-text-id') });
            FAutoCompHide();
            DoIt = false;
            OAutoCompKeySel = false;
            event.preventDefault();
            return false;

            //OField = document.getElementById(OAutoCompKeySel.getAttribute('field') + '_text');
            //OFieldHidden = document.getElementById(OAutoCompKeySel.getAttribute('field') + '_hidden');
            //OField.value = OAutoCompKeySel.innerHTML;
            //OFieldHidden.value = OAutoCompKeySel.getAttribute('value');


        }

    }

}


/*******************************************************************************************************
XL Functions
********************************************************************************************************/

function XLArrSpliceVal(arr, val) {
    var index = arr.indexOf(val);
    if (index >= 0) {
        arr.splice(index, 1);
    }
}

function XLArrDelDuplicates(a) {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for (var i = 0; i < len; i++) {
        var item = a[i];
        if (seen[item] !== 1) {
            seen[item] = 1;
            out[j++] = item;
        }
    }
    return out;
}



function XLUCFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function isset(variable) {
    if (typeof (window[variable]) != 'undefined') return true;
    else return false;
}

function XLGetBack(AIn) {

    //AIn['Url']
    //AIn['DivId']

    var XHRObject = null;
    //var Position = DivId ;

    if (window.XMLHttpRequest) XHRObject = new XMLHttpRequest();
    else if (window.ActiveXObject) XHRObject = new ActiveXObject("Microsoft.XMLHTTP");

    XHRObject.open("GET", AIn['Url'], true);
    // dans le cas du get
    XHRObject.send(null);
    XHRObject.onreadystatechange = function () {

        if (XHRObject.readyState == 4) {

            document.getElementById(AIn['DivId']).innerHTML = XHRObject.responseText;
            if (AIn['JSOnLoad'] && XHRObject.status == 200) AIn['JSOnLoad']();

        }
    }
    return false;
}

function XLPostBack(AIn) {

    //AIn['DivId'] = 'FBoxQues' ;
    //AIn['Url'] = '/pages/core/step-check-answer.php' ;
    //AIn['FormId'] = 'FormStep' ;
    //AIn['JSOnLoad'] = XLAnimCountA ;

    var XHRObject = null;
    var Position = AIn['DivId'];

    if (window.XMLHttpRequest) XHRObject = new XMLHttpRequest();
    else if (window.ActiveXObject) XHRObject = new ActiveXObject("Microsoft.XMLHTTP");

    //XHRObject.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    //XHRObject.setRequestHeader("Content-length", params.length);
    //XHRObject.setRequestHeader("Connection", "close");

    AllFields = '';
    for (i = 0; i < document.getElementById(AIn['FormId']).elements.length; i++) {
        AllFields = AllFields + document.getElementById(AIn['FormId']).elements[i].name + '=' + document.getElementById(AIn['FormId']).elements[i].value + '&';

    }

    XHRObject.open("POST", AIn['Url'], true);
    XHRObject.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    XHRObject.send(AllFields);

    XHRObject.onreadystatechange = function () {

        if (XHRObject.readyState == 4) {
            document.getElementById(AIn['DivId']).innerHTML = XHRObject.responseText;
            if (AIn['JSOnLoad'] && XHRObject.status == 200) AIn['JSOnLoad'](AIn['JSOnLoadParams']);
        }
    }
    return false;
}



function XLUserAgent() {
    var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) return 'Opera ' + tem[1];
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
}

function XLUserSystem() {

    var OSName = "unknown OS",
        vNav = navigator.appVersion;

    if (vNav.indexOf("Win") != -1) OSName = "Windows";
    if (vNav.indexOf("Mac") != -1) OSName = "MacOS";
    if (vNav.indexOf("X11") != -1) OSName = "UNIX";
    if (vNav.indexOf("Linux") != -1) OSName = "Linux";
    return OSName;

}



/////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * AW Masked Input
 * @version 1.3
 * @author Kendall Conrad
 * @url http://www.angelwatt.com/coding/masked_input.php
 * @created 2008-12-16
 * @modified 2013-08-19
 * @license This work is licensed under a Creative Commons
 *  Attribution-Share Alike 3.0 United States License
 *  http://creativecommons.org/licenses/by-sa/3.0/us/
 *
 * @param scope The object to attach MaskedInput to.
 */
(function (scope) {
    'use strict';

    /**
     * MaskedInput takes many possible arguments described below.
     * Note: req = required, opt = optional
     * @param {object} args {
     *  -elm [req] text input node to apply the mask on
     *  -format [req] string format for the mask
     *  -allowed [opt, '0123456789'] string with chars allowed to be typed
     *  -sep [opt, '\/:-'] string of char(s) used as separators in mask
     *  -typeon [opt, '_YMDhms'] string of chars in mask that can be typed on
     *  -onfilled [opt, null] function to run when the format is filled in
     *  -onbadkey [opt, null] function to run when user types a unallowed key
     *  -badkeywait [opt, 0] used with onbadkey. Indicates how long (in ms)
     *   to lock text input for onbadkey function to run
     *  -preserve [opt, true] whether to preserve existing text in
     *   field during init.
     * }
     * @returns MaskedInput
     */
    scope.MaskedInput = function (args) {

        // Ensure passing in valid argument
        if (!args || !args.elm || !args.format) {
            return null;
        }
        // Ensure use of 'new'
        if (!(this instanceof scope.MaskedInput)) {
            return new scope.MaskedInput(args);
        }
        // Initialize variables
        var self = this,
            el = args.elm,
            format = args.format,
            allowed = args.allowed || '0123456789',
            sep = args.separator || '\/:-+',
            open = args.typeon || '_YMDhms',
            onbadkey = args.onbadkey || function () { },
            onfilled = args.onfilled || function () { },
            badwait = args.badkeywait || 0,
            preserve = args.hasOwnProperty('preserve') ? !!args.preserve : true,
            // ----
            enabled = true,
            locked = false,
            startText = format,
            /**
             * Add events to objects.
             */
            evtAdd = (function () {
                if (window.addEventListener) {
                    return function (obj, type, fx, capture) {
                        obj.addEventListener(type, fx,
                            (capture === undefined) ? false : capture);
                    };
                }
                if (window.attachEvent) {
                    return function (obj, type, fx) {
                        obj.attachEvent('on' + type, fx);
                    };
                }
                return function (obj, type, fx) {
                    obj['on' + type] = fx;
                };
            }()),
            /**
             * Checks whether the format has been completely filled out.
             * @return boolean if all typeon chars have been filled.
             */
            isFilled = function () {
                // Check if any typeon characters are left
                // Work from end of string as it's usually last filled
                for (var a = el.value.length - 1; a >= 0; a--) {
                    // Check against each typeon character
                    for (var c = 0, d = open.length; c < d; c++) {
                        // If one matches we don't need to check anymore
                        if (el.value[a] === open[c]) {
                            return false;
                        }
                    }
                }
                return true;
            },
            /**
             * Gets the current position of the text cursor in a text field.
             * @param node a input or textarea HTML node.
             * @return int text cursor position index, or -1 if there was a problem.
             */
            getTextCursor = function (node) {

                try {
                    node.focus();
                    if (node.selectionStart >= 0) {
                        return node.selectionStart;
                    }
                    if (document.selection) {// IE
                        var rng = document.selection.createRange();
                        return -rng.moveStart('character', -node.value.length);
                    }
                    return -1;
                }
                catch (e) {
                    return -1;
                }
            },
            /**
             * Sets the text cursor in a text field to a specific position.
             * @param node a input or textarea HTML node.
             * @param pos int of the position to be placed.
             * @return boolean true is successful, false otherwise.
             */
            setTextCursor = function (node, pos) {
                try {
                    if (node.selectionStart) {

                        node.focus();
                        node.setSelectionRange(pos, pos);
                    }
                    else if (node.createTextRange) { // IE
                        var rng = node.createTextRange();
                        rng.move('character', pos);
                        rng.select();
                    }
                }
                catch (e) {
                    return false;
                }
                return true;
            },
            /**
             * Gets the keyboard input in usable way.
             * @param code integer character code
             * @return string representing character code
             */
            getKey = function (code) {
                code = code || window.event;
                var ch = '',
                    keyCode = code.which,
                    evt = code.type;
                if (keyCode === undefined || keyCode === null) {
                    keyCode = code.keyCode;
                }
                // no key, no play
                if (keyCode === undefined || keyCode === null) {
                    return '';
                }
                if (keyCode == 38) return false; // NICO 27-04
                // deal with special keys
                switch (keyCode) {
                    case 8:
                        ch = 'bksp';
                        break;
                    case 46: // handle del and . both being 46
                        ch = (evt === 'keydown') ? 'del' : '.';
                        break;
                    case 16:
                        ch = 'shift';
                        break;
                    case 0: /*CRAP*/
                    case 9: /*TAB*/
                    case 13:/*ENTER*/
                        ch = 'etc';
                        break;
                    case 37:
                    case 38:
                    case 39:
                    case 40: // arrow keys
                        ch = (!code.shiftKey &&
                            (code.charCode !== 39 && code.charCode !== undefined)) ?
                            'etc' : String.fromCharCode(keyCode);
                        break;
                    // default to thinking it's a character or digit
                    default:
                        ch = String.fromCharCode(keyCode);
                        break;
                }
                return ch;
            },
            /**
             * Stop the event propogation chain.
             * @param evt Event to stop
             * @param ret boolean, used for IE to prevent default event
             */
            stopEvent = function (evt, ret) {
                // Stop default behavior the standard way
                if (evt.preventDefault) {
                    evt.preventDefault();
                }
                // Then there's IE
                evt.returnValue = ret || false;
            },
            /**
             * Updates the text field with the given key.
             * @param key string keyboard input.
             */
            update = function (key) {
                var p = getTextCursor(el),
                    c = el.value,
                    val = '',
                    cond = true;
                // Handle keys now
                switch (cond) {
                    // Allowed characters
                    case (allowed.indexOf(key) !== -1):
                        p = p + 1;
                        // if text cursor at end
                        if (p > format.length) {
                            return false;
                        }
                        // Handle cases where user places cursor before separator
                        while (sep.indexOf(c.charAt(p - 1)) !== -1 && p <= format.length) {
                            p = p + 1;
                        }
                        val = c.substr(0, p - 1) + key + c.substr(p);
                        // Move csor up a spot if next char is a separator char
                        if (allowed.indexOf(c.charAt(p)) === -1
                            && open.indexOf(c.charAt(p)) === -1) {
                            p = p + 1;
                        }
                        break;
                    case (key === 'bksp'): // backspace
                        p = p - 1;
                        // at start of field
                        if (p < 0) {
                            return false;
                        }
                        // If previous char is a separator, move a little more
                        while (allowed.indexOf(c.charAt(p)) === -1
                            && open.indexOf(c.charAt(p)) === -1
                            && p > 1) {
                            p = p - 1;
                        }
                        val = c.substr(0, p) + format.substr(p, 1) + c.substr(p + 1);
                        break;
                    case (key === 'del'): // forward delete
                        // at end of field
                        if (p >= c.length) {
                            return false;
                        }
                        // If next char is a separator and not the end of the text field
                        while (sep.indexOf(c.charAt(p)) !== -1
                            && c.charAt(p) !== '') {
                            p = p + 1;
                        }
                        val = c.substr(0, p) + format.substr(p, 1) + c.substr(p + 1);
                        p = p + 1; // Move position forward
                        break;
                    case (key === 'etc'):
                        // Catch other allowed chars
                        return true;
                    default:
                        return false; // Ignore the rest
                }
                el.value = ''; // blank it first (Firefox issue)
                el.value = val; // put updated value back in
                setTextCursor(el, p); // Set the text cursor
                return false;
            },
            /**
             * Returns whether or not a given input is valid for the mask.
             * @param k string of character to check.
             * @return bool true if it's a valid character.
             */
            goodOnes = function (k) {
                // if not in allowed list, or invisible key action
                if (allowed.indexOf(k) === -1 && k !== 'bksp' && k !== 'del' && k !== 'etc') {
                    // Need to ensure cursor position not lost
                    var p = getTextCursor(el);
                    locked = true;
                    onbadkey(k);
                    // Hold lock long enough for onbadkey function to run
                    setTimeout(function () {
                        locked = false;
                        setTextCursor(el, p);
                    }, badwait);
                    return false;
                }
                return true;
            },
            /**
             * Handles the key down events.
             * @param e Event
             */
            keyHandlerDown = function (e) {
                if (!enabled) {
                    return true;
                }
                if (locked) {
                    stopEvent(e);
                    return false;
                }
                e = e || event;
                var key = getKey(e);
                // Stop copy and paste
                if ((e.metaKey || e.ctrlKey) && (key === 'X' || key === 'V')) {
                    stopEvent(e);
                    return false;
                }
                // Allow for OS commands
                if (e.metaKey || e.ctrlKey) {
                    return true;
                }
                if (el.value === '') {
                    el.value = format;
                    setTextCursor(el, 0);
                }
                // Only do update for bksp del
                if (key === 'bksp' || key === 'del') {
                    update(key);
                    stopEvent(e);
                    return false;
                }
                return true;
            },
            /**
             * Handles the key press events.
             * @param e Event
             */
            keyHandlerPress = function (e) {
                if (!enabled) {
                    return true;
                }
                if (locked) {
                    stopEvent(e);
                    return false;
                }
                e = e || event;
                var key = getKey(e);
                // Check if modifier key is being pressed; command
                if (key === 'etc' || e.metaKey || e.ctrlKey || e.altKey) {
                    return true;
                }
                if (key !== 'bksp' && key !== 'del' && key !== 'shift') {
                    if (!goodOnes(key)) {
                        stopEvent(e);
                        return false;
                    }
                    if (update(key)) {
                        if (isFilled()) {
                            onfilled();
                        }
                        stopEvent(e, true);
                        return true;
                    }
                    if (isFilled()) {
                        onfilled();
                    }
                    stopEvent(e);
                    return false;
                }
                return false;
            },
            /**
             * Initialize the object.
             */
            init = function () {
                // Check if an input or textarea tag was passed in
                if (!el.tagName || (el.tagName.toUpperCase() !== 'INPUT'
                    && el.tagName.toUpperCase() !== 'TEXTAREA')) {
                    return null;
                }
                // Only place formatted text in field when not preserving
                // text or it's empty.
                if (!preserve || el.value === '') {
                    el.value = format;
                }
                // Assign events
                evtAdd(el, 'keydown', function (e) {
                    FErrorDestroy();
                    keyHandlerDown(e);
                });
                evtAdd(el, 'keypress', function (e) {
                    FErrorDestroy();
                    keyHandlerPress(e);
                });
                // Let us set the initial text state when focused
                evtAdd(el, 'focus', function () {
                    startText = el.value;
                });
                evtAdd(el, 'mouseup', function () { // NICO 15-04-20
                    if (el.value == format) el.setSelectionRange(0, 0); // NICO 15-04-20
                }); // NICO 15-04-20
                // Handle onChange event manually
                evtAdd(el, 'blur', function () {
                    if (el.value !== startText && el.onchange) {
                        el.onchange();
                    }
                });
                return self;
            };

        /**
         * Resets the text field so just the format is present.
         */
        self.resetField = function () {
            el.value = format;
        };

        /**
         * Set the allowed characters that can be used in the mask.
         * @param a string of characters that can be used.
         */
        self.setAllowed = function (a) {
            allowed = a;
            self.resetField();
        };

        /**
         * The format to be used in the mask.
         * @param f string of the format.
         */
        self.setFormat = function (f) {
            format = f;
            self.resetField();
        };

        /**
         * Set the characters to be used as separators.
         * @param s string representing the separator characters.
         */
        self.setSeparator = function (s) {
            sep = s;
            self.resetField();
        };

        /**
         * Set the characters that the user will be typing over.
         * @param t string representing the characters that will be typed over.
         */
        self.setTypeon = function (t) {
            open = t;
            self.resetField();
        };

        /**
         * Sets whether the mask is active.
         */
        self.setEnabled = function (enable) {
            enabled = enable;
        };

        return init();
    };
}(window));


/** polyfill classList for IE9 **/

if (!("classList" in document.documentElement) && Object.defineProperty && typeof HTMLElement !== 'undefined') {
    Object.defineProperty(HTMLElement.prototype, 'classList', {
        get: function () {
            var self = this;
            function update(fn) {
                return function (value) {
                    var classes = self.className.split(/\s+/),
                        index = classes.indexOf(value);

                    fn(classes, index, value);
                    self.className = classes.join(" ");
                }
            }

            var ret = {
                add: update(function (classes, index, value) {
                    ~index || classes.push(value);
                }),

                remove: update(function (classes, index) {
                    ~index && classes.splice(index, 1);
                }),

                toggle: update(function (classes, index, value) {
                    ~index ? classes.splice(index, 1) : classes.push(value);
                }),

                contains: function (value) {
                    return !!~self.className.split(/\s+/).indexOf(value);
                },

                item: function (i) {
                    return self.className.split(/\s+/)[i] || null;
                }
            };

            Object.defineProperty(ret, 'length', {
                get: function () {
                    return self.className.split(/\s+/).length;
                }
            });

            return ret;
        }
    });
}


// NICO 2015-04-07
// ************************************

function FFlightsUpdated(aIn) {

    FFDetCloseAll();

    if (aIn['vFlightsCount'] <= 1) myMsg = aIn['vFlightsCount'] + ' ' + getT('homepage.flightfound');
    else myMsg = aIn['vFlightsCount'] + ' ' + getT('homepage.flightsfound');

    FPopFlash({ vMsg: myMsg });

    var _aIn = aIn || {};
    _aIn.vCount = 0;
    FFlightAnim(_aIn);

    //setTimeout(function() { FPopFlash({vMsg:aIn['vFlightsCount'] + ' vols trouvés'}) ;	 }, 50) ;
    //setTimeout(function() { FFlightAnim({vCount:0}) ;	 }, 100) ;

}

function FFDetCloseAll() {

    if (V_FF_DET) {
        console.log(V_FF_DET);
        FSmoothOpen({ iSmooth: 'i-smooth-detail-' + V_FF_DET, iToggle: 'i-flight-' + V_FF_DET, vToggleClass: 'c-flight-on-detail' });
        V_FF_DET = false;
    }

    aFlightsBack = document.body.getElementsByClassName('c-flight-back c-smooth-open');
    aFlightsBackLength = aFlightsBack.length;
    for (var v = 0; v < aFlightsBackLength; ++v) {

        if (typeof aFlightsBack[v] !== 'undefined') {

            var vWich = aFlightsBack[v].id.replace('i-smooth-back-', '');

            FSmoothOpen({ iSmooth: 'i-smooth-back-' + vWich, iToggle: 'i-flight-' + vWich, vToggleClass: 'c-flight-on-back' });
            document.getElementById('i-flight-' + vWich).classList.remove('c-flight-on-back');
        }
    }

}

function FPopFlash(aIn) {

    oPopFlash = document.getElementById('i-pop-flash');
    oPopFlashIn = document.getElementById('i-pop-flash-in');
    oPopFlashIn.innerHTML = aIn['vMsg'];
    //XLClassAnim({ oObj: oPopFlash, vClass: 'c-pop-flash-run', vTime: 2500 }) ;
    oPopFlash.classList.remove('c-pop-flash-run');
    setTimeout(function () { oPopFlash.classList.add('c-pop-flash-run'); }, 100);

}

function FFlightAnim(aIn) {

    if (typeof FFlightAnimRunTimer != 'undefined') clearTimeout(FFlightAnimRunTimer);

    aFlights = document.body.getElementsByClassName('c-flight-top');
    aFlightsLength = aFlights.length;
    for (var i = 0; i < aFlightsLength; ++i) {
        aFlights[i].classList.add('c-flight-anim');
    }

    var _aIn = aIn || {};
    _aIn.vCount = 0;
    setTimeout(function (arg) { FFlightAnimRun(arg) }, 200, _aIn);
}

function FFlightAnimRun(aIn) {
    //console.log(aIn['vCount']);
    aFlights = document.body.getElementsByClassName('c-flight-top');
    if (aFlights.length == 0) return false;
    if (aIn) {
        if (typeof aIn['vCount'] != 'undefined') {
            var vCount = aIn['vCount'];
            aFlights[vCount].classList.remove('c-flight-anim');

            if (typeof aIn['itemRender'] != 'undefined' && aIn['itemRender'])
                aIn['itemRender'](aFlights[vCount]);

            if (aFlights.length - 1 <= vCount) {
                if (typeof FFlightAnimRunTimer !== "undefined") //AGSW fix IE9
                    clearTimeout(FFlightAnimRunTimer);
                if (typeof aIn['callback'] != 'undefined' && aIn['callback'])
                    aIn['callback']();
            }
            else {
                aIn['vCount']++;
                FFlightAnimRunTimer = setTimeout(function () { FFlightAnimRun(aIn) }, 100);
                //requestAnimationFrame(FFlightAnimRun);
            }
        }
    }
}

function FLoading(aIn) {
    // Function to show / hide the loading block. To use it :
    // to show : FLoading({vAction:'show'})
    // to hide : FLoading({vAction:'hide'})

    var oBody = document.body;
    window._floadingTimer = null;

    if (aIn['vAction'] == 'show') {

        var oLoading = document.createElement("div");
        oLoading.id = 'i-loading';
        oLoading.classList.add('c-loading');
        oLoading.classList.add('c-pop');
        oLoading.classList.add('c-bg-ffffff');
        oLoading.classList.add('c-txt-or');
        var loadingMessage = "Loading...";

        if (aIn['umbracoKeyLoadingText']) {
            loadingMessage = getT(aIn['umbracoKeyLoadingText']);
        }
        else {
            loadingMessage = getT('loadingpage.loading');
        }

        oLoading.innerHTML = '<div><p>' + loadingMessage + '</p><div class="c-loading-spin"><div class="c-one"></div><div class="c-two"></div><div class="c-three"></div></div></div>';

        var oLoadingCover = document.createElement("div");
        oLoadingCover.id = 'i-loading-cover';
        oLoadingCover.classList.add('c-loading-cover');
        //oLoadingCover.onclick = function() { FLoading({vAction:'hide'}) } ;

        oBody.appendChild(oLoadingCover);
        oBody.appendChild(oLoading);

        if (window._floadingTimer)
            clearTimeout(window._floadingTimer);
        window._floadingTimer = window.setTimeout(function () {
            oLoadingCover.classList.add('c-show');
            oLoading.classList.add('c-show');
        }, 1000);

    }
    if (aIn['vAction'] == 'showNow') {
        var oLoading = document.createElement("div");
        oLoading.id = 'i-loading';
        oLoading.classList.add('c-loading');
        oLoading.classList.add('c-pop');
        oLoading.classList.add('c-bg-ffffff');
        oLoading.classList.add('c-txt-or');
        oLoading.classList.add('c-show');
        var loadingMessage = "Loading...";

        if (aIn['umbracoKeyLoadingText']) {
            loadingMessage = getT(aIn['umbracoKeyLoadingText']);
        }
        else {
            loadingMessage = getT('loadingpage.loading');
        }

        oLoading.innerHTML = '<div><p>' + loadingMessage + '</p><div class="c-loading-spin"><div class="c-one"></div><div class="c-two"></div><div class="c-three"></div></div></div>';

        var oLoadingCover = document.createElement("div");
        oLoadingCover.id = 'i-loading-cover';
        oLoadingCover.classList.add('c-loading-cover');
        oLoadingCover.classList.add('c-show');

        oBody.appendChild(oLoadingCover);
        oBody.appendChild(oLoading);
    }
    if (aIn['vAction'] == 'hide') {
        if (document.getElementById('i-loading-cover') != null) {
            document.getElementById('i-loading-cover').classList.remove('c-show')
        }
        if (document.getElementById('i-loading') != null) {
            document.getElementById('i-loading').classList.remove('c-show')
        }
        if (window._floadingTimer)
            clearTimeout(window._floadingTimer);
        window._floadingTimer = window.setTimeout(function () {
            if (document.getElementById('i-loading-cover')) {
                oBody.removeChild(document.getElementById('i-loading-cover'));
            }
            if (document.getElementById('i-loading')) {
                oBody.removeChild(document.getElementById('i-loading'));
            }

        }, 150);
    }
}

function FCardFirst(aIn) {

    if (!document.getElementsByName('i-card-type')[0].value) {

        aVS = new Array();
        aVS['oObj'] = document.getElementById('i-card-type-text');
        aVS['vError'] = 'nostyle';
        aVS['vErrorCode'] = '';
        aVS['vErrorCustom'] = getT('loadingpage.pleasechoose');
        aVS['vShiftLeft'] = 100;
        XLFormValidStyle(aVS);

        FPop({ oTarget: document.getElementById('i-card-type-text'), iPop: 'i-card-type-pop', vStyle: 'classic' });
        return false;

    }

}

function FCardCheck(cardnumber, cardname) {

    console.log(cardname + ' > ' + cardnumber);

    var cardType = -1, cards = [];
    // Define the cards we support. You may add addtional card types as follows.
    //  Name:         As in the selection box of the form - must be same as user's
    //  Length:       List of possible valid lengths of the card number for the card
    //  prefixes:     List of possible prefixes for the card
    //  checkdigit:   Boolean to say whether there is a check digit
    cards[0] = { name: "003", length: "13,16", prefixes: "4", checkdigit: true }; // VISA
    cards[1] = { name: "006", length: "16", prefixes: "5", checkdigit: true }; // MASTERCARD
    cards[2] = { name: "DinersClub", length: "14,16", prefixes: "300,301,302,303,304,305,36,38,39,54,55", checkdigit: true };
    cards[3] = { name: "CarteBlanche", length: "14", prefixes: "300,301,302,303,304,305", checkdigit: true };
    cards[4] = { name: "001", length: "15", prefixes: "34,37", checkdigit: true }; //AMEX
    cards[5] = { name: "Discover", length: "16", prefixes: "6011,622,64,65", checkdigit: true };
    cards[6] = { name: "JCB", length: "16", prefixes: "35", checkdigit: true };
    cards[7] = { name: "enRoute", length: "15", prefixes: "2014,2149", checkdigit: false };
    cards[8] = { name: "Solo", length: "16,18,19", prefixes: "6334,6767", checkdigit: true };
    cards[9] = { name: "Switch", length: "16,18,19", prefixes: "4903,4905,4911,4936,564182,633110,6333,6759", checkdigit: true };
    cards[10] = { name: "Maestro", length: "12,13,14,15,16,18,19", prefixes: "5018,5020,5038,5612,5893,6304,67,0604,6390,56", checkdigit: true };
    cards[11] = { name: "VisaElectron", length: "16", prefixes: "4026,417500,4405,4508,4844,4913,4917,4546", checkdigit: true };
    cards[12] = { name: "LaserCard", length: "16,17,18,19", prefixes: "6304,6706,6771,6709", checkdigit: true };

    for (var i = 0; i < cards.length; i++) {
        if (cardname.toLowerCase() == cards[i].name.toLowerCase()) {
            cardType = i;
            break;
        }
    }

    // If card type not found, report an error
    if (cardType == -1) return false;
    // Ensure that the user has provided a credit card number
    if (cardnumber.length == 0) return false;

    // Now remove any spaces from the credit card number
    cardnumber = cardnumber.replace(/\s/g, "");

    // Check that the number is numeric
    var cardNo = cardnumber
    var cardexp = /^[0-9]{13,19}$/;
    if (!cardexp.exec(cardNo)) return false;

    // Now check the modulus 10 check digit - if required
    if (cards[cardType].checkdigit) {
        var checksum = 0;                                  // running checksum total
        var mychar = "";                                   // next char to process
        var j = 1;                                         // takes value of 1 or 2
        // Process each digit one by one starting at the right
        var calc;
        for (i = cardNo.length - 1; i >= 0; i--) {
            // Extract the next digit and multiply by 1 or 2 on alternative digits.
            calc = Number(cardNo.charAt(i)) * j;
            // If the result is in two digits add 1 to the checksum total
            if (calc > 9) {
                checksum = checksum + 1;
                calc = calc - 10;
            }
            // Add the units element to the checksum total
            checksum = checksum + calc;
            // Switch the value of j
            if (j == 1) { j = 2 } else { j = 1 };
        }
        // All done - if checksum is divisible by 10, it is a valid modulus 10.
        // If not, report an error.
        if (checksum % 10 != 0) return false;
    }

    // Check it's not a spam number
    if (cardNo == '5490997771092064') return false;

    // The following are the card-specific checks we undertake.
    var LengthValid = false;
    var PrefixValid = false;
    var undefined;

    // We use these for holding the valid lengths and prefixes of a card type
    var prefix = [];
    var lengths = [];

    // Load an array with the valid prefixes for this card
    prefix = cards[cardType].prefixes.split(",");

    // Now see if any of them match what we have in the card number
    for (i = 0; i < prefix.length; i++) {
        var exp = new RegExp("^" + prefix[i]);
        if (exp.test(cardNo)) PrefixValid = true;
    }

    // If it isn't a valid prefix there's no point at looking at the length
    if (!PrefixValid) return false;

    // See if the length is valid for this card
    lengths = cards[cardType].length.split(",");
    for (j = 0; j < lengths.length; j++) {
        if (cardNo.length == lengths[j]) LengthValid = true;
    }

    // See if all is OK by seeing if the length was valid. We only check the length if all else was
    // hunky dory.
    if (!LengthValid) return false;

    // The credit card is in the required format.
    return true;
}

function XLConfirm(aIn) {

    var oBody = document.body;
    var vTitle = getT('loadingpage.areyousure');
    var vPayForm = "";
    var vProgress = "";
    var vHeader = "";
    var vFlag = "";
    var vText = "";
    var vInnerHTML = "";

    var oConfirmCover = document.createElement("div");
    oConfirmCover.id = 'i-confirm-cover';
    oConfirmCover.classList.add('c-confirm-cover');

    var oConfirm = document.createElement("div");
    oConfirm.id = 'i-confirm';
    oConfirm.classList.add('c-confirm');
    oConfirm.classList.add('c-pop');
    oConfirm.classList.add('c-show');
    oConfirm.classList.add('c-bg-ffffff');

    if (aIn['vTitle']) vTitle = aIn['vTitle'];
    if (aIn['vText']) vText = aIn['vText'];
    if (aIn['vPayForm']) vPayForm = aIn['vPayForm'];
    if (aIn['vProgress']) vProgress = aIn['vProgress'];
    if (aIn['vHeader']) vHeader = aIn['vHeader'];
    if (aIn['vFlag']) vFlag = aIn['vFlag'];

    if (vHeader != '') var oHeader = '<div class="c-accord-head c-accord-head-' + vFlag + '"><div class="c-title"><span class="c-disc">1</span> ' + vHeader + '</div></div>';
    if (vTitle != '') vInnerHTML += '<div class="c-confirm-title c-txt-m c-strong c-pad-b">' + vTitle + '</div>';
    if (vText != '') vInnerHTML += '<div class="c-confirm-text c-pad-s c-txt-light">' + vText + '</div>';
    if (vProgress != '') vInnerHTML += '<span class="spinner-cont"><div class="preloader-wrapper active"><div class="spinner-layer"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div></span>';
    if (vPayForm != '') vInnerHTML += '<div class="c-form c-form-compact" id="i-tab-card-1"> <div class="c-field c-100"> <label for="i-sec-owner" class="c-ico c-ico-dark c-ico-user-adult"></label> <input type="text" name="lastname" id="i-sec-owner" ng-model="_cardName" data-check="{check:\'text\'}" placeholder="Titulaire de la carte" class="ng-pristine ng-valid" tabindex="12"> </div><div class="c-field c-100"> <label id="i-cb-type" for="i-sec-num" class="c-ico c-ico-dark c-ico-credit-card"></label> <input type="number" name="ccnum" x-autocompletetype="cc-number" class="inspectletIgnore ng-pristine ng-valid" id="i-sec-num" data-check="{check:\'card\'}" placeholder="Numéro de carte" maxlength="16" tabindex="8" onfocus="cbCheck();"> </div><div class="c-field c-50" id="i-mm-card"> <label for="i-card-mm-text" class="c-ico c-ico-dark c-ico-calendar-r"></label> <input type="number" class="inspectletIgnore ng-pristine ng-valid" id="i-sec-num" data-check="{check:\'card\'}" placeholder="MMAA" maxlength="16" tabindex="8"> </div><div class="c-field c-50"> <label for="i-sec-ccv" class="c-ico c-ico-dark c-ico-lock"></label> <input type="number" class="inspectletIgnore" id="i-sec-ccv" oninput="ccvCut();" data-check="{check:\'numeric\'}" placeholder="Crypto." maxlength="3" tabindex="11"> </div></div>';

    if (vHeader === '') oConfirm.innerHTML = '<div class="c-pad">' + vInnerHTML + '</div><div class="c-close c-closer" onclick="XLConfirmDestroy();"></div>';
    else {
        oConfirm.innerHTML = oHeader + '<div class="c-pad">' + vInnerHTML + '</div>';
    }

    var oBtns = document.createElement("div");
    oBtns.classList.add('c-confirm-btns');
    oBtns.classList.add('c-pad');
    oBtns.classList.add('c-npad-t');
    oBtns.classList.add('c-align-c');

    var oBtnNo = document.createElement("div");
    oBtnNo.classList.add('c-btn');
    oBtnNo.classList.add('c-btn-dark');
    oBtnNo.classList.add('c-marg-rs');
    oBtnNo.innerHTML = 'Non';
    if (aIn['vTextNo']) oBtnNo.innerHTML = aIn['vTextNo'];

    var oBtnYes = document.createElement("div");
    oBtnYes.classList.add('c-btn');
    oBtnYes.innerHTML = 'Oui';
    if (aIn['vTextYes']) oBtnYes.innerHTML = aIn['vTextYes'];

    if (aIn['fCallBackYes']) oBtnYes.addEventListener("click", aIn['fCallBackYes']);
    oBtnYes.addEventListener("click", XLConfirmDestroy);
    if (aIn['fCallBackNo']) oBtnNo.addEventListener("click", aIn['fCallBackNo']);
    oBtnNo.addEventListener("click", XLConfirmDestroy);

    if (!aIn['vHideNo']) oBtns.appendChild(oBtnNo);
    if (!aIn['vHideYes']) oBtns.appendChild(oBtnYes);

    oConfirm.appendChild(oBtns);
    oBody.appendChild(oConfirmCover);
    oBody.appendChild(oConfirm);

}

function XLConfirmDestroy() {

    var oBody = document.body;
    oBody.removeChild(document.getElementById('i-confirm-cover'));
    oBody.removeChild(document.getElementById('i-confirm'));

}

// polyfill setTimeout IE9

if (document.all && !window.setTimeout.isPolyfill) {
    var __nativeST__ = window.setTimeout;
    window.setTimeout = function (vCallback, nDelay /*, argumentToPass1, argumentToPass2, etc. */) {
        var aArgs = Array.prototype.slice.call(arguments, 2);
        return __nativeST__(vCallback instanceof Function ? function () {
            vCallback.apply(null, aArgs);
        } : vCallback, nDelay);
    };
    window.setTimeout.isPolyfill = true;
}

if (document.all && !window.setInterval.isPolyfill) {
    var __nativeSI__ = window.setInterval;
    window.setInterval = function (vCallback, nDelay /*, argumentToPass1, argumentToPass2, etc. */) {
        var aArgs = Array.prototype.slice.call(arguments, 2);
        return __nativeSI__(vCallback instanceof Function ? function () {
            vCallback.apply(null, aArgs);
        } : vCallback, nDelay);
    };
    window.setInterval.isPolyfill = true;
}

// Polyfill placeholder IE9
!function (a) { "use strict"; function b() { } function c() { try { return document.activeElement } catch (a) { } } function d(a, b) { for (var c = 0, d = a.length; d > c; c++) if (a[c] === b) return !0; return !1 } function e(a, b, c) { return a.addEventListener ? a.addEventListener(b, c, !1) : a.attachEvent ? a.attachEvent("on" + b, c) : void 0 } function f(a, b) { var c; a.createTextRange ? (c = a.createTextRange(), c.move("character", b), c.select()) : a.selectionStart && (a.focus(), a.setSelectionRange(b, b)) } function g(a, b) { try { return a.type = b, !0 } catch (c) { return !1 } } function h(a, b) { if (a && a.getAttribute(B)) b(a); else for (var c, d = a ? a.getElementsByTagName("input") : N, e = a ? a.getElementsByTagName("textarea") : O, f = d ? d.length : 0, g = e ? e.length : 0, h = f + g, i = 0; h > i; i++) c = f > i ? d[i] : e[i - f], b(c) } function i(a) { h(a, k) } function j(a) { h(a, l) } function k(a, b) { var c = !!b && a.value !== b, d = a.value === a.getAttribute(B); if ((c || d) && "true" === a.getAttribute(C)) { a.removeAttribute(C), a.value = a.value.replace(a.getAttribute(B), ""), a.className = a.className.replace(A, ""); var e = a.getAttribute(I); parseInt(e, 10) >= 0 && (a.setAttribute("maxLength", e), a.removeAttribute(I)); var f = a.getAttribute(D); return f && (a.type = f), !0 } return !1 } function l(a) { var b = a.getAttribute(B); if ("" === a.value && b) { a.setAttribute(C, "true"), a.value = b, a.className += " " + z; var c = a.getAttribute(I); c || (a.setAttribute(I, a.maxLength), a.removeAttribute("maxLength")); var d = a.getAttribute(D); return d ? a.type = "text" : "password" === a.type && g(a, "text") && a.setAttribute(D, "password"), !0 } return !1 } function m(a) { return function () { P && a.value === a.getAttribute(B) && "true" === a.getAttribute(C) ? f(a, 0) : k(a) } } function n(a) { return function () { l(a) } } function o(a) { return function () { i(a) } } function p(a) { return function (b) { return v = a.value, "true" === a.getAttribute(C) && v === a.getAttribute(B) && d(x, b.keyCode) ? (b.preventDefault && b.preventDefault(), !1) : void 0 } } function q(a) { return function () { k(a, v), "" === a.value && (a.blur(), f(a, 0)) } } function r(a) { return function () { a === c() && a.value === a.getAttribute(B) && "true" === a.getAttribute(C) && f(a, 0) } } function s(a) { var b = a.form; b && "string" == typeof b && (b = document.getElementById(b), b.getAttribute(E) || (e(b, "submit", o(b)), b.setAttribute(E, "true"))), e(a, "focus", m(a)), e(a, "blur", n(a)), P && (e(a, "keydown", p(a)), e(a, "keyup", q(a)), e(a, "click", r(a))), a.setAttribute(F, "true"), a.setAttribute(B, T), (P || a !== c()) && l(a) } var t = document.createElement("input"), u = void 0 !== t.placeholder; if (a.Placeholders = { nativeSupport: u, disable: u ? b : i, enable: u ? b : j }, !u) { var v, w = ["text", "search", "url", "tel", "email", "password", "number", "textarea"], x = [27, 33, 34, 35, 36, 37, 38, 39, 40, 8, 46], y = "#ccc", z = "placeholdersjs", A = new RegExp("(?:^|\\s)" + z + "(?!\\S)"), B = "data-placeholder-value", C = "data-placeholder-active", D = "data-placeholder-type", E = "data-placeholder-submit", F = "data-placeholder-bound", G = "data-placeholder-focus", H = "data-placeholder-live", I = "data-placeholder-maxlength", J = 100, K = document.getElementsByTagName("head")[0], L = document.documentElement, M = a.Placeholders, N = document.getElementsByTagName("input"), O = document.getElementsByTagName("textarea"), P = "false" === L.getAttribute(G), Q = "false" !== L.getAttribute(H), R = document.createElement("style"); R.type = "text/css"; var S = document.createTextNode("." + z + " {color:" + y + ";}"); R.styleSheet ? R.styleSheet.cssText = S.nodeValue : R.appendChild(S), K.insertBefore(R, K.firstChild); for (var T, U, V = 0, W = N.length + O.length; W > V; V++) U = V < N.length ? N[V] : O[V - N.length], T = U.attributes.placeholder, T && (T = T.nodeValue, T && d(w, U.type) && s(U)); var X = setInterval(function () { for (var a = 0, b = N.length + O.length; b > a; a++) U = a < N.length ? N[a] : O[a - N.length], T = U.attributes.placeholder, T ? (T = T.nodeValue, T && d(w, U.type) && (U.getAttribute(F) || s(U), (T !== U.getAttribute(B) || "password" === U.type && !U.getAttribute(D)) && ("password" === U.type && !U.getAttribute(D) && g(U, "text") && U.setAttribute(D, "password"), U.value === U.getAttribute(B) && (U.value = T), U.setAttribute(B, T)))) : U.getAttribute(C) && (k(U), U.removeAttribute(B)); Q || clearInterval(X) }, J); e(a, "beforeunload", function () { M.disable() }) } }(this);

V_DATE_SELECT = '';

function XLDateSelect(aIn) {
    var isServair = window.site.partnerId === "servair";
    var dateType = "";
    
    if (aIn) {
        dateType = aIn['vTpl'];
        console.log("> dateType ");
        console.log(dateType);
        if (currentDateSelect) {
            var oldDateSelect = currentDateSelect + '-ds-pop';
            FPopHide({ iPop: oldDateSelect });
            currentDateSelect = (aIn['oField'].id);
        }
        else {
            if (aIn['oField'].id != null && aIn['oField'].id != '') {
                currentDateSelect = (aIn['oField'].id);
            }
        }
    }

    O_DATE_SELECT = aIn['oField'];

    vDataValid = aIn['oField'].getAttribute('data-check');
    aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")")));

    var aDate = new Array();
    aDate['valid'] = false;

    V_DATE_SELECT = aIn['oField'].value;
    aIn['oField'].value = '';

    if (aIn['oField'].value) {
        var regPattern = new RegExp("^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[0-9]{4}$");
        if (aIn['oField'].value.match(regPattern)) {
            var aSField = aIn['oField'].value.split('/');
            aDate['valid'] = true;
            aDate['day'] = aSField[0];
            aDate['month'] = aSField[1];
            aDate['year'] = aSField[2];
        }
    }

    //alert(aIn['oField'].value) ;
    var vDate = new Date()
    var oBody = document.body;
    //oBody.classList.add('c-noscroll') ;
    var oDateSelPop = document.createElement("div");
    oDateSelPop.id = 'i-date-select';
    oDateSelPop.id = aIn['oField'].id + '-ds-pop';
    oDateSelPop.classList.add('c-pop');
    oDateSelPop.classList.add('c-arrow');
    oDateSelPop.classList.add('c-ds');
    oDateSelPop.setAttribute('data-hide-destroy', true);

    var oDateRail = document.createElement("div");
    oDateRail.classList.add('xlsl-rail');

    var oDateSel = document.createElement("div");
    oDateSel.classList.add('xlsl-obj');
    oDateSel.id = aIn['oField'].id + '-ds';

    var oDateSelTit = document.createElement("div");
    oDateSelTit.classList.add('c-title');
    oDateSelTit.classList.add('c-npad');
    //oDateSelTit.innerHTML = 'Composez votre date :' ;
    oDateSelTit.innerHTML = '<span class="c-ds-txt-di"></span><span class="c-ds-txt-mi"></span><span class="c-ds-txt c-txt-l c-pad-ls"><span class="c-ds-txt-d"></span> <span class="c-ds-txt-m"></span> <span class="c-ds-txt-y"></span></span>';
    oDateSel.appendChild(oDateSelTit);

    var oDateSelL = document.createElement("div");
    oDateSelL.addEventListener("click", function () { XLSlGo({ i: aIn['oField'].id + '-ds', d: 'l' }); });
    oDateSelL.classList.add('c-ds-l');
    oDateSelL.id = aIn['oField'].id + '-ds-l';
    oDateSelL.innerHTML = "<i class='icon-disc-arrow-l c-txt-light c-txt-xxl c-link-hover transition'></i>";
    oDateSel.appendChild(oDateSelL);

    var oDateSelR = document.createElement("div");
    oDateSelR.addEventListener("click", function () { XLSlGo({ i: aIn['oField'].id + '-ds', d: 'r' }); });
    //oDateSelR.onclick = function() {alert('qsdq');} ;
    oDateSelR.classList.add('c-ds-r');
    oDateSelR.id = aIn['oField'].id + '-ds-r';
    oDateSelR.innerHTML = "<i class='icon-disc-arrow-r c-txt-light c-txt-xxl c-link-hover transition'></i>";
    oDateSel.appendChild(oDateSelR);

    var oDateSelColD = document.createElement("div");
    oDateSelColD.classList.add('xlsl-pan');
    oDateSelColD.classList.add('c-ds-d');
    oDateRail.appendChild(oDateSelColD);

    var oDateSelColM = document.createElement("div");
    oDateSelColM.classList.add('xlsl-pan');
    oDateSelColM.classList.add('c-ds-m');
    oDateRail.appendChild(oDateSelColM);

    var oDateSelColY = document.createElement("div");
    //oDateSelColY.addEventListener("mouseover", function(){  this.scrollIntoView() ; }) ;
    //oDateSelColY.addEventListener("touchstart", function(){  alert('SCROLL') ; }) ;
    oDateSelColY.addEventListener("touchstart", function () { V_XLSL_PREVENT = true });
    oDateSelColY.addEventListener("touchend", function () { V_XLSL_PREVENT = false });

    oDateSelColY.classList.add('xlsl-pan');
    oDateSelColY.classList.add('c-ds-y');
    oDateRail.appendChild(oDateSelColY);

    oDateSel.appendChild(oDateRail);

    var oDateSelColCl = document.createElement("div");
    oDateSelColCl.classList.add('c-ds-cl');
    oDateSel.appendChild(oDateSelColCl);

    var oDateSelColC = document.createElement("div");
    oDateSelColC.classList.add('c-ds-c');
    oDateSelColC.classList.add('c-pad-s');
    /*oDateSelColC.innerHTML = '<div class="c-ds-er c-txt-red transition"><i class="icon-alert c-pad-rs"></i><span>Error ...</span></div>';*/
    oDateSelColC.innerHTML = '<div class="c-ds-er alert alert--warning alert--small c-nmarg-t transition"><svg width="16px" height="16px" viewBox="0 0 240 240"><path d="M118.3,220c-6.2,0-11.2-1.8-14.8-5.3c-3.5-3.5-5.3-8.5-5.3-14.8v-4.5c0-6.2,1.8-11.2,5.3-14.8s8.5-5.3,14.8-5.3h3.5  c6.2,0,11.2,1.8,14.8,5.3c3.5,3.5,5.3,8.5,5.4,14.8v4.5c0,6.2-1.8,11.2-5.4,14.8c-3.5,3.5-8.5,5.3-14.8,5.3H118.3z M120.1,154.6  c-8.2,0-13.3-5.1-14.1-14l-7.6-96.7c-0.4-6.7,1.4-12.3,5.4-16.9s9.4-7,15.9-7h0.1c6.5,0,11.9,2.3,16.1,6.9s5.9,10.3,5.3,17  l-7.4,96.7C133.2,149.6,128.2,154.6,120.1,154.6z"></path></svg></div>';
    oDateSel.appendChild(oDateSelColC);

    if ($scope.isServair && dateType != "passport") {
        var oDateSelColCServair = document.createElement("div");
        oDateSelColCServair.classList.add('c-servair-warning');
        oDateSelColCServair.classList.add('c-pad-s');
        oDateSelColCServair.innerHTML = '<div class="c-txt-red transition"><i class="icon-alert c-pad-rs"></i><span>Si l’année de naissance du passager n’est pas proposée ci-dessus, cela signifie qu’elle correspond à une autre typologie de passager (adulte/enfant/bébé). Dans ce cas, veuillez contacter votre service RH pour qu’il modifie votre date de naissance.</span></div>';
        oDateSel.appendChild(oDateSelColCServair);
    }

    vClassT = '';

    var vInnerDays = '';
    for (var i = 1; i <= 31; ++i) {
        //vClassT = aDate['valid'] && aDate['day'] == i ? vClassT = 'class="c-on"' : '' ;
        vInnerDays += '<div onclick="XLDS(this,\'d\',' + i + ')" ' + vClassT + '>' + i + '</div>';
    }
    oDateSelColD.innerHTML = '<div class="c-ds-title">' + getT('homepage.calender.Selecttheday') + '</div><div class="c-ds-pick">' + vInnerDays + '</div>';

    var vInnerMonth = '';
    for (var i = 1; i <= 12; ++i) {
        //vInnerMonth += '<div onclick="XLDS(this,\'m\',\''+ i +'\')">' + A_CAL_MONTHS[i].substring(0, 3) + '</div>' ;
        //vClassT = aDate['valid'] && aDate['month'] == i ? vClassT = 'class="c-on"' : '' ;
        vInnerMonth += '<div onclick="XLDS(this,\'m\',\'' + i + '\')" ' + vClassT + '>' + getT(A_CAL_MONTHS[i]) + '</div>';
    }
    oDateSelColM.innerHTML = '<div class="c-ds-title">' + getT('homepage.calender.Selectthemonth') + '</div><div class="c-ds-pick">' + vInnerMonth + '</div>';

    var vInnerYears = '',
        vYearFrom = vDate.getFullYear() - 120,
        vYearTo = vDate.getFullYear();

    if (aIn['vTpl']) {
        if (aIn['vTpl'] == 'passport') {
            vYearFrom = vDate.getFullYear(),
                vYearTo = vDate.getFullYear() + 15;
        }
    }

    if (aDataValid && aDataValid['date_min']) {
        var aTmp = aDataValid['date_min'].split('/');
        vYearFrom = aTmp[2];

    }

    if (aDataValid && aDataValid['date_max']) {
        var aTmp = aDataValid['date_max'].split('/');
        vYearTo = aTmp[2];

    }

    for (var i = vYearFrom; i <= vYearTo; ++i) {
        //vClassT = aDate['valid'] && aDate['year'] == i ? vClassT = 'class="c-on"' : '' ;
        vInnerYears += '<div onclick="XLDS(this,\'y\',' + i + ');XLDSDdl(this,\'y\',' + i + ')" ' + vClassT + ' >' + i + '</div>';
    }
    oDateSelColY.innerHTML = '<div class="c-ds-title">' + getT('homepage.calender.Selecttheyear') + '</div><div class="c-ds-pick c-ds-pick-y">' + vInnerYears + '</div>';

    var oDatePopArr = document.createElement("div");
    oDatePopArr.classList.add('c-pop-arr');

    oDateSelPop.appendChild(oDateSel);
    oDateSelPop.appendChild(oDatePopArr);
    var oDateSelClose = document.createElement("div");
    oDateSelClose.classList.add('c-close');
    oDateSelClose.classList.add('c-closer');
    oDateSelPop.appendChild(oDateSelClose);
    oBody.appendChild(oDateSelPop);

    oListY = oDateSel.getElementsByClassName('c-ds-pick-y')[0];
    oListY.scrollTop = 353;

    XLSlInit({
        i: aIn['oField'].id + '-ds',
        pstart: 1
    });

    FPop({ oField: aIn['oField'], iPop: aIn['oField'].id + '-ds-pop', vPos: 'bc', vNoBodyHide: true, fCallBackOnClose: XLDSClosed });

}

function XLDSClosed() {
    O_DATE_SELECT.value = V_DATE_SELECT;
}

function XLDSDdl(o, w, v) {

    XLDS(o, w, v);
    var ot = o.parentNode.parentNode;
    XLDSF(ot);

}

function XLDS(o, w, v) {

    oDs = o.parentNode.parentNode.parentNode.parentNode;

    oTextError = oDs.getElementsByClassName('c-ds-er')[0];
    oTextError.classList.remove('c-on');

    aDi = o.parentNode.parentNode.getElementsByTagName('div');
    aDiLength = aDi.length;
    for (var i = 0; i < aDiLength; ++i) {
        aDi[i].classList.remove('c-on');
    }

    o.classList.add('c-on');
    oText = oDs.getElementsByClassName('c-ds-txt-' + w)[0];
    vText = v;
    if (w == 'm') {
        vText = getT(A_CAL_MONTHS[v]);
        oTextMi = oDs.getElementsByClassName('c-ds-txt-mi')[0];
        vTemp = v;
        if (v <= 9) vTemp = '0' + v;
        oTextMi.innerHTML = vTemp;
    }
    else if (w == 'd') {
        oTextDi = oDs.getElementsByClassName('c-ds-txt-di')[0];
        vTemp = v;
        if (v <= 9) vTemp = '0' + v;
        oTextDi.innerHTML = vTemp;
    }
    oText.innerHTML = vText;

    oTextD = oDs.getElementsByClassName('c-ds-txt-d')[0];
    oTextM = oDs.getElementsByClassName('c-ds-txt-m')[0];
    oTextY = oDs.getElementsByClassName('c-ds-txt-y')[0];

    if (oTextD.innerHTML != '' && oTextM.innerHTML != '' && oTextY.innerHTML != '') {
        //oDSValid = oDs.getElementsByClassName('c-ds-v')[0] ;
        oDSOut = oDs.getElementsByClassName('c-ds-out')[0];
        //oDSValid.classList.remove('c-disabled');
    }

    if (w != 'y')
        XLSlGo({ i: oDs.id, d: 'r' });

}


function XLDSF(o) {
    if (O_DATE_SELECT) {

        if (!o) return false;
        oDs = o.parentNode.parentNode;

        var TextDi = oDs.getElementsByClassName('c-ds-txt-di')[0].innerHTML;
        var TextMi = oDs.getElementsByClassName('c-ds-txt-mi')[0].innerHTML;
        var TextY = oDs.getElementsByClassName('c-ds-txt-y')[0].innerHTML;
        var oTextError = oDs.getElementsByClassName('c-ds-er')[0];
        var oTextErrorContentActualContent = oTextError.getElementsByTagName('p');
        if (oTextErrorContentActualContent.length != 0) {
            oTextErrorContentActualContent[0].remove();
        }
        var oTextErrorContent = document.createElement('p');

        vDataValid = O_DATE_SELECT.getAttribute('data-check');
        aDataValid = JSON.parse(JSON.stringify(eval("(" + vDataValid + ")")));

        if (TextDi != '' && TextMi != '' && TextY != '') {
            var userDate = moment({ y: TextY, M: TextMi - 1, d: TextDi });

            if (userDate.isValid()) {
                if (aDataValid) {
                    if (aDataValid['date_min'] && aDataValid['date_min'] != '') {
                        var vDateAfter = moment(aDataValid['date_min'], "DD-MM-YYYY");
                        if (userDate < vDateAfter) {
                            oTextErrorContent.innerHTML = getT('loadingpage.mindateinvalid') + aDataValid['date_min'];
                            oTextError.appendChild(oTextErrorContent);
                            oTextError.classList.add('c-on');
                            return false;
                        }
                    }
                    if (aDataValid['date_max'] && aDataValid['date_max'] != '') {
                        var vDateBefore = moment(aDataValid['date_max'], "DD-MM-YYYY");
                        var vTempDateSixteen = moment(aDataValid['date_max'], "DD-MM-YYYY").subtract(4, "years").format("DD/MM/YYYY");
                        if ($scope.hasFlightHotelFormSummary && O_DATE_SELECT.classList.contains('adult-birthday')) {
                            vTempDateSixteen = moment(aDataValid['date_max'], "DD-MM-YYYY").add(2, "years").format("DD/MM/YYYY");
                        }
                        var vDateSixteen = moment(vTempDateSixteen, "DD/MM/YYYY");
                        var nbAdults = document.getElementsByClassName("adult-birthday");
                        if (userDate > vDateBefore) {
                            if (O_DATE_SELECT.hasAttribute("data-error-date-max")) oTextErrorContent.innerHTML = O_DATE_SELECT.getAttribute("data-error-date-max");
                            else oTextErrorContent.innerHTML = getT('loadingpage.maxdateinvalid') + aDataValid['date_max'];
                            oTextError.appendChild(oTextErrorContent);
                            oTextError.classList.add('c-on');
                            return false;
                        }
                        else if (userDate > vDateSixteen && $scope.bkgData && $scope.bkgData.request.childs > 0) {
                            if ($scope.siteIsB2b && $scope.hasFlightHotelFormSummary && !O_DATE_SELECT.classList.contains('adult-birthday'));
                            else if (nbAdults) {
                                if (nbAdults.length > 1) {
                                    var oldEnough = 0;
                                    for (var i = 0; i < nbAdults.length; i++) {
                                        if (nbAdults.value != "" && moment(nbAdults[i].value, "DD/MM/YYYY") < vDateSixteen) oldEnough = oldEnough + 1;
                                    }
                                    if (oldEnough == 0) {
                                        oTextErrorContent.innerHTML = getT('airbooking.paxsinfo.undersixteenerrchild2');
                                        oTextError.appendChild(oTextErrorContent);
                                        oTextError.classList.add('c-on');
                                        return false;
                                    }
                                }
                                else if (nbAdults.length == 1) {
                                    var oldEnough = 0;
                                    if (nbAdults.value != "" && moment(nbAdults[0].value, "DD/MM/YYYY") < vDateSixteen) oldEnough = oldEnough + 1;

                                    if (oldEnough == 0) {
                                        oTextErrorContent.innerHTML = getT('airbooking.paxsinfo.undersixteenerrchild');
                                        oTextError.appendChild(oTextErrorContent);
                                        oTextError.classList.add('c-on');
                                        return false;
                                    }
                                }
                            }
                        }
                        else if (userDate > vDateSixteen && $scope.bkgData && $scope.bkgData.request.infants > 0) {
                            if (nbAdults) {
                                if (nbAdults.length > 1) {
                                    var oldEnough = 0;
                                    for (var i = 0; i < nbAdults.length; i++) {
                                        if (nbAdults.value != "" && moment(nbAdults[i].value, "DD/MM/YYYY") < vDateSixteen) oldEnough = 1;
                                    }
                                    if (oldEnough == 0) {
                                        oTextErrorContent.innerHTML = getT('airbooking.paxsinfo.undersixteenerrinfant2');
                                        oTextError.appendChild(oTextErrorContent);
                                        oTextError.classList.add('c-on');
                                        return false;
                                    }
                                }
                                else if (nbAdults.length == 1) {
                                    var oldEnough = 0;
                                    if (nbAdults.value != "" && moment(nbAdults[0].value, "DD/MM/YYYY") < vDateSixteen) oldEnough = 1;

                                    if (oldEnough == 0) {
                                        oTextErrorContent.innerHTML = getT('airbooking.paxsinfo.undersixteenerrinfant');
                                        oTextError.appendChild(oTextErrorContent);
                                        oTextError.classList.add('c-on');
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                }
                O_DATE_SELECT.value = userDate.format('DD/MM/YYYY');
                V_DATE_SELECT = O_DATE_SELECT.value;
                fireEvent(O_DATE_SELECT, "input");
                fireEvent(O_DATE_SELECT, "keydown");
                O_DATE_SELECT.setAttribute('data-check', '{check:\'date\'}');
                XLFieldCheck({ oObj: O_DATE_SELECT });
                var birthday = aDataValid['birthday'] === undefined ? true : aDataValid['birthday'];
                if (vDateAfter && vDateBefore) O_DATE_SELECT.setAttribute('data-check', '{check:\'date\',date_min:\'' + aDataValid['date_min'] + '\',date_max:\'' + aDataValid['date_max'] + '\',birthday:' + birthday + ',nolive:true}');
                O_DATE_SELECT = false;
                FPopHide({ iPop: oDs.id + '-pop' });
            }
            else {
                oTextErrorContent.innerHTML = getT('loadingpage.invaliddate');
                oTextError.appendChild(oTextErrorContent);
                oTextError.classList.add('c-on');
                return false;
            }
        }
        else {
            oTextErrorContent.innerHTML = getT('airbooking.incompletedate');
            oTextError.appendChild(oTextErrorContent);
            oTextError.classList.add('c-on');
            return false;
        }
    }
    else {
        return false;
    }
}

function fireEvent(element, event) {
    //console.log('fireEvent');
    if (document.createEvent) {
        // dispatch for firefox + others
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type,bubbling,cancelable
        return !element.dispatchEvent(evt);
    }
    else if (document.createEventObject) {
        // dispatch for IE < 9
        var evt = document.createEventObject();
        return element.fireEvent('on' + event, evt)
    }
}

function isValidDate(dateStr) {

    // Checks for the following valid date formats:
    // MM/DD/YYYY
    // Also separates date into month, day, and year variables
    var datePat = /^(\d{2,2})(\/)(\d{2,2})\2(\d{4}|\d{4})$/;

    var matchArray = dateStr.match(datePat); // is the format ok?
    if (matchArray == null) {
        //alert("Date must be in MM/DD/YYYY format")
        return false;
    }

    month = matchArray[1]; // parse date into variables
    day = matchArray[3];
    year = matchArray[4];
    if (month < 1 || month > 12) { // check month range
        //alert("Month must be between 1 and 12");
        return false;
    }
    if (day < 1 || day > 31) {
        //alert("Day must be between 1 and 31");
        return false;
    }
    if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
        //alert("Month "+month+" doesn't have 31 days!")
        return false;
    }
    if (month == 2) { // check for february 29th
        var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
        if (day > 29 || (day == 29 && !isleap)) {
            //alert("February " + year + " doesn't have " + day + " days!");
            return false;
        }
    }
    return true;  // date is valid
}

A_XLSL = new Array();
var V_XLSL_PAN = 1;
var V_XLSL_PREVENT = true;

function XLSlInit(aIn) {

    var oSlider = document.getElementById(aIn['i']);
    var oSliderRail = oSlider.getElementsByClassName('xlsl-rail')[0];
    var oSliderL = document.getElementById(aIn['i'] + '-l') ? document.getElementById(aIn['i'] + '-l') : false;
    var oSliderR = document.getElementById(aIn['i'] + '-r') ? document.getElementById(aIn['i'] + '-r') : false;
    var aPans = oSlider.getElementsByClassName('xlsl-pan');
    var aPansLength = aPans.length;
    var vMaxWidth = 0;
    var vPanStart = aIn['pstart'] ? aIn['pstart'] : 1;
    for (var i = 0; i < aPansLength; ++i) {
        aPans[i].setAttribute('data-xlsl-n', i + 1);
        vMaxWidth += aPans[i].offsetWidth;
    }
    oSliderRail.style.width = vMaxWidth + 'px';
    //vMaxWidth = vMaxWidth - oSlider.offsetWidth ;
    //console.log('MAX WIDTH:'+ vMaxWidth) ;

    oSlider.addEventListener("touchstart", XLSlStart, false);
    //oSlider.addEventListener("mousedown", XLSlStart, false);
    oSlider.addEventListener("touchmove", XLSlMove, false);
    oSlider.addEventListener("mousemove", XLSlMove, false);
    oSlider.addEventListener("touchend", XLSlEnd, false);
    //oSlider.addEventListener("mouseup", XLSlEnd, false);

    if (vPanStart) {

        oSlider.classList.add('xlsl-anim-no');

        window.setTimeout(function () {
            XLSlGo({ i: aIn['i'], n: vPanStart });
        }, 1);

        window.setTimeout(function () {
            oSlider.classList.remove('xlsl-anim-no');
        }, 150);

        V_XLSL_PAN = vPanStart;

    }

    if (V_XLSL_PAN <= 1) V_XLSL_PAN = 1;
    else if (V_XLSL_PAN >= aPansLength) V_XLSL_PAN = aPansLength;

    if (vPanStart == 1) {
        //if (oSliderL) oSliderL.classList.add('c-display-none') ;
    }
    else if (vPanStart == aPansLength) {
        //if (oSliderR) oSliderR.classList.add('c-display-none') ;
    }

}

function XLSlStart(event) {

    //event.preventDefault();

    var oTarget = XLObjTarget(event);
    if (oTarget) {
        A_XLSL['npan'] = 0;
        if (oTarget.tagName == 'BODY') return false;
        while (oTarget.tagName != 'BODY' && oTarget.className.indexOf("xlsl-obj") == -1) {
            if (oTarget.className.indexOf("xlsl-pan") != -1) A_XLSL['npan'] = parseInt(oTarget.getAttribute('data-xlsl-n'));
            oTarget = oTarget.parentNode;
        }
        if (oTarget.tagName == 'BODY') return false;

        if (oTarget) {
            A_XLSL['obj'] = oTarget;
            A_XLSL['sx'] = A_XLSL['obj'].scrollLeft;
            A_XLSL['drag'] = true;
            A_XLSL['rail'] = A_XLSL['obj'].getElementsByClassName('xlsl-rail')[0];
            A_XLSL['rsx'] = parseInt(A_XLSL['rail'].offsetLeft);
            A_XLSL['rsy'] = parseInt(A_XLSL['rail'].offsetTop);
            A_XLSL['csx'] = event.touches ? event.touches[0].pageX : event.pageX;
            A_XLSL['csy'] = event.touches ? event.touches[0].pageY : event.pageY;
            A_XLSL['obj'].classList.add('xlsl-anim-no');
        }
    }
}

function XLSlMove(event) {

    if (A_XLSL['obj'] && !V_XLSL_PREVENT) {

        V_XLSL_PREVENT = false;
        //if (V_XLSL_PREVENT) event.preventDefault();
        //event.cancelBubble = true;
        var vXLSLx = parseInt(A_XLSL['obj'].getAttribute('data-xlsl-x'));
        A_XLSL['cx'] = event.touches ? event.touches[0].pageX : event.pageX;
        A_XLSL['cy'] = event.touches ? event.touches[0].pageY : event.pageY;
        vMoveByX = A_XLSL['cx'] - A_XLSL['csx'] + vXLSLx;
        XLTrans2D({ o: A_XLSL['rail'], x: vMoveByX, y: 0 });

    }

}

function XLSlEnd() {

    if (A_XLSL['obj']) {
        A_XLSL['obj'].classList.remove('xlsl-anim-no');
        vMovedByX = A_XLSL['cx'] - A_XLSL['csx'];

        if ((vMovedByX < 0 && vMovedByX > -30) || (vMovedByX > 0 && vMovedByX < 30)) {
            XLSlGo({ i: A_XLSL['obj'].id, n: A_XLSL['npan'], vAnimClass: 'xlsl-anim-back' });
        }
        else if (vMovedByX <= -30) {
            XLSlGo({ i: A_XLSL['obj'].id, d: 'r' });
        }
        else if (vMovedByX >= 30) {
            XLSlGo({ i: A_XLSL['obj'].id, d: 'l' });
        }
    }
    A_XLSL = new Array();

}

function XLSlGo(aIn) {

    var oSlider = document.getElementById(aIn['i']);
    if (oSlider) {
        var oSliderRail = oSlider.getElementsByClassName('xlsl-rail')[0];
        var oSliderL = document.getElementById(aIn['i'] + '-l') ? document.getElementById(aIn['i'] + '-l') : false;
        var oSliderR = document.getElementById(aIn['i'] + '-r') ? document.getElementById(aIn['i'] + '-r') : false;
        var aPans = oSlider.getElementsByClassName('xlsl-pan');
        var aPansLength = aPans.length;
        var oSliderData = oSlider.getAttribute('data-xlsl') ? JSON.parse(JSON.stringify(eval("(" + oSlider.getAttribute('data-xlsl') + ")"))) : false;
        var vXLSLx = oSlider.getAttribute('data-xlsl-x');
        var vSlideByX = 0;

        var vMaxWidth = 0;
        for (var i = 0; i < aPansLength; ++i) {
            vMaxWidth += aPans[i].offsetWidth;
        }
        vMaxWidth = vMaxWidth - oSlider.offsetWidth;

        if (aIn['vAnimClass']) oSlider.classList.add(aIn['vAnimClass']);

        if (aIn['n'] && aPans[aIn['n'] - 1]) {
            vSlideByX = aPans[aIn['n'] - 1].offsetLeft * -1;
            V_XLSL_PAN = aIn['n'];
        }
        else if (aIn['d'] && aIn['d'] == 'r') {
            if (window.matchMedia("(min-width: 640px)").matches && oSlider.classList.contains("c-cal")) {
                vSlideByX = (oSlider.offsetWidth / 2 + (vXLSLx * -1)) * -1 + oSlider.scrollLeft;
            }
            else vSlideByX = (oSlider.offsetWidth + (vXLSLx * -1)) * -1 + oSlider.scrollLeft;
            V_XLSL_PAN++;
        }
        else if (aIn['d'] && aIn['d'] == 'l') {
            if (window.matchMedia("(min-width: 640px)").matches && oSlider.classList.contains("c-cal")) {
                vSlideByX = vXLSLx - oSlider.offsetWidth / 2 * -1 - oSlider.scrollLeft;
            }
            else vSlideByX = vXLSLx - oSlider.offsetWidth * -1 - oSlider.scrollLeft;
            V_XLSL_PAN--;
        }

        if (V_XLSL_PAN <= 1) V_XLSL_PAN = 1;
        else if (V_XLSL_PAN >= aPansLength) V_XLSL_PAN = aPansLength;

        if (vSlideByX > 0) vSlideByX = 0;
        else if (vSlideByX < vMaxWidth * -1) vSlideByX = vMaxWidth * -1;

        //console.log(vSlideByX + ' <> ' + vMaxWidth) ;

        if (oSliderL) oSliderL.style.display = 'block';
        if (oSliderR) oSliderR.style.display = 'block';

        if (V_XLSL_PAN == 1 && oSliderL) oSliderL.style.display = 'none';
        else if (V_XLSL_PAN == aPansLength && oSliderR) oSliderR.style.display = 'none';

        XLTrans2D({ o: oSliderRail, x: vSlideByX, y: 0 });
        oSlider.setAttribute('data-xlsl-x', vSlideByX);

        if (aIn['vAnimClass']) {
            window.setTimeout(function () {
                oSlider.classList.remove(aIn['vAnimClass']);
            }, 10);

        }
    }
    //console.log('PANNEL : ' + V_XLSL_PAN) ;

}

function XLTrans2D(aIn) {

    aIn['x'] = Math.round(aIn['x']);
    if (!aIn['o']) return false;
    if (aIn['o'] !== null) {
        if (aIn['clear']) {
            aIn['o'].style.transform = '';
            aIn['o'].style.OTransform = '';
            aIn['o'].style.msTransform = '';
            aIn['o'].style.MozTransform = '';
            aIn['o'].style.WebkitTransform = '';
        }
        else {
            aIn['o'].style.transform = 'translate(' + aIn['x'] + 'px, ' + aIn['y'] + 'px)';
            aIn['o'].style.OTransform = 'translate(' + aIn['x'] + 'px, ' + aIn['y'] + 'px)';
            aIn['o'].style.msTransform = 'translate(' + aIn['x'] + 'px, ' + aIn['y'] + 'px)';
            aIn['o'].style.MozTransform = 'translate(' + aIn['x'] + 'px, ' + aIn['y'] + 'px)';
            aIn['o'].style.WebkitTransform = 'translate(' + aIn['x'] + 'px, ' + aIn['y'] + 'px)';
        }
    }
}

function XLTrans3D(aIn) {

    aIn['x'] = Math.round(aIn['x']);

    if (aIn['clear']) {
        aIn['o'].style.transform = '';
        aIn['o'].style.OTransform = '';
        aIn['o'].style.msTransform = '';
        aIn['o'].style.MozTransform = '';
        aIn['o'].style.WebkitTransform = '';
    }
    else {
        aIn['o'].style.transform = 'translate3D(' + aIn['x'] + 'px, ' + aIn['y'] + 'px, ' + aIn['z'] + 'px)';
        aIn['o'].style.OTransform = 'translate3D(' + aIn['x'] + 'px, ' + aIn['y'] + 'px, ' + aIn['z'] + 'px)';
        aIn['o'].style.msTransform = 'translate3D(' + aIn['x'] + 'px, ' + aIn['y'] + 'px, ' + aIn['z'] + 'px)';
        aIn['o'].style.MozTransform = 'translate3D(' + aIn['x'] + 'px, ' + aIn['y'] + 'px, ' + aIn['z'] + 'px)';
        aIn['o'].style.WebkitTransform = 'translate3D(' + aIn['x'] + 'px, ' + aIn['y'] + 'px, ' + aIn['z'] + 'px)';
    }

}


function FVideoLoopIn() {

    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1;
    var isIEMobile = navigator.userAgent.match(/IEMobile/i);
    var video = document.getElementById('i-video');

    if (isSafari || isIEMobile) {
        video.parentElement.removeChild(video);
    }
    else {
        var oBody = document.body;
        oBody.style.background = 'transparent';
        video.play();
        if (!video.paused) {
            video.style.display = 'block';
            document.getElementById('i-video-img').style.display = 'none';
        }
    }
}

function FCook() {


    try {
        if (!localStorage.cook && window.site) {
            if (
                (window.site.partnerId !== "m")
                && (window.site.partnerId !== "b2c")
            ) {
                localStorage.cook = true;
                var oBody = document.body;
                var oCook = document.createElement("div");
                oCook.id = 'i-cook';
                oCook.classList.add('c-cook');
                oCook.classList.add('c-txt-white');
                oCook.classList.add('c-w-100');
                oCook.classList.add('c-align-c');
                oCook.classList.add('c-txt-s');
                oCook.classList.add('c-pad-s');
                oCook.innerHTML = getT('airbooking.ocook');
                oBody.appendChild(oCook);

                window.setTimeout(function () {
                    oCook.classList.add('c-cook-show');
                }, 1);

            }
        }
    }
    catch (e) { }
}

function FCookHide() {
    document.getElementById('i-cook').classList.remove('c-cook-show');
    try {
        localStorage.cook = true;
        $(document).trigger('cookie-accepted');
    }
    catch (e) { }
}

function FPopNoFee() {

    oDate = new Date;
    var vMKTimeNow = Math.floor(Date.now() / 1000);

    // 604800 = 1 week
    if (!localStorage.popnofee || vMKTimeNow - localStorage.popnofee > 604800) {
        FPopNoFeeRun();
        localStorage.popnofee = vMKTimeNow;
        if (window.site.partnerId === "cdiscountvol") {
            setTimeout(function () {
                if (document.getElementById('i-pop-nofee')) document.getElementById('i-pop-nofee').style.display = "none";
            }, 6000);
        }
    }

}

function FPopNoFeeRun() {

    oFirstFlight = document.getElementById('i-flight-1');
    if (!oFirstFlight) return false;
    oPopNoFee = document.getElementById('i-pop-nofee');
    if (!oPopNoFee) return false;
    obanners = document.getElementById('banners-widget');
    obannersP = document.querySelector('#banners-widget p');
    vTop = oFirstFlight.offsetTop + 6;
    if (!obanners.contains(obannersP)) {
        if (window.innerWidth < 768) vTop += 210;
        else if (window.innerWidth >= 768 && window.innerWidth < 1024) vTop += 135;
        else if (window.innerWidth >= 1024) vTop += 83;
    }
    vLeft = oFirstFlight.offsetLeft;
    oPopNoFee.setAttribute('style', 'top:' + vTop + 'px !important;');

    window.setTimeout(function () {
        if (window.innerWidth < 768) vTop -= 6;
        if (window.innerWidth > 1199) vLeft -= 9;
        oPopNoFee.setAttribute('style', 'top:' + vTop + 'px !important;left: ' + vLeft + 'px');
    }, 3000);

}
function switchSearchForm(type) {

    var nav = document.getElementById("i-nav-search");
    var engineContainer = $(".c-hp-search");
    if (localStorage.getItem("searchFormProduct") === null || localStorage.getItem("searchFormProduct") !== type) {
        localStorage.setItem("searchFormProduct", type);
    }
    if (nav != null) {
        var volTab = document.getElementById("i-nav-vols");
        var hotelTab = document.getElementById("i-nav-hotels");
        var carTab = document.getElementById("i-nav-cars");
        var transfertTab = document.getElementById("i-nav-transferts");
        var volHotelTab = document.getElementById("i-nav-volshotels");

        var searchVols = document.getElementById("i-search");
        var searchHotels = document.getElementById("i-search-hotel");
        var searchCars = document.getElementById("i-search-cars");
        var searchTransfert = document.getElementById("i-search-transfert");
        var searchLocation = document.getElementById("i-search-location");
        var searchVolHotel = document.getElementById("i-search-flighthotel");

        if ($('#i-nav-search .unactive-dark').length > 0) $('#i-nav-search .unactive-dark').removeClass("unactive-dark");
        if ($('#i-nav-search .active').length > 0) $('#i-nav-search .active').removeClass("active");
        if ($('#hid-upsell').length > 0) {
            $('#hid-upsell').remove();
        }            

        //enaable type ddl
        $("#i-search-type-text").attr('onclick', "FPop({ oField: this, iPop: 'i-search-type-pop' });");

        //remove all previous class begining with c-background-*
        engineContainer.removeClass(function (index, css) {
            return (css.match(/(^|\s)c-background-\S+/g) || []).join(' ');
        });

        $("#i-catch-phrase span[product]").hide();
        $("#i-catch-phrase span[product=" + type + "]").show();

        if (type === "Flight") {

            //reset history filter
            $('li[search-type]').show();

            var csearchla = document.getElementsByClassName("c-search-la")[0];
            if (csearchla) {
                csearchla.innerHTML = getT('homepage.searchform.searchflight');
            }


            volTab.classList.add("active");
            engineContainer.addClass("c-background-flight");
            if ($('#i-nav-search .unactive-dark').length < 1 && hotelTab) {
                hotelTab.classList.add("unactive-dark");
            }

            if ($('#i-nav-search .unactive-dark').length < 1 && volHotelTab) {
                volHotelTab.classList.add("unactive-dark");
            }

            if (searchHotels) searchHotels.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchTransfert) searchTransfert.style.display = "none";
            if (searchLocation) searchLocation.style.display = "none";
            if (searchVolHotel) searchVolHotel.style.display = "none";
            if (searchVols) searchVols.style.display = "block";

            if (angular.element(document.getElementById('i-search-flighthotel')).scope()) {
                angular.element(document.getElementById('i-search-flighthotel')).scope().show = false;
                angular.element(document.getElementById('i-search-flighthotel')).scope().$apply();
            }

            console.log("switchSearchFormNew: show flight hide flighthotel 2");
            if (angular.element(document.getElementById('i-search')).scope()) {
                angular.element(document.getElementById('i-search')).scope().show = true;
                angular.element(document.getElementById('i-search')).scope().$apply();
            }

        }
        else if (type === "Hotel") {
            engineContainer.addClass("c-background-hotel");
            if (hotelTab) hotelTab.classList.add("active");

            if ($('#i-nav-search .unactive-dark').length < 1 && volTab) {
                volTab.classList.add("unactive-dark");
            }

            if ($('#i-nav-search .unactive-dark').length < 1 && volHotelTab) {
                volHotelTab.classList.add("unactive-dark");
            }
            if (searchCars) searchCars.style.display = "none";
            if (searchVols) searchVols.style.display = "none";
            if (searchVolHotel) searchVolHotel.style.display = "none";
            searchHotels.style.display = "block";

        }
        if (type === "FlightHotel") {

            //filter no "round trip" history items
            $('li[search-type]').hide();
            $('li[search-type=0]').show();

            var csearchla = document.getElementsByClassName("c-search-la")[0];
            if (csearchla) {
                csearchla.innerHTML = getT('homepage.searchform.searchflightandhotel');
            }

            engineContainer.addClass("c-background-flight-hotel");
            $("#i-search-flighthotel").append('<input id="hid-upsell" type="hidden" name="upsell" value="true" />');
            //disable type ddl
            $("#i-search-flighthotel li[data-value='roundTrip']").click();

            volHotelTab.classList.add("active");

            if ($('#i-nav-search .unactive-dark').length < 1 && hotelTab) {
                hotelTab.classList.add("unactive-dark");
            }

            if ($('#i-nav-search .unactive-dark').length < 1 && volTab) {
                volTab.classList.add("unactive-dark");
            }

            if (searchHotels) searchHotels.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchTransfert) searchTransfert.style.display = "none";
            if (searchLocation) searchLocation.style.display = "none";
            if (searchVols) searchVols.style.display = "none";
            if (searchVolHotel) searchVolHotel.style.display = "block";

            console.log("switchSearchFormNew: show FlightHotel hide flight");
            if (angular.element(document.getElementById('i-search')).scope()) {
                angular.element(document.getElementById('i-search')).scope().show = false;
                angular.element(document.getElementById('i-search')).scope().$apply();
            }

            if (angular.element(document.getElementById('i-search-flighthotel')).scope()) {
                angular.element(document.getElementById('i-search-flighthotel')).scope().show = true;
                angular.element(document.getElementById('i-search-flighthotel')).scope().$apply();
            }
        }
        else if (type === "Car") {
            engineContainer.addClass("c-background-car");
            if (carTab) carTab.classList.add("active");
            if (hotelTab) hotelTab.classList.add("unactive-dark");
            if (volHotelTab) volHotelTab.classList.add("unactive-dark");
            if (transfertTab) transfertTab.classList.add("unactive-dark");
            if (searchVols) searchVols.style.display = "none";
            if (searchHotels) searchHotels.style.display = "none";
            if (searchTransfert) searchTransfert.style.display = "none";
            if (searchLocation) searchLocation.style.display = "none";
            if (searchCars) searchCars.style.display = "block";
            if (searchVolHotel) searchVolHotel.style.display = "none";
        }
        else if (type === "Transfert") {
            engineContainer.addClass("c-background-transfert");
            if (transfertTab) transfertTab.classList.add("active");
            if (carTab) carTab.classList.add("unactive-dark");
            if (hotelTab) hotelTab.classList.add("unactive-dark");
            if (volHotelTab) volHotelTab.classList.add("unactive-dark");
            if (searchVols) searchVols.style.display = "none";
            if (searchHotels) searchHotels.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchLocation) searchLocation.style.display = "none";
            if (searchTransfert) searchTransfert.style.display = "block";
            if (searchVolHotel) searchVolHotel.style.display = "none";
        }
        else if (type === "Location") {
            engineContainer.addClass("c-background-transfert");
            if (transfertTab) transfertTab.classList.add("active");
            if (carTab) carTab.classList.add("unactive-dark");
            if (hotelTab) hotelTab.classList.add("unactive-dark");
            if (volHotelTab) volHotelTab.classList.add("unactive-dark");
            if (searchVols) searchVols.style.display = "none";
            if (searchHotels) searchHotels.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchTransfert) searchTransfert.style.display = "none";
            if (searchLocation) searchLocation.style.display = "block";
            if (searchVolHotel) searchVolHotel.style.display = "none";
        }
        else if (type === "Ski") {
            engineContainer.addClass("c-background-transfert");
            if (transfertTab) transfertTab.classList.add("active");
            if (carTab) carTab.classList.add("unactive-dark");
            if (hotelTab) hotelTab.classList.add("unactive-dark");
            if (volHotelTab) volHotelTab.classList.add("unactive-dark");
            if (searchVols) searchVols.style.display = "none";
            if (searchHotels) searchHotels.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchCars) searchCars.style.display = "none";
            if (searchTransfert) searchTransfert.style.display = "none";
            if (searchLocation) searchLocation.style.display = "block";
            if (searchVolHotel) searchVolHotel.style.display = "none";
        }

        return true;
    }
}


async function switchSearchFormNew(type) {

    if (type.toLowerCase() == "") 
        type = "Flight";
    if (type.toLowerCase() == "flight") type = "Flight";
    if (type.toLowerCase() == "flighthotel") type = "FlightHotel";
    if (type.toLowerCase() == "hotel") type = "Hotel";
    if (type.toLowerCase() == "car") type = "Car";
    if (type.toLowerCase() == "transfert") type = "Transfert";
    if (type.toLowerCase() == "location") type = "Location";
    if (type.toLowerCase() == "ski") type = "Ski";
    if (type.toLowerCase() == "hotelenfrance") type = "HotelEnFrance";

    console.log("switchSearchFormNew: " + type);
    window.selectedProduct = type;

    var waitForScope = null;
    var foundScope = false;
    if (type == 'Flight') waitForScope = "i-search";
    if (type == 'FlightHotel') waitForScope = "i-search-flighthotel";
    if (waitForScope != null) {
        while (foundScope == false) {
            console.log("waitForScope: " + waitForScope);
            if (document.getElementById(waitForScope) && angular.element(document.getElementById(waitForScope)).scope()) {
                console.log("waitForScope found");
                foundScope = true;
            } else {
                console.log("waitForScope not found");
                await new Promise(r => setTimeout(r, 300));
            }
        }
    }


    if ((type == 'Flight') || (type == 'FlightHotel')) {
        if (document.getElementById('i-search')) {
            if (angular.element(document.getElementById('i-search')).scope()) {
                angular.element(document.getElementById('i-search')).scope().show = true;
                angular.element(document.getElementById('i-search')).scope().$apply();
                angular.element(document.getElementById('i-search')).show();
            }
        }
        if (document.getElementById('i-search-flighthotel')) {
            if (angular.element(document.getElementById('i-search-flighthotel')).scope()) {
                angular.element(document.getElementById('i-search-flighthotel')).scope().show = true;
                angular.element(document.getElementById('i-search-flighthotel')).scope().$apply();
                angular.element(document.getElementById('i-search-flighthotel')).show();
            }
        }
    }

    var oClickedTab = $(".c-nav-search div[product='" + type + "']");
    var oFormToDisplay = $("#" + oClickedTab.attr("data-form"));
    var aTabs = document.querySelectorAll("#i-nav-search div.c-nav-tab");
    var aSearchForms = document.querySelectorAll(".c-search-form");
    var engineContainer = $(".c-hp-search");
    if (localStorage.getItem("searchFormProduct") === null || localStorage.getItem("searchFormProduct") !== type) {
        localStorage.setItem("searchFormProduct", type);
    }

    for (var i = 0; i < aTabs.length; i++) aTabs[i].classList.remove("active");

    oClickedTab.addClass("active");
    oClickedTab.removeClass("unactive-dark");

    if (typeof oClickedTab[0] !== 'undefined') {
        engineContainer.removeClass(function (index, css) {
            return (css.match(/(^|\s)c-background-\S+/g) || []).join(' ');
        });
    }

    for (var j = 0; j < aSearchForms.length; j++) aSearchForms[j].style.display = "none";



    if (oFormToDisplay.selector == "#undefined") {
        if (type == 'Flight') { angular.element(document.getElementById('i-search')).show(); engineContainer.addClass("c-background-flight");}
        if (type == 'FlightHotel') { angular.element(document.getElementById('i-search-flighthotel')).show(); engineContainer.addClass("c-background-flight-hotel");}
    } 
    oFormToDisplay.show();



    //enable type ddl
    $("#i-search-type-text").attr('onclick', "FPop({ oField: this, iPop: 'i-search-type-pop' });");

    //remove all previous class begining with c-background-*

    
    $("#i-search").children("#hid-upsell").remove();

    $("#i-catch-phrase span[product]").hide();
    $("#i-catch-phrase span[product=" + type + "]").show();

    if (typeof oClickedTab[0] !== 'undefined') {
        //flight + hotel
        if (oClickedTab[0].id === "i-nav-volshotels") {

            //filter no "round trip" history items
            $('li[search-type]').hide();
            $('li[search-type=0]').show();

            engineContainer.addClass("c-background-flight-hotel");

            var csearchla = document.getElementsByClassName("c-search-la")[0];
            if (csearchla) {
                csearchla.innerHTML = getT('homepage.searchform.searchflightandhotel');
            }

            $("#i-search").append('<input id="hid-upsell" type="hidden" name="upsell" value="true" />');

            //disable type ddl
            $("#i-search li[data-value='roundTrip']").click();

            var adultsMin = $(".c-select-mp[data-pax='adults']").find(".c-m");
            if (adultsMin.hasClass('c-txt-vlight')) {
                var adultsPlus = $(".c-select-mp[data-pax='adults']").find(".c-p");
                adultsPlus.click();
            }
        }
        else if (oClickedTab[0].id === "i-nav-vols") {

            //reset history filter
            $('li[search-type]').show();
            if (engineContainer != null)
                engineContainer.addClass("c-background-flight");

            var csearchla = document.getElementsByClassName("c-search-la")[0];
            if (csearchla) {
                csearchla.innerHTML = getT('homepage.searchform.searchflight');
            }

            document.querySelectorAll(".c-search .c-title .c-select").forEach(function (select) {
                select.style.display = "inline-block";
            });

        }
        else if (oClickedTab[0].id === "i-nav-hotels") {

            engineContainer.addClass("c-background-hotel");
        }
        else if (oClickedTab[0].id === "i-nav-cars") {

            engineContainer.addClass("c-background-car");
        }
        else if (oClickedTab[0].id === "i-nav-transferts") {

            engineContainer.addClass("c-background-transfert");
        }
        else if (oClickedTab[0].id === "i-nav-location") {

            engineContainer.addClass("c-background-location");
        }
        else if (oClickedTab[0].id === "i-nav-ski") {

            engineContainer.addClass("c-background-ski");
        }

    }
    var isServairData = window.site.partnerId === "servair";
    if (isServairData) {
        engineContainer.addClass("c-background-Servair");
    }

    if (type == 'Flight') {
        console.log("switchSearchFormNew: show flight hide flighthotel 3");
        if (angular.element(document.getElementById('i-search')).scope()) {
            angular.element(document.getElementById('i-search')).scope().show = true;
            angular.element(document.getElementById('i-search')).scope().$apply();
            angular.element(document.getElementById('i-search')).show();
        }
        if (angular.element(document.getElementById('i-search-flighthotel')).scope()) {
            angular.element(document.getElementById('i-search-flighthotel')).scope().show = false;
            angular.element(document.getElementById('i-search-flighthotel')).scope().$apply();
            
        }

    }

    if (type == 'FlightHotel') {
        console.log("switchSearchFormNew: show FlightHotel hide flight");
        //debugger;

        const iSearch = document.getElementById('i-search');
        if (iSearch) {
            const ngISearch = angular.element(iSearch);
            if (ngISearch && ngISearch.scope()) {
                ngISearch.scope().show = false;
                ngISearch.scope().$apply();
            }
        }

        const iSearchHotel = document.getElementById('i-search-flighthotel');
        if (iSearchHotel) {
            const ngISearchHotel = angular.element(iSearchHotel);
            if (ngISearchHotel && ngISearchHotel.scope()) {
                if (ngISearchHotel.scope() != null) {
                    ngISearchHotel.scope().show = true;
                    if (ngISearchHotel.scope().onDisplay != null) {
                        ngISearchHotel.scope().onDisplay();
                    }
                    if (ngISearchHotel.scope().$apply != null) {
                        ngISearchHotel.scope().$apply();
                    }
                }
                ngISearchHotel.show();
            }
        }
    }

}
function codeAvantageClick(value) {
    document.getElementById("code-avantage").style.display = "inline-block";
    value.style.display = "none";
}
function limitText(limitField, limitNum) {
    if (limitField.value.length > limitNum) {
        limitField.value = limitField.value.substring(0, limitNum);
    }
}

function removeByClass(className) {
    var elements = document.getElementsByClassName(className);
    while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
    }
}

function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function setSearchFieldsAttr(array, length, index) {
    for (var j = 0; j < length; ++j) {

        if (array[j].getAttribute('id'))
            array[j].setAttribute('id', array[j].getAttribute('id') + '-' + index); // Required For Web       

        if (array[j].getAttribute('name'))
            array[j].setAttribute('name', array[j].getAttribute('name') + '-' + index); // Required For Web        

        if (array[j].getAttribute('data-input-name')) {
            array[j].setAttribute('data-input-name', array[j].getAttribute('data-input-name') + '-' + index); // Required For Web
            array[j].value = '';
        }
    }
}

function FswitchDest() {
    if (window.site.partnerId == "airbus") {
        var originInfo = JSON.parse(window.localStorage.getItem('origin_info'));
        var legs = parseInt($('.c-segment .c-field').length);
        var lastDestinationKey = 'destination_info';
        if (legs > 1) {
            lastDestinationKey = 'destination-' + legs + '_info';
        }
        var destinationInfo = JSON.parse(window.localStorage.getItem(lastDestinationKey));
        
        window.localStorage.setItem('origin_info', JSON.stringify(destinationInfo));
        window.localStorage.setItem(lastDestinationKey, JSON.stringify(originInfo));
    }

    oSearchOrigin = document.getElementById("i-field-where-origin");
    aSearchOrigin = oSearchOrigin.getElementsByTagName("input");
    oSearchdestination = document.getElementById("i-field-where-destination");
    aSearchdestination = oSearchdestination.getElementsByTagName("input");
    for (var i = 0; i < 2; i++) {
        temp = oSearchOrigin.children[i].value;
        oSearchOrigin.children[i].value = aSearchdestination[i].value;
        oSearchdestination.children[i].value = temp;
    }
    $('.switchDest').toggleClass('rotate');
}
function toggleSwitch() {
    switchDest = document.getElementById("switchDest");
    oOrigin = document.getElementsByName("origin");
    oDesti = document.getElementsByName("destination");
    if (oOrigin[0].value != "" && oDesti[0].value != "") {
        switchDest.classList.add("show");
    }
    else switchDest.classList.remove("show");

    if (document.getElementById("searchType-text") != null && document.getElementById("searchType-text").innerHTML == "multi-destinations")
        switchDest.classList.remove("show");
}
function searchInList(input, listId, nbDim) {
    var oInput = input;
    var filter = input.value.toUpperCase().removeAccent();
    var vnbDim = nbDim;
    var oList = document.getElementById(listId);
    var oListItem = oList.getElementsByTagName("li");
    for (var i = 0; i < oListItem.length; i++) {
        firstDim = oListItem[i].getElementsByClassName("c-first-dim")[0].textContent;
        if (vnbDim == 1) {
            if (firstDim.toUpperCase().removeAccent().indexOf(filter) > -1) {
                oListItem[i].setAttribute("style", "");
            } else {
                oListItem[i].setAttribute("style", "display:none!important");
            }
        }
        else {
            secDim = oListItem[i].getElementsByClassName("c-sec-dim")[0].textContent;
            if (firstDim.toUpperCase().removeAccent().indexOf(filter) > -1 || secDim.toUpperCase().removeAccent().indexOf(filter) > -1) {
                oListItem[i].setAttribute("style", "");
            } else {
                oListItem[i].setAttribute("style", "display:none!important");
            }
        }
    }
}
String.prototype.removeAccent = function () {
    var accent = [
        /[\300-\306]/g, /[\340-\346]/g, // A, a
        /[\310-\313]/g, /[\350-\353]/g, // E, e
        /[\314-\317]/g, /[\354-\357]/g, // I, i
        /[\322-\330]/g, /[\362-\370]/g, // O, o
        /[\331-\334]/g, /[\371-\374]/g, // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
    ];
    var noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

    var str = this;
    for (var i = 0; i < accent.length; i++) {
        str = str.replace(accent[i], noaccent[i]);
    }

    return str;
}
function marketOpe(aIn, mode) {
    var oOpener = aIn;
    if (mode == 'show') {
        oOpener.getElementsByClassName("c-more-text")[0].classList.add("c-show");
        oOpener.getElementsByClassName("c-more")[0].classList.remove("c-show");
    }
    else {
        oOpener.getElementsByClassName("c-more-text")[0].classList.remove("c-show");
        oOpener.getElementsByClassName("c-more")[0].classList.add("c-show");
    }
}

//GTM
function sendGtmEvent() {

    if (typeof dataLayer !== 'undefined' && dataLayer) {

        var lastDestinationIndex = document.getElementsByClassName('c-field-destination').length - 1;

        var origin = document.getElementById('i-where-origin').value;
        var destination = document.getElementsByClassName('c-field-destination')[lastDestinationIndex].getElementsByTagName('input')[0].value;
        var action = origin + ' - ' + destination;
        var goDate = document.getElementsByName('goDate')[0].value;
        var label = goDate.substring(6, 10) + goDate.substring(3, 5) + goDate.substring(0, 2);

        var event = {
            event: 'FlightButtonPressed',
            Category: 'Flight Search',
            Action: action,
            Label: label
        };

        console.log(JSON.stringify(event));

        dataLayer.push(event);
    }
}

function pushNeoDataLayer(stepID) {
    var counter = 0;
    pushFuncNeoDataLayer = function () {
        try {
            if (angular.element(document.body).injector().get('trackingService')) {
                angular.element(document.body).injector().get('trackingService').neoDataLayer(stepID);  
            } else {
                counter++;
                if (counter > 10) {
                    return;
                }
                setTimeout(function () {
                    requestAnimationFrame(pushFuncNeoDataLayer);
                }, 100);
            }
        }
        catch (ex) {
            console.log('erreur : ' + ex.message);
            counter++;
            if (counter > 10) {
                return;
            }
            setTimeout(function () {
                requestAnimationFrame(pushFuncNeoDataLayer);
            }, 100);
        }
    }
    requestAnimationFrame(pushFuncNeoDataLayer);
}

function pushPageViewEvent(pageType, page, args) {
    var counter = 0;
    pushFuncPageViewEvent = function () {
        try {
            if (angular.element(document.body).injector().get('trackingService')) {
                angular.element(document.body).injector().get('trackingService').pageViewEvent(pageType, page, args);
            } else {
                counter++;
                if (counter > 10) {
                    return;
                }
                setTimeout(function () {
                    requestAnimationFrame(pushFuncPageViewEvent);
                }, 100);
            }
        }
        catch (ex) {
            console.log('erreur : ' + ex.message);
            counter++;
            if (counter > 40) {
                return;
            }
            setTimeout(function () {
                requestAnimationFrame(pushFuncPageViewEvent);
            }, 100);
        }
    }
    requestAnimationFrame(pushFuncPageViewEvent);
}

function pushInteractionEvent(eventName, funnelName, funnelStep, args) {
    var counter = 0;
    pushFuncInteractionEvent = function () {
        try {
            if (angular.element(document.body).injector() && angular.element(document.body).injector().get('trackingService') && angular.element(document.body).injector().get('trackingService').interactionEvent) {
                angular.element(document.body).injector().get('trackingService').interactionEvent(eventName, funnelName, funnelStep, args);
            } else {
                counter++;
                if (counter > 10) {
                    return;
                }
                setTimeout(function () {
                    requestAnimationFrame(pushFuncInteractionEvent);
                }, 100);
            }
        }
        catch (ex) {
            console.log('erreur : ' + ex.message);
            counter++;
            if (counter > 10) {
                return;
            }
            setTimeout(function () {
                requestAnimationFrame(pushFuncInteractionEvent);
            }, 100);
        }
    }
    requestAnimationFrame(pushFuncInteractionEvent);
}


function pushGtmPage(page, title, language, fireEvent, args) {

    //Reuse the ng service so that it's easier to override in cas of different tracking platform (GTM, TC...)
    //cannot use window.load because it doesn't work on error pages
    setTimeout(function () {
        try {
            angular.element(document.body).injector().get('trackingService').pushPageData(page, title, language, true, args);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    }, 2000);

}

//function pushOmnitureEvent(pageName, prop7) {

//    if (typeof s !== 'undefined' && s != null) {

//        console.log("pageName: " + pageName);
//        console.log("prop7: " + prop7);

//        s.pageName = pageName;
//        s.prop7 = prop7;
//        s.prop2 = "Voyage";
//        if (pageName === 'HomeHotel') {
//            s.prop3 = "Hôtel";
//        }
//        else {
//            s.prop3 = "Vol";
//        }

//        s.prop24 = "1";

//        if (isTablet) {
//            s.eVar93 = 'Tablet';
//        }
//        else if (isMobile) {
//            s.eVar93 = 'SMS';
//        }
//        else {
//            s.eVar93 = 'PC';
//        }

//        s.t();  //fires tracking
//    }

//    if (typeof window.criteo_q !== 'undefined' && window.criteo_q != null) {

//        //window.criteo_q.push(
//        //    { event: "setAccount", account: 52511 },
//        //    { event: "viewHome", ui_section: "vols" }
//        //);
//    }
//}
function findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
            return array[i];
        }
    }
    return null;
}

function initSlider(advantagesContainer) {

    if (advantagesContainer != null && advantagesContainer.length > 0) {

        var advantages = advantagesContainer.find('.c-reas-asu .c-rea');
        var infos = advantagesContainer.find('.c-reas-infos ');

        if (window.innerWidth > 639) {

            setAdvantage(advantagesContainer.find('.c-reas-asu .c-rea:eq(0)'));

            advantages.bind('mouseover', function () {
                advantagesContainer.attr("paused", true);
                setAdvantage($(this));
            });

            infos.bind('mouseover', function () {
                advantagesContainer.attr("paused", true);
            });


            advantages.bind('mouseleave', function () {
                advantagesContainer.removeAttr("paused");
            });

            infos.bind('mouseleave', function () {
                advantagesContainer.removeAttr("paused");
            });

            //window.onload = auto(advantagesContainer);
            auto(advantagesContainer);
        }
        else {
            //active class needs to be removed for mobile devices
            $(".c-reas-asu .c-rea").removeClass("active");
        }

        advantagesContainer.show();
    }
}

function auto(container) {

    if (window.clearInterval != null) {
        window.clearInterval(window.sliderInterval);
    }

    window.sliderInterval = setInterval(function () {

        if (!container.is("[paused]")) {
            var i = container.find(".c-reas-asu .c-rea").index(container.find(".c-reas-asu .active"))
            if (i < 0) {
                i = 0;
            }
            var lastIndex = container.find(".c-reas-asu .c-rea").length - 1;
            var j = i < lastIndex ? 1 + i : 0;
            setAdvantage(container.find(".c-reas-asu .c-rea:eq(" + j + ")"));
        }
    }, 5000);
}

function setAdvantage(aIn) {

    aIn.siblings().removeClass("active");
    aIn.addClass("active");
    var reaContent = aIn.attr("data-content");
    var SecondImageUrl = aIn.attr("data-url");
    var SecondImageUrl = aIn.attr("data-url");
    var link = aIn.attr("href");

    $(aIn).parent().parent().find(".c-reas-infos p").html(reaContent);
    $(aIn).parent().parent().find(".c-reas-infos img").attr("src", SecondImageUrl);
    $(aIn).parent().parent().find(".c-reas-infos a").attr("href", link);
}
function targetScroll(target, way, px) {
    var oTarget = document.querySelector(target);
    way === "toBottom" ? oTarget.scrollTop += px : oTarget.scrollTop -= px;
}
function buttonSpinner(button) {
    var oButton = document.getElementById(button);
    oButton.classList.add("spin");
    var spinner = document.createElement("span");
    spinner.classList.add("spinner-cont");
    spinner.innerHTML = '<div class="preloader-wrapper active"><div class="spinner-layer"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div>';
    oButton.appendChild(spinner);
}

function buttonRemoveSpinner(button) {
    var oButton = document.getElementById(button);
    oButton.classList.remove("spin");
    oButton.removeChild(oButton.children[0]);
}
function selfToggleClass(aIn, theClass) {
    aIn.classList.contains(theClass) ? aIn.classList.remove(theClass) : aIn.classList.add(theClass);
}


function XLFormValidVolHotelSearch(oObj) {

    var parent = document.getElementById(oObj)[0];
    console.log("Hello :!!!!!");
    console.log(parent);
    console.log("vSearchType :!!!!!");
    var vSearchType = parent.getElementsByName('searchType')[0].value;
    console.log(vSearchType);

    if (vSearchType == 'roundTrip' || vSearchType == 'oneWay' || vSearchType == 'openJaw') {

        if (parent.getElementById('i-where-origin2').value == '') {

            aVS = new Array();
            aVS['oObj'] = document.getElementById('i-where-origin2');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        if (parent.getElementsByName('origin')[0].value == '')
            parent.getElementsByName('origin')[0].value = parent.getElementById('i-where-origin2').value;

        if (parent.getElementById('i-where-destination2').value == '') {

            aVS = new Array();
            aVS['oObj'] = parent.getElementById('i-where-destination2');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        if (parent.getElementsByName('destination')[0].value == '')
            parent.getElementsByName('destination')[0].value = parent.getElementById('i-where-destination2').value;

        if (parent.getElementById('i-where-origin').value == parent.getElementById('i-where-destination2').value) {

            aVS = new Array();
            aVS['oObj'] = parent.getElementById('i-where-destination2');
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.choosecityaeroport2');
            XLFormValidStyle(aVS);
            return false;

        }

        var vGoDate = parent.getElementsByName('goDate')[0].value;

        if (vGoDate == '') {

            aVS = new Array();
            aVS['oObj'] = parent.getElementsByName('goDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

    }


    if (vSearchType == 'roundTrip') {

        var vReturnDate = parent.getElementsByName('returnDate')[0].value;

        if (vReturnDate == '') {

            aVS = new Array();
            aVS['oObj'] = parent.getElementsByName('returnDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.pleasecompletethisfield');
            XLFormValidStyle(aVS);
            return false;

        }

        vDateComp = XLDateComp({ vDate: vGoDate, vDateComp: vReturnDate });
        if (vDateComp == 'sup') {

            aVS = new Array();
            aVS['oObj'] = parent.getElementsByName('returnDate')[0];
            aVS['vError'] = true;
            aVS['vErrorCode'] = '';
            aVS['vErrorCustom'] = getT('airbooking.dateafterdeparture');
            XLFormValidStyle(aVS);
            return false;

        }

    }


    parent.getElementById('i-search').submit();
}



// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" est nul ou non défini');
            }

            // 1. Soit o égal à ? Object(cette valeur).
            var o = Object(this);

            // 2. Soit len égal à ? Length(? Get(o, "length")).
            var len = o.length >>> 0;

            // 3. Si len = 0, renvoyer "false".
            if (len === 0) {
                return false;
            }

            // 4. Soit n = ? ToInteger(fromIndex).
            // Pour la cohérence du code, on gardera le nom anglais "fromIndex" pour la variable auparavant appelée "indiceDépart"
            //    (Si fromIndex n'est pas défini, cette étape produit la valeur 0.)
            var n = fromIndex | 0;

            // 5. Si n ≥ 0,
            //  a. Alors k = n.
            // 6. Sinon, si n < 0,
            //  a. Alors k = len + n.
            //  b. Si k < 0, alors k = 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Répéter tant que k < len
            while (k < len) {
                // a. Soit elementK le résultat de ? Get(O, ! ToString(k)).
                // b. Si SameValueZero(searchElement, elementK) est vrai, renvoyer "true".
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                // c. Augmenter la valeur de k de 1. 
                k++;
            }

            // 8. Renvoyer "false"
            return false;
        }
    });
}

if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

function openIdilizAccordingDevice(url, deviceOs) {
 
    //but keep theses lines if change again
    if (deviceOs == null || !deviceOs.length) {
        deviceOs = getDeviceOs();
    }
    switch (deviceOs) {

        case "android":
            var installedApps = [];
            if (navigator.getInstalledRelatedApps != null) {
                installedApps = navigator.getInstalledRelatedApps();
            }
            if (installedApps && installedApps.length) {
                if (installedApps.indexOf("com.idiliz.app") > -1) {
                    window.location = "com.idiliz.app";
                    return;
                }
            };
            window.open(url);
            //window.open("https://play.google.com/store/apps/details?id=com.idiliz.app&hl=ln&gl=US&pli=1");
            break;

        case "ios":
            var appInstalled = false;
            var appLink = "idiliz://";

            // Détecter si l'app a été ouverte (la page passe en arrière-plan)
            window.addEventListener("pagehide", function () {
                appInstalled = true;
            });
            window.addEventListener("visibilitychange", function () {
                if (document.hidden) appInstalled = true;
            });

            // Utiliser un iframe caché pour éviter le dialog d'erreur natif de Safari
            // (window.location.href avec un scheme inconnu affiche une alerte non catchable)
            FLoading({vAction: 'showNow'});
            try {
                var iframe = document.createElement('iframe');
                iframe.style.cssText = 'display:none;width:0;height:0;border:none;';
                iframe.src = appLink;
                document.body.appendChild(iframe);

                setTimeout(function () {
                    try {
                        document.body.removeChild(iframe);
                        if (!appInstalled) {
                            window.location.href = url;
                            setTimeout(function () { FLoading({vAction: 'hide'}); }, 2000);
                        } else {
                            FLoading({vAction: 'hide'});
                        }
                    } catch (e) {
                        FLoading({vAction: 'hide'});
                    }
                }, 2000);
            } catch (e) {
                FLoading({vAction: 'hide'});
            }
            break;


        default:
            window.open(url);
            break;
    }

}

function getDeviceOs() {
    var uap = navigator.userAgent.toLowerCase() + " " + navigator.platform.toLowerCase();
    if (uap.indexOf("android") > -1) {
        return "android";
    }
    else if (uap.indexOf("ipad") > -1 || uap.indexOf("iphone") > -1 || uap.indexOf("ipod") > -1) {
        return "ios";
    }
    return "other";
}

function getAmountFromMargin(total, rate) {
    //simple
    const amountFromMarginA = Math.ceil(total * rate) / 100;

    //complex
    var margin = (100 / (100 - rate) * total) - total;
    const amountFromMarginB = Math.ceil(margin * 100) / 100;

    console.log("getAmountFromMargin total: " + total + " rate: " + rate + " A: " + amountFromMarginA + " B: " + amountFromMarginB);
    return amountFromMarginB;
}

function getRoundedValue(value, decimalCount = 2) {
    value = parseFloat(value);
    let factor = Math.pow(10, decimalCount); 
    const result = Math.round(value * factor) / factor
    console.log("getRoundedValue value: " + value + " decimalCount: " + decimalCount);
    return result;
}

// Apply Linear Backoff to call the tracking service
function callTrackingFunction(stepID, data) {
    var counter = 0;
    pushFuncTracking = function () {
        try {
            if (window.site.partnerId.startsWith("veepee") || window.site.partnerId == "dp-veepee") {
                if (angular.element(document.body).injector().get('trackingService')) {
                    angular.element(document.body).injector().get('trackingService').handleTrackingStep(stepID, data);
                } else {
                    counter++;
                    if (counter > 10) {
                        return;
                    }
                    setTimeout(function () {
                        requestAnimationFrame(pushFuncTracking);
                    }, 100);
                }
            }
        }
        catch (ex) {
            console.log('erreur : ' + ex.message);
            counter++;
            if (counter > 10) {
                return;
            }
            setTimeout(function () {
                requestAnimationFrame(pushFuncTracking);
            }, 100);
        }
    }

    requestAnimationFrame(pushFuncTracking);
}

document.addEventListener('onSearchBtnClick', function () {
    callTrackingFunction("click_complete_search")
});

function updateValuesRecursively(obj, transformFn, parentKey = "") {
    if(!obj || typeof obj !== 'object')
        return;

    for (let key in obj) {
        const fullKey = parentKey ? `${parentKey}.${key}` : key;

        if (typeof obj[key] === 'object' && obj[key] !== null) {
            updateValuesRecursively(obj[key], transformFn, fullKey);
        } else if (typeof obj[key] === 'string') {
            transformFn(obj, key, fullKey);
        }
    }
}

async function getUrlJson(url) {
    const response = await fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            //"Authorization": "bearer " + data._bearer.token,
            "Content-Type": 'application/json'
            //"Content-Type": "application/x-www-form-urlencoded",
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        //body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
}